export type Language = "de" | "en" | "pt";

export const translations = {
  de: {
    trustVideos: {"title": "Echte Menschen. Echte Routinen.", "subtitle": "Founding Members und unser Gründer erzählen, wie H2Humans in ihren Alltag passt.", "thanksTitle": "So sieht die Routine im Alltag aus.", "strip": "Founding Members erzählen ihre Routine*", "play": "Video von {name} abspielen", "close": "Video schließen", "prev": "Vorheriges Video", "next": "Nächstes Video", "setCta": "Zum Komplett-Set", "shopCta": "Zum Shop", "bodyCta": "Daily Body-Care ansehen", "advertising": "Werbung · Founding Member, erhält eine Provision", "videoName": "H2Humans Trust Card – {name}", "people": {"sandra": {"name": "Sandra", "role": "Founding Member · Kraftsport & Alltag", "quote": "Ich rühr mir täglich einen Shake an – nicht süß, leichte Kakaonote.", "sourceRole": "Founding Member"}, "nicole": {"name": "Nicole", "role": "Founding Member · HYROX-Vorbereitung", "quote": "Meine Routine startet jeden Morgen mit der Daily Balance.", "sourceRole": "Founding Member"}, "patrick": {"name": "Patrick", "role": "Gründer & CEO, H2Humans", "quote": "Von Mensch zu Mensch: Wir bauen das System für die Zeit danach.", "sourceRole": "Gründer & CEO"}, "angelika": {"name": "Angelika", "role": "Founding Member · HYROX-Athletin", "quote": "Die sind bei mir in der Sporttasche drin – perfekt für unterwegs.", "sourceRole": "Founding Member"}}, "quoteOpen": "„", "quoteClose": "“", "source": "— {name}, {role}", "footnote": "* Werbung: Founding Members sind Kooperationspartner:innen von H2HUMANS und erhalten eine Provision. Mehr unter", "legalLink": "Rechtliche Hinweise", "modalAdvertising": "* Werbung · Founding Member mit Provision", "cooperationTitle": "Kooperationen mit Founding Members.", "cooperationText": "Auf unserer Website, in unseren Social-Media-Kanälen und in Anzeigen zeigen wir Erfahrungsberichte von Founding Members. Founding Members sind Kooperationspartner:innen von H2HUMANS. Sie erhalten die Produkte teilweise kostenfrei und eine Provision auf Bestellungen, die über ihren persönlichen Link oder Code erfolgen. Die Inhalte geben die persönliche Meinung und Erfahrung der jeweiligen Person wieder. Patrick ist Gründer und CEO von H2HUMANS.", "carouselSubtitle": "Echte Menschen. Echte Routinen. Ungefiltert.", "hydrationCta": "Daily Hydration ansehen", "dot": "Zu Video {n} von {total}"},
    legalNotice: {"title": "Impressum.", "metaTitle": "Impressum | H2HUMANS", "description": "Rechtliche Angaben zu H2HUMANS, betrieben von Cosmic Gap, Lda in Lissabon, Portugal.", "back": "Zurück zur Startseite", "company": "Cosmic Gap, Lda.", "address": "Avenida da Liberdade 230, 2 Floor, Andar 1250-148", "city": "Lissabon, Portugal", "emailLabel": "E-Mail", "email": "info@h2humans.com", "phoneLabel": "Telefon", "phone": "+351 910 734 628", "management": "Geschäftsführung.", "manager": "Patrick Eichiner", "registration": "Firmennummer.", "registrationValue": "NIPC: 519218299", "tax": "Steuernummer.", "taxValue": "Umsatzsteuer-Identifikationsnummer: PT519218299", "disputeTitle": "Streitbeilegung.", "disputeIntro": "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:", "disputeText": "Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht teil und sind dazu auch nicht verpflichtet."},
    productHeroAlts: {"bundle": "Daily Routine Komplett-Set: Daily Hydration, Daily Body-Care und Daily Balance – Daily Balance gratis", "body-care": "Daily Body-Care Proteinpulver mit Kakao-Geschmack, 1000 g – 22,4 g Eiweiß pro Portion", "hydration": "Daily Hydration Elektrolyte mit Zitrus-Geschmack, 30 Sticks", "balance": "Daily Balance Vitamine und Mineralstoffe, 30 Kapseln – 1 Kapsel pro Tag"},
    productReviews: {"summary": "{avg} von 5 · {count} Bewertungen", "title": "Bewertungen.", "verified": "Verifizierter Kauf", "incentivized": "Bewertung nach Gutschein-Anreiz", "note": "Alle Bewertungen stammen von verifizierten Käufer:innen. Wir prüfen, ob Bewertungen von Personen stammen, die das Produkt gekauft haben.", "stars": "{n} von 5 Sternen", "perCapsule": "{price} / Kapsel", "formTitle": "Deine Bewertung.", "formIntro": "Danke für deinen Kauf. Wie gefällt dir {product}?", "formRating": "Sterne", "formText": "Deine Erfahrung", "formName": "Vorname", "formSubmit": "Bewertung senden", "formSending": "Wird gesendet …", "formThanks": "Danke! Deine Bewertung wird geprüft und dann veröffentlicht.", "formUsed": "Für diesen Link wurde bereits eine Bewertung abgegeben.", "formInvalid": "Dieser Bewertungslink ist ungültig.", "formError": "Das hat nicht geklappt. Bitte versuche es erneut.", "formRequired": "Bitte Sterne, Text und Vorname angeben.", "metaTitle": "Bewertung abgeben | H2HUMANS", "metaDesc": "Bewerte dein H2HUMANS Produkt über deinen persönlichen Link.", "adminTitle": "Bewertungen moderieren.", "adminHint": "Ablehnen nur bei Spam oder Rechtsverstoß, nicht wegen einer schlechten Bewertung.", "adminApprove": "Freigeben", "adminReject": "Ablehnen", "adminEmpty": "Keine Bewertungen in dieser Ansicht.", "adminForbidden": "Kein Zugriff. Dein Konto hat keine Admin-Rolle.", "statusPending": "Offen", "statusApproved": "Freigegeben", "statusRejected": "Abgelehnt", "adminReviewsLink": "Bewertungen", "videosTitle": "Stimmen im Video."},
    shippingUnits: {"daysNom": "{min}–{max} Werktage", "daysDat": "{min}–{max} Werktagen", "countryNotice": "Wir liefern aktuell nur innerhalb Deutschlands."},
    shop: {
      navLabel: "Shop",
      promoMessages: {
        label: "Aktuelle Angebote",
        freeShipping: "Kostenloser Versand ab {amount}",
        app: "Neu: H2Humans App kostenlos testen",
        freeShippingShort: "Kostenloser Versand ab {amount}",
        appShort: "Neu: H2Humans App kostenlos testen",
        startOffer: "Startangebot: Komplett-Set 24,80 € günstiger · Daily Balance gratis · Versand ab {amount} frei",
        startOfferShort: "Komplett-Set 24,80 € günstiger · Balance gratis",
      },
      order: {"title": "Deine Bestellung.", "continueToPayment": "Weiter zur Zahlung", "continueShopping": "Weiter einkaufen", "summaryTitle": "Bestellübersicht", "stripeHint": "Mit dem Bezahl-Button unten bestellst du zahlungspflichtig.", "empty": "Dein Warenkorb ist leer.", "toShop": "Zum Shop", "back": "Zurück", "seoTitle": "Bestellung | H2HUMANS", "seoDesc": "Deine Bestellung bei H2HUMANS prüfen und sicher bezahlen.", "legalTerms": "Mit deiner Bestellung gelten unsere {terms}.", "legalTermsLink": "Kaufbedingungen", "legalWithdrawal": "Informationen zu deinem Widerrufsrecht findest du in der {withdrawal}.", "legalWithdrawalLink": "Widerrufsbelehrung", "legalDelivery": "Lieferung in {timeDat} innerhalb Deutschlands.", "legalDeliveryShort": "Lieferung in {timeDat}.", "newTab": "(öffnet in neuem Tab)"},
      upgrade: {"title": "Mach's komplett", "saved": "Daily Balance gratis · {amount} gespart", "extra": "Nur {amount} mehr für {products}", "cta": "Auf Set upgraden", "decline": "Nein danke, nur {product}", "yourChoice": "Deine Wahl", "recommended": "Empfohlen", "close": "Schließen", "andWord": " + "},
      miniCart: {
        shipping: "Versand",
        shippingFreeValue: "kostenlos",
        total: "Gesamt",
        vatNote: "inkl. MwSt.",
        deliveryLine: "Lieferung in {timeDat} · Versand aus Deutschland",
        swapSet: "Gegen Set tauschen",
        swapSetText: "Mit dem Set bekommst du Daily Balance gratis und sparst {amount}.",
        reachesFree: "Damit ist dein Versand kostenlos",
        title: "Dein Warenkorb",
        itemCount: "{count} Artikel",
        shippingRemaining: "Noch {amount} bis zum kostenlosen Versand",
        codeActive: "Code {code} ist aktiv",
        tierActive: "Mengenrabatt −{pct} %",
        codeLineActive: "Code {code} −{pct} %",
        tierLabel: "Mengenrabatt",
        shippingRemainingOrSet: "Noch {amount} bis zum kostenlosen Versand. Oder hol dir das Set (immer versandkostenfrei)",
        shippingFree: "Dein Versand ist kostenlos ✓",
        crossSellTitle: "Passt dazu",
        add: "Hinzufügen",
        promoHint: "Promo Code im nächsten Schritt eingeben",
        subtotal: "Zwischensumme",
        checkout: "Zur Kasse",
        trust: "Sicher bezahlen · Versand aus Deutschland",
        empty: "Dein Warenkorb ist leer",
        toShop: "Zum Shop",
        close: "Warenkorb schließen",
        open: "Warenkorb öffnen",
        decrease: "Menge verringern",
        increase: "Menge erhöhen",
        remove: "Entfernen",
        quantity: "Menge",
      },
      title: "Alle Produkte.",
      subtitle: "Das H2HUMANS Supplement-Konzept im Überblick.",
      metaTitle: "Shop | H2HUMANS",
      metaDescription: "Alle H2HUMANS Produkte im Überblick.",
      viewProduct: "Zum Produkt",
      cart: "Warenkorb",
      backToShop: "Zurück zum Shop",
      productMetaTitleSuffix: " | H2HUMANS",
      productMetaDescriptionFallback: "Produktbeschreibung folgt.",
      priceNote: "Preis inkl. MwSt., zzgl. Versand.",
      pdp: {"tbd": "[TEXT FOLGT]", "unitPrice": "Grundpreis: {price} / kg", "unitPriceMissing": "Grundpreis: [TEXT FOLGT]", "gallery": "Produktbilder", "galleryAlts": {"set-1-routine": "3-Schritte-Methode: morgens Daily Balance, tagsüber Daily Hydration, nachmittags Daily Body-Care. 2 Minuten am Tag.", "set-2-preis": "Einzelkomponenten ca. 173 € für 30 Tage vs. Komplett-Set ab 84,90 € pro Monat im 3-Monats-Paket. Daily Balance gratis, versandkostenfrei.", "bodycare-1-inhalt": "Daily Body-Care pro Portion: 22,4 g Eiweiß, 3.000 mg Kreatin, 3.000 mg Kollagen, Vitamin B6 und B12, mit Bio-Molkeneiweiß, 0 g zugesetzter Zucker.", "bodycare-2-vergleich": "Vergleich Daily Body-Care mit normalem Proteinshake.", "hydration-1-inhalt": "Daily Hydration pro Stick: 810 mg Natrium, 300 mg Kalium, 100 mg Magnesium, kein zugesetzter Zucker, 30 Sticks.", "hydration-2-vergleich": "Vergleich Daily Hydration mit fertigem Sportdrink.", "balance-1-inhalt": "Daily Balance: 22 Vitamine und Mineralstoffe in 1 Kapsel, u. a. Vitamin D3, B12, Folsäure, Selen, Zink, Magnesium.", "balance-2-basis": "Daily Balance: Nährstoffe für Energie, Immunsystem, weniger Müdigkeit, Haare, Knochen und Muskeln sowie Zellschutz.", "nutrition-body-care": "Nährwerte und Inhaltsstoffe von Daily Body-Care", "nutrition-hydration": "Nährwerte und Inhaltsstoffe von Daily Hydration", "nutrition-balance": "Nährwerte und Inhaltsstoffe von Daily Balance"}, "slide": "Bild {n} von {total}", "placeholderNutrition": "Nährwertbild folgt", "placeholderLifestyle": "Lifestyle-Bild folgt", "reviews": "{count} Bewertungen", "purchaseOptions": "Kaufoption", "oneTime": "Einmalkauf", "subscribe": "Abonnieren & sparen", "subscriptionPreview": "Abo / Subscription", "comingSoon": "Coming soon", "tiers": "Packungen", "save": "Spare {amount}", "quantity": "Menge", "addToCart": "In den Warenkorb · {price}", "addShort": "In den Warenkorb", "delivery": "Lieferung in {timeDat}", "trust": ["Im Labor getestet", "GMP certified", "Hergestellt in DE/AT", "Non-GMO"], "accIngredients": "Inhaltsstoffe", "accUsage": "Anwendung", "accShipping": "Versand & Rückgabe", "shippingText": "Wir versenden aus Deutschland. Die Lieferzeit beträgt {time}. Der Versand kostet {cost}. Ab {amount} Warenwert (nach Rabatten) liefern wir kostenlos. Das Komplett-Set ist immer versandkostenfrei. Details zum Widerrufsrecht findest du in der Widerrufsbelehrung.", "shippingLink": "Versandinformationen", "withdrawalLink": "Widerrufsbelehrung", "termsLink": "AGB", "upsellTitle": "Alles im Daily Routine Komplett-Set", "upsellSave": "du sparst {amount}", "upsellCta": "Zum Komplett-Set", "phaseTitle": "So passt es in deine", "phaseTitleEm": "Phase.", "phases": ["Vor der Spritze", "Mit der Spritze", "Nach der Spritze"], "ingredientsTitle": "Inhaltsstoffe im", "ingredientsTitleEm": "Detail.", "perServing": "pro Tagesportion", "compareTitle": "H2Humans vs.", "compareTitleEm": "Einzelkauf.", "compareCols": ["", "H2Humans", "Einzelne Supplements"], "compareRows": ["Anzahl Produkte", "Preis pro Monat", "Abgestimmt auf GLP-1-Phasen", "App-Begleitung"], "compareProducts": "1 System (3 Produkte)", "compareYes": "Ja", "compareApp": "Ja, kostenlos testen", "usageTitle": "Anwendung in", "usageTitleEm": "3 Schritten.", "usageSteps": ["Portion abmessen", "Mit Flüssigkeit einnehmen", "Täglich in die Routine einbauen"], "faqTitle": "Häufige", "faqTitleEm": "Fragen.", "appUpsellTitle": "Dein System. Dein ", "appUpsellTitleEm": "+1.", "crossTitle": "Dein System", "crossTitleEm": "ergänzen.", "bundleContents": "Im System enthalten", "reviewsTitle": "Bewertungen", "pkgLegend": "Paket wählen", "pkgMonth1": "1 Monat", "pkgMonths": "{n} Monate", "pkgInstead": "statt {price}", "pkgPerDay": "nur {price} pro Tag", "pkgPerSet": "{price} pro Set", "pkgSaved": "{amount} gespart", "pkgPopular": "Beliebteste Wahl", "pkgBest": "Bester Preis", "pkgGuideFree": "Gratis dazu: Dein 30-Tage-Routine-Guide", "pkgFreeBalance": "Daily Balance in jedem Set GRATIS (Wert {price})", "free": "GRATIS", "setContentsTitle": "Inhalt je Set", "promoExcluded": "Rabattcodes gelten nicht für das bereits rabattierte Komplett-Set.", "setShippingFree": "Versandkostenfrei", "tplSetEyebrow": "Daily Routine Komplett-Set · 3-Schritte-Methode™", "tplSetH1": ["Drei Produkte. 2\u00a0Minuten am Tag.", "Für deinen Alltag mit der Abnehmspritze."], "tplSetSeoTitle": "Daily Routine Komplett-Set für den Alltag mit der Abnehmspritze | H2Humans", "tplSetSeoDesc": "Drei Produkte, eine Routine, 2 Minuten am Tag: Protein, Elektrolyte und Mikronährstoffe für deinen Alltag mit der Abnehmspritze. Daily Balance gratis, versandkostenfrei, 30-Tage-Routine-Garantie.", "tplSetSubline": "Protein, Elektrolyte und Mikronährstoffe in einem abgestimmten System. Ohne Dosen-Chaos und ohne stundenlange Recherche. Gedacht für Tage, an denen die Mahlzeiten kleiner ausfallen.", "tplSetBullets": [["Protein kann zur Erhaltung von Muskelmasse beitragen", "1", ". Auch an Tagen mit kleineren Mahlzeiten."], ["Kreatin kann zu einer erhöhten körperlichen Leistung bei Schnellkrafttraining beitragen", "2", ""], ["Magnesium und Vitamin B12 können zur Verringerung von Müdigkeit und Ermüdung beitragen", "3", ""], ["Ein Plan statt fünf Dosen: morgens, tagsüber, nachmittags und das gute Gefühl, an alles gedacht zu haben", "", ""], ["Schmeckt: Kakao-Shake und Zitrus-Drink", "", ""]], "jumpNavLabel": "Auf dieser Seite", "jumpNav": ["Vorteile", "So funktioniert's", "Stimmen", "FAQ"], "guaranteeBadge": "30-Tage-Routine-Garantie: risikofrei testen", "deliveryLineSet": "Lieferung in {timeDat} · Versand aus Deutschland · versandkostenfrei", "balanceFreeShort": "Daily Balance gratis", "footnotesLabel": "Fußnoten", "jumpGuarantee": "Garantie", "priceNoteSet": "Preis inkl. MwSt. · versandkostenfrei", "priceNoteSinglePrefix": "inkl. MwSt., zzgl.", "priceNoteShippingLink": "Versand", "paymentMethodsLabel": "Verfügbare Zahlarten", "guaranteeTitle": "Probier's 30 Tage. Passt es nicht in deinen Alltag, bekommst du dein Geld zurück.", "guaranteeSteps": ["Bestellen", "30 Tage testen", "Formlose Mail an info@h2humans.com mit Bestellnummer"], "guaranteeNoReturn": "Angebrochene Packung? Musst du nicht zurückschicken.", "guaranteeTermsLink": "Alle Bedingungen", "footnotes": ["¹ Protein kann zur Erhaltung von Muskelmasse beitragen.", "² Kreatin kann zu einer erhöhten körperlichen Leistung bei Schnellkrafttraining im Rahmen kurzzeitiger intensiver körperlicher Betätigung beitragen. Für diese Angabe ist eine tägliche Aufnahme von 3 g Kreatin Voraussetzung; die Angabe richtet sich an Erwachsene, die intensiver körperlicher Betätigung nachgehen.", "³ Magnesium und Vitamin B12 können zur Verringerung von Müdigkeit und Ermüdung beitragen.", "Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche und ausgewogene Ernährung und eine gesunde Lebensweise."], "gpNav": "Garantie", "gpSeoTitle": "30-Tage-Routine-Garantie | H2HUMANS", "gpSeoDesc": "Teste deine erste Bestellung 30 Tage lang. Passt sie nicht in deinen Alltag, erstatten wir dir den Kaufpreis.", "gpBack": "Zurück zur Startseite", "gpTitle": "30-Tage-Routine-Garantie.", "gpIntro": "Teste deine erste Bestellung 30 Tage lang ab Lieferung. Wenn sie nicht in deinen Alltag passt, erstatten wir dir den Kaufpreis.", "gpHowTitle": "So geht's.", "gpHow": "Schreib uns innerhalb von 30 Tagen nach Lieferung an info@h2humans.com mit deiner Bestellnummer. Wir erstatten innerhalb von 14 Tagen auf dein ursprüngliches Zahlungsmittel.", "gpCondTitle": "Bedingungen.", "gpConditions": ["Gilt für deine erste Bestellung, einmal pro Kundin bzw. Kunde.", "Eine angebrochene Packung je Produkt bzw. ein angebrochenes Set erstatten wir voll, ohne Rücksendung.", "Bei Vorratspaketen (2 oder 3 Sets) sendest du die weiteren Sets ungeöffnet zurück; die Rücksendekosten trägst du.", "Die Garantie ist eine freiwillige Leistung und lässt deine gesetzlichen Rechte (Widerruf, Gewährleistung) unberührt."], "tplSetFaq": [["Ich esse kaum noch. Wie passt das in meinen Tag?", "Ganz einfach: Der Shake ist in 30 Sekunden angerührt, der Stick kommt in deine Trinkflasche, dazu eine Kapsel. Du musst dafür keinen Hunger haben."], ["Wann nehme ich es an Tagen mit wenig Appetit?", "Dann, wenn es sich für dich gut anfühlt. Den Shake kannst du gern in kleinen Schlucken trinken oder mit mehr Flüssigkeit anrühren."], ["Ich ernähre mich schon gut. Brauche ich das?", "Das Set ist eine Ergänzung für Tage mit kleinen Portionen. Es ist kein Ersatz für eine abwechslungsreiche und ausgewogene Ernährung."], ["Ist das ein Mahlzeitenersatz?", "Nein. Das Set ist eine Ergänzung zu deinen Mahlzeiten."], ["Wie schmeckt es?", "Daily Body-Care ist ein Kakao-Shake, Daily Hydration ein Zitrus-Drink, beide ohne zugesetzten Zucker."], ["Wie lange reicht ein Set?", "Ein Set reicht für 30 Tage."], ["Welches Paket passt zu mir?", "1 Monat ist ideal zum Kennenlernen. 2 oder 3 Monate passen für eine feste Routine, mit dem besten Preis pro Set."], ["Wie funktioniert die Garantie?", "In 3 Schritten: bestellen, 30 Tage testen, formlose Mail an info@h2humans.com mit deiner Bestellnummer.", "/garantie"], ["Gelten Rabattcodes für das Set?", "Nein, das Set ist bereits rabattiert."]], "pkgPiece1": "1 Stück", "pkgPieces": "{n} Stück", "pkgPctSaved": "{pct} % gespart", "pkgPerPiece": "{price} pro Stück", "pkgPopularShort": "Beliebt", "pkgListPrice": "Normalpreis", "priceNotePdpPrefix": "Preis inkl. MwSt., zzgl.", "priceNoteFreeFrom": "gratis ab {amount}", "setBoxText": "Im Daily Routine Komplett-Set sparst du ab {amount}: Daily Balance gratis dabei", "balanceInSet": "Im Komplett-Set ist Daily Balance gratis dabei.", "tilesLabel": "Auf einen Blick", "tplBodyEyebrow": "Multi-Formel · Schritt 3 der Daily Routine", "tplBodyH1": "Dein Protein-Shake für Tage mit wenig Appetit. In 30 Sekunden fertig.", "tplBodySubline": "22,4 g Eiweiß, 3 g Kreatin und 3 g Kollagen in einem Shake. Kakao-Geschmack, ohne zugesetzten Zucker.", "tplBodyBullets": [["Protein kann zur Erhaltung von Muskelmasse beitragen", "1", ""], ["Kreatin kann zu einer erhöhten körperlichen Leistung bei Schnellkrafttraining beitragen", "2", ""], ["Vitamin B6 und B12 können zu einem normalen Energiestoffwechsel beitragen", "3", ""], ["Sieben Inhaltsstoffe in einem Shake statt sieben Dosen und das gute Gefühl, an alles gedacht zu haben", "", ""], ["Schmeckt nach Kakao: 1 Messlöffel, Flüssigkeit, schütteln", "", ""]], "tplBodyTiles": ["22,4 g Eiweiß", "3.000 mg Kreatin", "3.000 mg Kollagen", "30 Portionen"], "tplBodyFaq": [["Wie bereite ich den Shake zu?", "1 Messlöffel (35 g) in 300 ml Wasser oder Milch geben, schütteln, fertig."], ["Ist das ein Mahlzeitenersatz?", "Nein. Daily Body-Care ist eine Ergänzung zu deinen Mahlzeiten."], ["Wie schmeckt es?", "Nach Kakao, ohne zugesetzten Zucker."], ["Welche Allergene sind enthalten?", "Milch (Molkeneiweiß, laut Zutatenliste). Die vollständige Zutatenliste findest du oben unter „Inhaltsstoffe“."], ["Wie lange reicht eine Dose?", "Eine Dose enthält 30 Portionen, bei 1 Portion täglich reicht sie 30 Tage."], ["Gibt es Mengenrabatt oder Codes?", "Ja: Ab 2 Stück sparst du 5 %, ab 3 Stück 10 %. Mengenrabatt und Rabattcodes sind nicht kombinierbar. Pro Produkt gilt automatisch der höhere Rabatt."], ["Wie funktioniert die Garantie?", "In 3 Schritten: bestellen, 30 Tage testen, formlose Mail an info@h2humans.com mit deiner Bestellnummer.", "/garantie"]], "tplBodyFootnotes": ["¹ Protein kann zur Erhaltung von Muskelmasse beitragen.", "² Kreatin kann zu einer erhöhten körperlichen Leistung bei Schnellkrafttraining im Rahmen kurzzeitiger intensiver körperlicher Betätigung beitragen. Für diese Angabe ist eine tägliche Aufnahme von 3 g Kreatin Voraussetzung; die Angabe richtet sich an Erwachsene, die intensiver körperlicher Betätigung nachgehen.", "³ Vitamin B6 und Vitamin B12 können zu einem normalen Energiestoffwechsel beitragen.", "Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche und ausgewogene Ernährung und eine gesunde Lebensweise."], "tplHydEyebrow": "Elektrolyt-Formel · Schritt 2 der Daily Routine", "tplHydH1": "Trinken, das du nicht vergisst. Ein Stick, eine Flasche, fertig.", "tplHydSubline": "Natrium, Kalium und Magnesium in einem Stick. Zitrus-Geschmack, ohne zugesetzten Zucker, 30 Sticks für 30 Tage.", "tplHydBullets": [["Magnesium kann zum Elektrolytgleichgewicht beitragen", "1", ""], ["Kalium und Magnesium können zu einer normalen Muskelfunktion beitragen", "2", ""], ["Stick in die Flasche: unterwegs, im Büro, beim Training", "", ""], ["Zitrus statt süß: kein zugesetzter Zucker und das gute Gefühl, an alles gedacht zu haben", "", ""], ["30 Sticks = 30 Tage, ohne Abmessen", "", ""]], "tplHydTiles": ["810 mg Natrium", "300 mg Kalium", "100 mg Magnesium", "30 Sticks"], "tplHydFaq": [["Wie viel Wasser pro Stick?", "1 Stick in 500 ml Wasser auflösen."], ["Wann trinke ich es am besten?", "Wann es für dich passt, zum Beispiel morgens, unterwegs oder beim Training. 1 Stick pro Tag."], ["Wie schmeckt es?", "Nach Zitrus: frisch statt süß."], ["Enthält es Zucker oder Süßstoff?", "Es ist kein Zucker zugesetzt. Laut Zutatenliste ist es mit Steviolglykosiden aus Stevia gesüßt."], ["Kann ich mehr als einen Stick nehmen?", "Bitte halte dich an die empfohlene Tagesmenge von 1 Stick. Sie sollte nicht überschritten werden."], ["Gibt es Mengenrabatt oder Codes?", "Ja: Ab 2 Stück sparst du 5 %, ab 3 Stück 10 %. Mengenrabatt und Rabattcodes sind nicht kombinierbar. Pro Produkt gilt automatisch der höhere Rabatt."], ["Wie funktioniert die Garantie?", "In 3 Schritten: bestellen, 30 Tage testen, formlose Mail an info@h2humans.com mit deiner Bestellnummer.", "/garantie"]], "tplHydFootnotes": ["¹ Magnesium kann zum Elektrolytgleichgewicht beitragen.", "² Kalium und Magnesium können zu einer normalen Muskelfunktion beitragen.", "Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche und ausgewogene Ernährung und eine gesunde Lebensweise."], "tplBalEyebrow": "Mikronährstoff-Komplex · Schritt 1 der Daily Routine", "tplBalH1": "Deine Mikronährstoffe in einer Kapsel. Morgens nehmen, abhaken.", "tplBalSubline": "Vitamin D3, B12, Folat, Magnesium, Zink und Selen in einer Kapsel. 30 Kapseln für 30 Tage.", "tplBalBullets": [["Vitamin B12 und Magnesium können zur Verringerung von Müdigkeit und Ermüdung beitragen", "1", ""], ["Vitamin D, Zink und Selen können zu einer normalen Funktion des Immunsystems beitragen", "2", ""], ["1 Kapsel am Morgen: kein Sortieren, kein Pillen-Chaos", "", ""], ["Für Tage, an denen die Portionen klein ausfallen und das gute Gefühl, an alles gedacht zu haben", "", ""], ["30 Kapseln = 30 Tage", "", ""]], "tplBalTiles": ["30 µg Vitamin B12", "72 mg Magnesium", "22 Vitamine & Mineralstoffe", "30 Kapseln"], "tplBalFaq": [["Wann nehme ich die Kapsel?", "Am besten morgens: 1 Kapsel täglich."], ["Mit oder ohne Essen?", "Nimm die Kapsel zu einer Mahlzeit mit einem Glas Flüssigkeit ein."], ["Kann ich sie mit anderen Präparaten kombinieren?", "Wenn du bereits andere Nahrungsergänzungsmittel nimmst, prüfe die Gesamtmengen der Vitamine und Mineralstoffe. Im Zweifel frag in der Apotheke oder bei deiner Ärztin oder deinem Arzt nach."], ["Wie lange reicht eine Dose?", "Eine Dose enthält 30 Kapseln, bei 1 Kapsel täglich reicht sie 30 Tage."], ["Gibt es Mengenrabatt oder Codes?", "Ja: Ab 2 Stück sparst du 5 %, ab 3 Stück 10 %. Mengenrabatt und Rabattcodes sind nicht kombinierbar. Pro Produkt gilt automatisch der höhere Rabatt."], ["Wie funktioniert die Garantie?", "In 3 Schritten: bestellen, 30 Tage testen, formlose Mail an info@h2humans.com mit deiner Bestellnummer.", "/garantie"]], "tplBalFootnotes": ["¹ Vitamin B12 und Magnesium können zur Verringerung von Müdigkeit und Ermüdung beitragen.", "² Vitamin D, Zink und Selen können zu einer normalen Funktion des Immunsystems beitragen.", "Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche und ausgewogene Ernährung und eine gesunde Lebensweise."], "deliveryLine": "Lieferung in {timeDat} · Versand aus Deutschland", "tplSetOutcome": "Damit du deine Basics im Griff hast und dich jeden Tag gut versorgt fühlst.", "tplBodyOutcome": "Damit dein Shake auch an Tagen mit wenig Appetit zur Routine passt.", "tplHydOutcome": "Damit Trinken kein To-do mehr ist.", "tplBalOutcome": "Damit deine tägliche Kapsel einfach zur Routine gehört.", "seoTitleBody": "Daily Body-Care Protein-Shake, für Tage mit wenig Appetit | H2HUMANS", "seoTitleHyd": "Daily Hydration Elektrolyt-Sticks: 30 Tage | H2HUMANS", "seoTitleBal": "Daily Balance Mikronährstoff-Kapseln: 30 Tage | H2HUMANS", "setBodyCareBenefit": "Protein, Kreatin und Kollagen in einem Shake.", "appDescPdp": "Dein persönlicher Begleiter für Routine, Wissen und Motivation: in jeder Phase.", "appFeature1Pdp": "Persönlicher Plan für jede Phase", "whyShakesTitle": "Warum normale Shakes nicht passen.", "whyShakes": ["Große Portionen für großen Hunger.", "Protein allein, ohne Kreatin und Kollagen.", "Sieben Dosen statt einer."], "whyShakesClose": "Deshalb steckt in Daily Body-Care alles in einem Messlöffel.", "guideBonusTitle": "Gratis dazu: Dein 30-Tage-Routine-Guide.", "guideBonusBody": "Mit Einnahmeplan, Zubereitung, Ideen für Tage mit wenig Appetit und Checkliste zum Abhaken.", "preparationVideoLabel": "Zubereitung im Video.", "claimNotesTitle": "Nährstoffangaben und Quellen.", "claimSourceLabel": "Quelle: EU-Verordnung 432/2012", "whyShakesDemand": "Zur Orientierung: Die Deutsche Gesellschaft für Ernährung empfiehlt Erwachsenen rund 0,8 g Protein pro Kilogramm Körpergewicht am Tag, ab 65 Jahren rund 1,0 g.", "whyShakesMetaphor": "Ein Shake für großen Hunger ist wie ein Teller, der zu voll ist: Er wird oft nicht leer.", "whyHydTitle": "Warum Trinken oft untergeht.", "whyHydPoints": ["Weniger Mahlzeiten heißt oft auch: weniger Getränke dazu.", "Ohne festen Moment wird es leicht vergessen.", "Eine volle Flasche im Rucksack ist noch keine Gewohnheit."], "whyHydClose": "Deshalb: ein Stick, eine Flasche, ein fester Moment am Tag.", "whyBalTitle": "Warum die Basis oft untergeht.", "whyBalPoints": ["Kleinere Portionen bedeuten oft weniger Abwechslung auf dem Teller.", "Sechs einzelne Präparate sortiert kaum jemand lange.", "Ein Vitaminschrank voller Dosen ist noch keine Routine."], "whyBalClose": "Deshalb: eine Kapsel, morgens, abgehakt."},
      listing: {"bundleSubline": "3 Produkte, 1 Routine, 2 Minuten am Tag: Daily Balance gratis dabei.", "bundleAlt": "Daily Routine Komplett-Set mit Daily Body-Care, Daily Hydration und Daily Balance", "title": "Dein GLP-1 Supplement System.", "subtitle": "Drei abgestimmte Produkte für jede Phase deiner Therapie: einzeln oder als komplettes System.", "bestseller": "EMPFOHLEN", "allProducts": "Alle Produkte", "saveVsSingle": "Du sparst {amount} gegenüber dem Einzelkauf", "singlesTitle": "Einzelprodukte", "listLabel": "Produkte", "faqTitle": "Fragen zu", "faqTitleEm": "Bestellung.", "faq": [["Wie kann ich bezahlen?", "Du kannst mit {payMethods} bezahlen. Die Zahlung läuft sicher über Stripe."], ["Wie löse ich einen Promo Code ein?", "Du gibst den Code auf der Bestellseite vor der Bezahlung ein. Neukunden-Codes gelten für deine erste Bestellung, Treue-Codes unserer Founding Members für jede Nachbestellung. Pro Bestellung gilt ein Code, nicht kombinierbar mit Mengenrabatt oder Set-Preis, es gilt automatisch der höhere Rabatt."]]},
      affiliate: {"welcome": "Schön, dass du über {name} hier bist. Dein 20-%-Rabatt auf Einzelprodukte ist aktiv. Das Komplett-Set ist bereits reduziert, Daily Balance ist gratis dabei.", "close": "Hinweis schließen", "admin": {"title": "Partner-Auswertung.", "loginTitle": "Anmelden.", "loginHint": "Wir schicken dir einen Login-Link per E-Mail.", "email": "E-Mail-Adresse", "send": "Login-Link senden", "sent": "Link gesendet. Prüfe dein Postfach.", "denied": "Kein Zugriff mit diesem Konto.", "logout": "Abmelden", "period": "Zeitraum", "thisMonth": "Dieser Monat", "lastMonth": "Letzter Monat", "custom": "Eigener Zeitraum", "dateFrom": "Von", "dateTo": "Bis", "partner": "Influencerin", "all": "Alle", "none": "Ohne Influencer", "orders": "Bestellungen", "net": "Nettoumsatz", "set": "Set", "singles": "Einzelprodukte", "first": "Erstkäufe", "reorders": "Nachbestellungen", "viaLink": "Über Link", "viaCode": "Über Code", "refunds": "Erstattungen", "commission": "Provision", "csv": "CSV exportieren", "backfill": "Altbestellungen übernehmen", "backfillDone": "{n} Bestellungen übernommen.", "colOrder": "Bestellnummer", "colDate": "Datum", "colKind": "Art", "colType": "Erstkauf/Nachbestellung", "colProducts": "Produkte", "colDiscount": "Rabatt", "colRefunded": "Erstattet", "testOrder": "Testbestellung · ohne Provision", "colCustomer": "Kunde", "link": "Link", "code": "Code", "firstOne": "Erstkauf", "reorder": "Nachbestellung", "yes": "ja", "no": "nein", "empty": "Keine Bestellungen im Zeitraum.", "netHint": "Nettoumsatz: bezahlter Warenwert nach Rabatt, ohne Versand, ohne MwSt. (Satz nach Lieferland). Testbestellungen zählen nicht zum Partner-Umsatz und erhalten ebenso wie Erstattungen keine Provision."}},
      shippingFaq: {"deliveryQ": "Wie schnell wird geliefert?", "deliveryA": "Wir versenden aus Deutschland. Die Lieferzeit beträgt {time}.", "costQ": "Was kostet der Versand?", "costA": "Der Versand kostet {cost}. Ab {amount} Warenwert (nach Rabatten) liefern wir kostenlos. Das Komplett-Set ist immer versandkostenfrei.", "title": "Versand"},
      trustBar: {"label": "Vorteile auf einen Blick", "stripLabel": "Unsere Versprechen", "setFree": "Komplett-Set immer versandkostenfrei", "qualityLabel": "Qualitätssiegel", "seals": ["Hergestellt in DE/AT", "GMP-zertifiziert", "Non-GMO", "Im Labor getestet"], "guarantee": "30 Tage Geld-zurück-Garantie", "freeFrom": "Versand ab {amount} frei", "delivery": "Lieferung in {timeDat}", "madeIn": "Hergestellt in DE/AT", "set": ["Daily Balance gratis", "Versandkostenfrei", "2 Minuten am Tag", "Hergestellt in DE/AT"], "body": ["22,4 g Eiweiß pro Portion", "3 g Kreatin", "Mit Bio-Molkeneiweiß", "Ohne zugesetzten Zucker"], "hyd": ["Natrium, Kalium, Magnesium", "Ohne zugesetzten Zucker", "30 Sticks für 30 Tage", "Hergestellt in DE/AT"], "bal": ["22 Vitamine & Mineralstoffe", "1 Kapsel am Tag", "30 Kapseln für 30 Tage", "Hergestellt in DE/AT"], "card": {"bundle": "Daily Balance gratis", "body-care": "22,4 g Eiweiß", "hydration": "Ohne zugesetzten Zucker", "balance": "1 Kapsel am Tag"}},
      trustLine: {"freeFrom": "Versand gratis ab {amount}", "setFree": "Set immer versandkostenfrei", "delivery": "Lieferung in {timeDat}", "guarantee": "30-Tage-Routine-Garantie", "label": "Versand und Garantie"},
      setMonthly3: "Oder ab {price} pro Monat im 3-Monats-Paket",
    },
    // Header
    nav: {
      howItWorks: "So funktioniert es",
      benefits: "Vorteile",
      trust: "Vertrauen",
      products: "Produkte",
      science: "Qualität",
      experts: "Expert:innen",
      app: "App",
      about: "Über uns",
      blog: "Ratgeber",
      community: "Community",
      shopCta: "Jetzt shoppen",
      openMenu: "Navigationsmenü öffnen",
      closeMenu: "Navigationsmenü schließen",
      primaryNavLabel: "Hauptnavigation",
      mobileNavLabel: "Mobile Navigation",
      homeLabel: "H2HUMANS Startseite",
    },
    langToggle: "EN",

    // Hero - Das erste Protokoll für die Abnehmspritze
    hero: {
      beActiveSection: {"filmLabel":"AUS DER COMMUNITY","videoAlt":"Kampagnen-Film BE ACTIVE mit Angelika bei HYROX","eyebrow":"FOUNDING MEMBER · HYROX KARLSRUHE · 04.10.2026","title":"BE ACTIVE!","sub1":"Stark werden.","sub2":"Stark bleiben.","body":"Angelika ist kein Profi. Sie hat einen Job, einen Alltag und eine Routine, die da hineinpasst. Wie sie sich auf HYROX vorbereitet, was sie am Renntag isst und warum Erholung zum Plan gehört, zeigt sie ehrlich und ungefiltert.","stats":[{"v":"8 km","l":"Laufen"},{"v":"8","l":"Stationen"},{"v":"1","l":"Routine dahinter"}],"chapters":["01 Vorbereitung","02 Race Day","03 Recovery"],"ctaStory":"Angelikas Story ansehen","ctaShop":"Ihre Routine im Shop","newTab":"(öffnet in neuem Tab)","nextStop":"Nächster Stopp: HYROX Frankfurt · 13.12.2026"},
      beActiveLanding: {"metaTitle":"BE ACTIVE! HYROX für Normalos: Angelikas Weg ins Ziel | H2Humans","metaDescription":"Vorbereitung, Race Day und Recovery: Wie H2Humans Founding Member Angelika HYROX Karlsruhe gelaufen ist, mit Trainingswoche, Renntag-Plan und ihrer Routine.","eyebrow":"H2HUMANS × ANGELIKA · HYROX KARLSRUHE · 04.10.2026","sub1":"HYROX für Normalos.","sub2":"Angelikas Weg ins Ziel.","body":"Kein Profi, kein Wundermittel. Ein Job, ein Alltag und eine Routine, die da hineinpasst. Angelika zeigt dir alles in drei Kapiteln: wie sie trainiert hat, was sie am Renntag gegessen hat und warum danach sechs Tage Pause zum Plan gehören.","filmLink":"Ganzer Film auf Instagram ▸","chooseChapter":"Wähle dein Kapitel","chapters":[{"n":"01","title":"Vorbereitung","sub":"Trainingswoche & Race Week","alt":"Angelika beim Training für HYROX"},{"n":"02","title":"Race Day","sub":"Stunde für Stunde","alt":"Angelika am Renntag bei HYROX Karlsruhe"},{"n":"03","title":"Recovery","sub":"Die Tage danach","alt":"Angelika bei der Erholung nach dem Rennen"}],"routineTab":"Angelikas Routine","navLabel":"Kapitel-Navigation","communityBack":"← Community","communityMore":"Weitere Founding Members kennenlernen →"},
      beActivePrep: {"eyebrow":"KAPITEL 01 · VORBEREITUNG","h1":"Eine normale Woche.","h2":"Kein Profi-Plan.","imgAlt":"Angelika bei Sandbag Lunges im Kurs","imgLabel":"TRAINING IM KURS · KEIN PERSONAL COACH","intro":"Angelika hat für HYROX nicht ihr Leben umgebaut. Sie hat eine Woche gebaut, die neben Job und Alltag funktioniert und die sie Woche für Woche durchziehen konnte.","week":[{"v":"1×","l":"Krafttraining"},{"v":"1–2×","l":"HYROX-Workout im Kurs"},{"v":"2×","l":"Laufen: Zone 2 + Intervalle"},{"v":"1–2","l":"echte Ruhetage"}],"dailyTitle":"Im Alltag","dailyText":"Protein immer im Fokus, Elektrolyte im Training, 6–7 Stunden Schlaf.","rwTitle1":"Die Race Week.","rwTitle2":"Was sich ändert, was bleibt.","rwSource":"Aus Angelikas Race-Week-Plan","rw":[{"label":"5–3 TAGE VORHER","title":"Noch kein Carb-Loading","text":"Kohlenhydrate nicht einsparen, Protein weiter essen, normal und ausgewogen bleiben, ausreichend trinken.","alt":"Porridge mit Obst"},{"label":"2–1 TAGE VORHER","title":"Kohlenhydrate in den Mittelpunkt","text":"Pasta, Reis, Kartoffeln, Brot, Obst. Bewusst mehr, aber nicht bis zum Platzen.","alt":"Teller mit Pasta"},{"label":"JEDEN TAG","title":"Regelmäßig trinken","text":"Nicht erst am Race Morning drei Liter auf einmal. Elektrolyte können je nach Situation sinnvoll sein. Ziel: gut hydriert an der Startlinie, nicht mit Wasserbauch.","alt":""},{"label":"BEWEGUNG","title":"Locker bleiben","text":"Spaziergang, lockeres Radfahren, Mobility, vielleicht ein sehr lockerer Lauf. Nichts, wonach die Beine am nächsten Tag fragen: „Was sollte das denn?“","alt":""}],"productLabel":"IN ANGELIKAS VORBEREITUNG · WERBUNG","howLead":"So nutzt Angelika es:","howText":"Protein immer im Blick, morgens in den Overnight Oats oder als Shake nach dem Training.","unit":"Grundpreis: {price} / kg · inkl. MwSt.","next":"Weiter zu Kapitel 02: Race Day"},
      beActiveRace: { eyebrow: 'KAPITEL 02 · RACE DAY · 04.10.2026', h1: 'Ihr Plan für den Renntag.', h2: 'Stunde für Stunde.', steps: [{ time: '3–4 H VORHER', title: 'Die letzte größere Mahlzeit', text: 'Leicht verdauliche Kohlenhydrate, moderate Proteinmenge, eher wenig Fett und Ballaststoffe. Bei Angelika: Porridge oder Overnight Oats mit Daily Body-Care und Obst. Alternativen: Reis, Toast, Banane.' }, { time: 'BIS ZUM START', title: 'Regelmäßig trinken, locker aufwärmen', text: 'Wasser plus Elektrolyte in kleinen Schlucken. Warm-up auf Rad und Rudergerät.' }, { time: '15–30 MIN VORHER', title: 'Ein kleiner Energieboost', text: 'Schnell verfügbare Kohlenhydrate: Banane, Fruchtmus, Reiswaffel mit Honig oder ein Gel. Aber nur, was im Training schon getestet wurde.' }, { time: 'IM RENNEN', title: '8 × 1 km Laufen, 8 Stationen', text: 'SkiErg, Sled Push, Sled Pull, Burpee Broad Jumps, Rudern, Farmers Carry, Sandbag Lunges, Wall Balls.' }, { time: 'IM ZIEL', title: 'Erst auffüllen, dann feiern', text: 'Flüssigkeit und Elektrolyte mit Daily Hydration, danach ein Daily Body-Care Shake.' }], ruleLabel: 'ANGELIKAS WICHTIGSTE REGEL', rule: 'Nichts Neues am Race Day.', alts: ['Angelika vor der HYROX-Wand', 'Angelika bei den Wall Balls', 'Angelika auf dem Rudergerät', 'Angelika beim Farmers Carry', 'Angelika läuft ins Ziel'], productLabel: 'AM RACE DAY DABEI · WERBUNG', howText: 'im Training, vor dem Start und als Erstes im Ziel.', next: 'Weiter zu Kapitel 03: Recovery' },
      beActiveRecovery: { eyebrow: 'KAPITEL 03 · RECOVERY', h1: '6 Tage.', h2: 'Kein Training.', imgAlt: 'Angelika entspannt sich nach dem Rennen', quote1: '„Mein Körper hat gerade Unglaubliches geleistet.', quote2: 'Jetzt darf ich mich um ihn kümmern.“', intro: 'Erholung ist kein verlorener Trainingstag, sondern der Grund, warum es weitergeht. Spaziergänge, Massage und Stretching gehören bei Angelika fest zum Plan.', tips: [{ title: 'Erstmal trinken', text: 'Nach über 60 Minuten Belastung fehlt Flüssigkeit. Nicht literweise auf einmal, sondern über die nächsten Stunden regelmäßig, Elektrolyte inklusive.' }, { title: 'Jetzt nicht sparen beim Essen', text: 'Kohlenhydrate füllen die Speicher, Protein für die Muskelregeneration, dazu Obst und Gemüse. Keine „Belohnungsdiät“, aber auch kein „jetzt eskaliere ich“.' }, { title: 'Bewegung ja. Belastung nein.', text: 'Spaziergang, sanfte Mobility, Füße hoch und viel schlafen. Am Morgen danach platt sein? Völlig okay.' }], dontLabel: 'WAS ANGELIKA NACH HYROX NICHT MACHT', dont1: 'Den Körper', dontEm: 'bestrafen,', dont2: 'weil er Gas gegeben hat.', donts: ['Kalorien „wegtrainieren“', 'Essen einsparen', 'Direkt wieder Vollgas', 'Härteres Training „zum Ausgleich“'], productLabel: 'IN ANGELIKAS RECOVERY · WERBUNG', productAlt: 'Daily Body-Care Shake nach dem Rennen', productQuote: '„Nach HYROX habe ich keinen Bock auf kompliziert.“', textBefore: 'Deshalb steht bei ihr nach dem Rennen ein', textBold: 'Daily Body-Care Shake', textAfter: 'bereit: anrühren, trinken, fertig.' },
      beActiveRoutine: {"eyebrow":"ANGELIKAS ROUTINE · ALLE DREI KAPITEL","h1":"Eine Routine.","h2":"Vom Training bis zur Recovery.","intro":"Drei Produkte, die Angelika durch Vorbereitung, Race Day und Recovery begleitet haben.","bestseller":"EMPFOHLEN","label":"ANGELIKAS KOMPLETTE ROUTINE","text":"Daily Body-Care, Daily Balance und Daily Hydration in einem Set: alles, was in den drei Kapiteln vorkommt.","lines":["Vorbereitung: Daily Body-Care & Daily Balance","Race Day: Daily Hydration","Recovery: Daily Body-Care Shake"],"vat":"inkl. MwSt. · Kostenloser Versand ab {amount}","singleLabels":{"body-care":"MULTI-FORMEL · KAPITEL 01 + 03","balance":"MIKRONÄHRSTOFF-KOMPLEX · JEDEN TAG","hydration":"ELEKTROLYT-FORMEL · KAPITEL 02"},"addToCart":"In den Warenkorb","disclaimer":"Werbung: Angelika ist Founding Member von H2Humans. Gezeigt ist ihre persönliche Routine, keine allgemeine oder medizinische Empfehlung. Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche, ausgewogene Ernährung und eine gesunde Lebensweise."},
      headline: "Das erste Wellbeing Protokoll für die Abnehmspritze.",
      subheadline:
        "Das H2HUMANS System, konzipiert von Experten für den Alltag mit der Abnehmspritze, vereint App, digitale Begleitung durch Dein +1 und wissenschaftlich entwickelte Supplements.",
      trustLine: "Wissenschaftlich fundiert & mit Experten entwickelt.",
      supportingCopy:
        "Von Experten entwickelt, für deinen Alltag mit der Abnehmspritze. App, Dein +1 KI-Begleitung und ergänzende, wissenschaftlich fundierte Supplements: als ein System.",
      // Default CTA used across the page (Hero, sections, etc.)
      ctaPrimary: "Jetzt Early Access sichern",
      // Header CTA should stay shorter to remain compact
      ctaPrimaryHeader: "Early Access",
      earlyAccessNote:
        "Wir starten das H2HUMANS System mit einer kleinen Gründergruppe von GLP-1-Nutzern: um es gemeinsam richtig aufzubauen. Die Warteliste sichert dir deinen Platz in der ersten Gruppe.",
      // Hero section (landing) specific copy
      headlineLine1: "Das Gewicht geht.",
      headlineLine2: "Dein Gefühl bleibt.",
      body: "H2Humans begleitet dich durch den Alltag mit der Abnehmspritze: beim Reduzieren, Pausieren und Absetzen. Für deine Kraft, deine Routinen und genau dieses Gefühl.",
      ctaPrimaryApp: "App kostenlos testen",
      ctaMicro: "Early Access · kostenlos · ohne Verpflichtung",
      ctaShop: "Zum Shop",
      intro:
        "Deutschlands erstes GLP-1 Support-System, wissenschaftlich entwickelt, um deinen Körper während der Therapie und darüber hinaus präventiv und langfristig zu unterstützen.",
      badges: {
        labTested: "Im Labor getestet",
        gmpCertified: "GMP certified",
        nonGmo: "Non-GMO",
        madeInGermany: "Hergestellt in DE/AT",
      },
      scienceLink: "Die Wissenschaft →",
    },

    // Is This For Me Section - Optimiert: Consumer-Sprache, reale Situationen
    isThisForMe: {
      title: "Kommt dir das bekannt vor?",
      items: [
        "Du hast gerade mit der Abnehmspritze begonnen und fühlst dich unsicher",
        "Mit der Therapie verändert sich dein Alltag: kleinere Portionen, ein anderer Rhythmus, neue Fragen",
        "Du merkst emotionale Veränderungen, die du nicht einordnen kannst",
        "Du suchst verständliche Antworten: keine Arzt-Fachsprache",
        "Du willst diesen Weg nicht allein gehen",
      ],
      notFor: "",
    },

    // Problem Section - Optimiert: Pain sichtbar, Rebound ergänzt, Nutzer-Relevanz
    problem: {
      title: "Du bist auf dem Weg der Veränderung,\naber Energie, Verdauung & Stimmung bleiben zurück.",
      subtitle: "",
      items: [
        {
          title: "KLEINER APPETIT",
          stat: "",
          description: "Weniger Hunger heißt oft: weniger Protein, weniger Trinken, weniger Mikronährstoffe.",
        },
        {
          title: "ORIENTIERUNGSLOS",
          stat: "68 %",
          description: "fühlen sich im Alltag mit der Therapie allein gelassen, ohne klare Anleitung.",
        },
        {
          title: "ABBRUCH & ZWEIFEL",
          stat: "> 50 %",
          description: "brechen die Therapie vorzeitig ab oder zweifeln an ihrem Weg: oft wegen fehlender Begleitung.",
        },
        {
          title: "EMOTIONALE VERÄNDERUNG",
          stat: "> 50 %",
          description: 'berichten von Stimmungsschwankungen, Reizbarkeit oder dem Gefühl, „neben sich zu stehen".',
        },
      ],
      conclusion: "",
      bridge: "",
      cta: "",
    },

    // Solution Section - Optimiert: LUMA als Begleiter, klare Funktionen
    solution: {
      title: "Dein +1: dein täglicher Begleiter während der GLP-1-Therapie.",
      titleOverride: "Dein +1 für den Alltag mit der Abnehmspritze.",
      subtitle:
        "Dein persönliches Unterstützungssystem für die Momente, in denen die GLP-1-Therapie allein schwer zu bewältigen ist.",
      betaNote: "App im Beta-Status: kostenlos verfügbar.",
      items: [
        "Personalisierte Unterstützung in jeder Phase deiner GLP-1-Therapie",
        "Evidenzbasierte Empfehlungen, verständlich erklärt",
        "Supplement-Routine passend zu deiner Phase",
        "Deine KI-Begleitung gibt emotionalen Halt und hilft dir, Veränderungen besser zu verstehen",
        "Immer alltagstauglich. Immer menschlich. Immer klar.",
      ],
    },

    // Benefits Section - Gekürzt: Nur die stärksten Nutzen
    benefits: {
      title: "Was sich für dich ändert.",
      subtitle: "Weniger Reibung, mehr Klarheit: in deinem Tempo.",
      items: [
        {
          title: "Mehr Sicherheit",
          description: "Klare Orientierung und verständliches Wissen für jede Phase.",
        },
        {
          title: "Weniger Stress",
          description: "Ruhige Begleitung statt Informationsflut.",
        },
        {
          title: "Klarere Orientierung",
          description: "Verstehen, was passiert - und warum.",
        },
        {
          title: "Nachhaltige Routinen",
          description: "Kleine, machbare Schritte für langfristigen Erfolg.",
        },
        {
          title: "Emotionaler Halt",
          description: "Du bist nicht allein - wir sind da.",
        },
      ],
    },

    // How It Works Section - Kombiniert: Erklärung + Mood-Szenarien
    howItWorks: {
      title: "So unterstützt dich Dein +1 im Alltag.",
      subtitle: "Dein +1 richtet sich nach deinem Tag.\nWie du dich fühlst, bestimmt, was du brauchst.",
      steps: [
        {
          number: "01",
          title: "Ankommen",
          description: "Dein +1 versteht deine Situation, mit einem kurzen Einstieg in deinen Alltag.",
        },
        {
          number: "02",
          title: "Dabeibleiben",
          description: "Erinnerungen, kleine Impulse und Routinen, die zu deinem Tag passen.",
        },
        {
          number: "03",
          title: "Weitergehen",
          description: "Unterstützung, die sich mit dir verändert: Schritt für Schritt.",
        },
      ],
      moodIntro: "Jeder Tag fühlt sich anders an. Dein +1 reagiert darauf.",
      scenarios: [
        {
          title: "SCHWIERIGER MORGEN",
          mood: "Müde, unsicher, unmotiviert",
          responses: [
            "Sanfter Start ohne Druck",
            "Herausfinden, was du heute brauchst",
            "Einfache Schritte für mehr Energie",
          ],
        },
        {
          title: "VOLLER TAG",
          mood: "Aktiv, aber mental überladen",
          responses: [
            "Vergiss deine Pausen nicht",
            "Überlastung frühzeitig erkennen",
            "Mahlzeiten & Supplements im Blick behalten",
          ],
        },
        {
          title: "UNRUHIGER ABEND",
          mood: "Gereizt, erschöpft, ruhelos",
          responses: ["Nimm dir Zeit für dich", "Reflektiere, was heute geholfen hat", "Runterfahren und gut schlafen"],
        },
      ],
    },

    // What Happens Next Section - Optimiert: Erwartungsmanagement
    whatHappensNext: {
      title: "Was passiert nach der Anmeldung?",
      signupTitle: "Was passiert nach deiner unverbindlichen Anmeldung?",
      signupSubtitle: "Drei einfache Schritte: dann bist du dabei.",
      signupSteps: [
        {
          title: "Bestätigung per E-Mail",
          description: "Du erhältst sofort eine Bestätigung: dein Platz ist reserviert.",
        },
        { title: "Early Access Einladung", description: "Sobald wir starten, bist du unter den Ersten mit Zugang." },
        {
          title: "Dein +1 kennenlernen",
          description: "Kurzes Onboarding, dann ist dein persönlicher Begleiter für dich da.",
        },
      ],
      dataPrivacyTooltip: {
        title: "Deine Daten gehören dir",
        description: "DSGVO-konform. Keine Weitergabe. Volle Kontrolle.",
      },
      steps: [
        {
          number: "1",
          title: "Bestätigung per E-Mail",
          description: "Du erhältst sofort eine Bestätigung und weißt, dass dein Platz reserviert ist.",
        },
        {
          number: "2",
          title: "Early Access Einladung",
          description: "Sobald wir starten, bist du unter den Ersten, die Zugang bekommen.",
        },
        {
          number: "3",
          title: "Dein +1 kennenlernen",
          description: "Kurzes Onboarding, dann ist dein persönlicher Begleiter sofort für dich da.",
        },
      ],
    },

    // Founding Member Section - Optimiert: Weniger Pitch, mehr Einladung
    foundingMember: {
      title: "Sei von Anfang an dabei",
      subtitle: "Sichere dir frühen Zugang: unverbindlich und vor offiziellem Start.",
      benefits: [
        "30 Tage kostenlos testen",
        "Keine Zahlung im Voraus",
        "Jederzeit kündbar",
        "Limitierte Plätze verfügbar",
      ],
      cta: "Kostenlos starten",
    },

    // Trust Section - Früher im Flow, erste Vertrauensverankerung
    trust: {
      title: "Auf Vertrauen gebaut. Von Wissenschaft gestützt.",
      items: [
        {
          title: "Wissenschaftlich fundiert",
          description: "Unsere Empfehlungen basieren auf aktueller GLP-1-Forschung.",
        },
        {
          title: "Deine Daten gehören dir",
          description: "DSGVO-konform. Keine Weitergabe. Volle Kontrolle.",
        },
        {
          title: "Keine Heilversprechen. Nur ehrliche Unterstützung.",
          description: "H2HUMANS ist ein Wellbeing-Begleiter: kein Medizinprodukt. Wir machen keine Heilversprechen.",
        },
      ],
      disclaimer:
        "Dein +1 ist ein Wellbeing-Begleiter von H2HUMANS: kein Medikament und ersetzt keine ärztliche Beratung.",
      expertsTitle: "Das sagen Expert:innen über Dein +1",
      experts: [
        {
          name: "Anna Pereira, PhD, MS",
          title: "Embodied Cognition · Verhaltenswissenschaft · Mind-Body Research",
          quote:
            "Dein +1 verbindet wissenschaftliche Tiefe mit echter Alltagstauglichkeit. Besonders der Fokus auf Stimmung, Selbstwahrnehmung und Routinen zeigt, wie wichtig es ist, Menschen nicht zu optimieren, sondern zu begleiten.",
          website: "actincycle.com",
        },
        {
          name: "Johannes Weiss",
          title: "Longevity & Performance · Gesundheitsstrategien · Praxisnahe Prävention",
          quote:
            "Was mich an Dein +1 überzeugt, ist der strukturierte, verantwortungsvolle Ansatz. Statt schneller Lösungen geht es um Orientierung, Prävention und nachhaltige Routinen: genau das fehlt vielen Menschen im Alltag.",
          website: "longevity-wien.at",
        },
      ],
    },

    // Privacy Block
    privacy: {
      title: "Deine Daten bleiben menschlich.",
      items: [
        "Deine Daten werden nicht verkauft",
        "Du entscheidest, was gespeichert wird",
        "Keine medizinischen Diagnosen",
        "Begleitung ergänzt: ersetzt keine Ärzt:innen",
      ],
    },

    // Sticky Banner
    stickyBanner: {
      ticker: {
        label: "Neuigkeiten",
        newArticleKey: "Neu im Ratgeber",
        newArticleRest: ": Muskelmasse nach dem Absetzen erhalten",
        articlesKey: "{count} Artikel",
        articlesRest: " wissenschaftlich eingeordnet im Ratgeber",
        qualityRest: "Im Labor getestet · GMP-zertifiziert · Hergestellt in DE/AT",
        appKey: "App kostenlos testen",
        appRest: ": Early Access",
        pause: "Pause",
        play: "Play",
      },
      guideTeaser: "Neu im Ratgeber: Muskelmasse nach dem Absetzen erhalten",
    },

    // Newsletter Section
    newsletter: {
      title: "Ein gesünderer Morgen",
      titleEm: "startet heute.",
      description: "15% auf deine erste Bestellung: plus Insider-Updates und GLP-1-Forschung direkt in dein Postfach.",
      discountHighlight: "15% auf deine erste Bestellung",
      descriptionRest: "plus Insider-Updates und GLP-1-Forschung direkt in dein Postfach.",
      placeholder: "your@email.com",
      submitting: "Wird gesendet...",
      submit: "15% sichern",
      success: "Danke: du bist auf der Warteliste.",
      error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      note: "Kein Spam. Jederzeit abbestellbar.",
      consentPrefix: "Mit deiner Anmeldung stimmst du unserer ",
      consentLink: "Datenschutzerklärung",
      consentSuffix: " zu.",
      finePrint: "Gilt für deine erste Bestellung. Nicht kombinierbar mit anderen Rabattcodes.",
      finePrintPartner: "Exklusive Rabatte über unsere Partner können höher ausfallen.",
      pendingTitle: "Fast geschafft!",
      pendingBody: "Wir haben dir eine E-Mail geschickt: bitte bestätige deine Anmeldung, um deinen 15%-Code zu erhalten.",
      resend: "Keine Mail erhalten? Erneut senden",
      resending: "Wird erneut gesendet...",
      resent: "E-Mail wurde erneut gesendet.",
      resendWait: "Bitte warte einen Moment, bevor du es erneut versuchst.",
      alreadyConfirmed: "Diese E-Mail ist schon bei uns angemeldet.",
      confirmedTitle: "Bestätigt!",
      confirmedBody: "Dein Code ist unterwegs. Schau in dein Postfach: dort findest du deinen 15%-Rabattcode.",
      confirmedCta: "Zum Shop",
      failedTitle: "Link ungültig oder abgelaufen.",
      failedBody: "Dieser Bestätigungslink wurde bereits verwendet oder ist abgelaufen. Melde dich einfach erneut an.",
      failedCta: "Erneut anmelden",
      popupClose: "Schließen",
      popupTitle: "15% auf deine",
      popupTitleEm: "erste Bestellung.",
      popupSentence: "Plus Insider-Updates und GLP-1-Forschung direkt in dein Postfach.",
      popupSuccess: "Fast geschafft: bitte bestätige deine E-Mail.",
    },


    // Promise Section
    promise: {
      title: "Qualität, die du ",
      titleEm: "sehen und prüfen kannst.",
      subtitle: "Jeder Inhaltsstoff in einer klinisch studierten Dosierung. Keine Füllstoffe, keine Abkürzungen.",
      moleqlarTitle: "Entwickelt mit MoleQlar",
      moleqlarBody1:
        "Unsere Supplements wurden gemeinsam mit den Wissenschaftler:innen von MoleQlar entwickelt, einem führenden deutschen Unternehmen in der Longevity- und Molekulargesundheitsforschung.",
      moleqlarBody2:
        "Die Formulierungen basieren auf aktueller wissenschaftlicher Evidenz und werden nach höchsten Qualitätsstandards entwickelt und produziert. So stellen wir sicher, dass jedes H2HUMANS Produkt wissenschaftsbasiert, transparent und kompromisslos hochwertig ist.",
      tags: ["GMP", "IFS Food", "ISO 22000", "HACCP"],
    },

    // Journal Section
    journal: {
      titleEm: "Unsere Geschichte",
      titleSuffix: "hinter H2Humans.",
      subtitle: "Deep Dives zu GLP-1 Forschung, Performance-Ernährung, Life Hacks und den Menschen hinter H2Humans.",
      heading: "Warum wir H2Humans gegründet haben.",
      body1:
        "H2Humans entstand aus eigenen Erfahrungen mit der Abnehmspritzen Therapie, sowie aus zahlreichen Gesprächen mit Freunden, Familie, Ärzt:innen und Betroffenen.",
      body2:
        "Millionen Menschen erleben durch GLP-1-Medikamente erstmals wieder Kontrolle über ihr Gewicht. Doch die eigentliche Herausforderung beginnt oft danach: Viele fühlen sich bei Themen wie Ernährung, Nährstoffversorgung, Muskelgesundheit und langfristigem Gewichtserhalt allein gelassen.",
      body3:
        "Wir glauben, dass nachhaltiger Erfolg mehr braucht als eine Verschreibung. Deshalb bauen wir H2Humans: ein wissenschaftlich fundiertes System aus Produkten, Wissen und Begleitung, das Menschen dabei unterstützt, bewusst, erfolgreich und gesund durch ihre GLP-1 Journey zu gehen.",
      body4:
        "Mit einer globalen Community von bald über 200 Millionen GLP-1 Anwender:innen sehen wir die Chance, eines der größten Gesundheitsprobleme unserer Zeit zu lösen, damit aus kurzfristigem Gewichtsverlust langfristige Gesundheit wird.",
      learnMore: "Mehr erfahren",
      aboutImageAlt: "H2Humans Über uns",
    },

    // App Section
    app: {
      betaBadge: "Free BETA Version",
      earlyAccessBadge: "Early Access Version 0€",
      title: "Dein +1 für den Alltag mit der ",
      titleEm: "Abnehmspritze.",
      description:
        "Dein persönliches Unterstützungssystem für die Momente, in denen die GLP-1-Therapie allein schwer zu bewältigen ist.",
      screenHomeAlt: "H2Humans App: Startbildschirm",
      screenProgressAlt: "H2Humans App: Fortschritt",
      features: [
        { title: "Personalisierte Unterstützung in jeder Phase deiner GLP-1-Therapie", body: "" },
        { title: "Evidenzbasierte Empfehlungen, verständlich erklärt", body: "" },
        { title: "Supplement-Routine passend zu deiner Phase", body: "" },
        { title: "Deine KI-Begleitung gibt emotionalen Halt und hilft dir, Veränderungen besser zu verstehen", body: "" },
        { title: "Immer alltagstauglich. Immer menschlich. Immer klar.", body: "" },
      ],
    },

    // Science Section
    science: {
      title: "Auf Wissenschaft gebaut. Von Erfahrung ",
      titleEm: "geleitet.",
      subtitle:
        "Zwei vertrauenswürdige Partner. Eine gemeinsame Mission:\nEvidenzbasierte Gesundheit durch wissenschaftliche Expertise, hochwertige Formulierungen und praktische Begleitung für den Alltag zugänglicher machen.",
      learnMore: "Mehr erfahren",
      back: "Zurück",
      next: "Weiter",
      moleqlarTags: ["GMP", "ISO/IEC 17025", "HACCP", "Lab tested"],
      experts: [
        {
          badge: "Trusted Supplement Partner",
          name: "MoleQlar",
          role: "Arztgegründet · Berlin/München · ISO/IEC 17025",
          backRole: "Arztgegründet · Deutschland & Österreich",
          backItems: [
            "Gegründet von drei Ärzten",
            "Jede Charge unabhängig im Labor getestet",
            "Produziert in zertifizierten deutschen & österreichischen Anlagen",
            "100.000+ Kunden in ganz Europa",
            "Wissenschaftsgetriebene Qualität und Transparenz",
          ],
          credentials: ["Quality Assurance", "Longevity Science", "Evidence-Based Formulation"],
          alt: "MoleQlar Supplement-Partner Präsentation",
        },
        {
          badge: "Health Ambassador",
          name: "Nuriel Molcho",
          role: "Gesundheit · Ernährung · Sport",
          backRole: "Gesundheit · Ernährung · Sport",
          backItems: [
            "Mitgründer der NENI Restaurantgruppe",
            "Verfechter von Ernährung, Bewegung und gesundem Leben",
            "Leidenschaftlich für Longevity und Performance",
            "Unterstützt die H2Humans Mission, Wohlbefinden in den Alltag zu integrieren",
          ],
          credentials: ["Healthy Lifestyle", "Nutrition", "Performance"],
          alt: "Porträt von Nuriel Molcho",
        },
      ],
    },

    // Principles Section
    principles: {
      title: "Wofür wir ",
      titleEm: "stehen.",
      subtitle: "Alles, was wir bauen, ist in Wissenschaft, Transparenz und echter täglicher Nutzbarkeit verankert.",
      items: [
        {
          number: "01",
          title: "Mit Intent & Impact gebaut",
          body: "Jedes Produkt löst ein klar definiertes, evidenzbasiertes Problem. Kein Supplement ohne klinisch nachvollziehbaren Grund.",
        },
        {
          number: "02",
          title: "Klinisch studierte Dosierungen",
          body: "Wir dosieren nach Wissenschaft. Bioaktive Formen statt günstigerer Alternativen.",
        },
        {
          number: "03",
          title: "Hergestellt nach GMP-Standard in Deutschland und Österreich",
          body: "",
        },
        {
          number: "04",
          title: "Wir nutzen es selbst",
          body: "Kein Produkt, das wir nicht selbst täglich nehmen würden. Unser härtester Qualitätsfilter.",
        },
      ],
    },

    // FAQ Section
    faq: {
      title: "Häufig gestellte Fragen.",
      items: [
        {
          icon: "help",
          tone: "neutral",
          question: "Ist H2HUMANS ein Medikament?",
          answer: [
            {
              type: "paragraph",
              text: "Nein. H2HUMANS ist ein Wellbeing-Begleiter, kein Medikament. Wir ersetzen keine medizinische Beratung. Konsultiere immer deinen Arzt, bevor du Supplements nimmst.",
            },
          ],
        },
        {
          icon: "clock",
          tone: "positive",
          question: "Wie lange dauert es, bis ich Ergebnisse sehe?",
          answer: [
            {
              type: "paragraph",
              text: "Unser Begleitprotokoll ist darauf ausgelegt, Veränderungen strukturiert zu begleiten und messbar zu machen. Erste Effekte können sich innerhalb der ersten Wochen zeigen. Für eine fundierte Bewertung empfehlen wir jedoch einen Zeitraum von mindestens 3 Monaten.",
            },
          ],
        },
        {
          icon: "shield",
          tone: "positive",
          question: "Sind die Supplements sicher?",
          answer: [
            { type: "paragraph", text: "Alle unsere Supplements sind:" },
            {
              type: "list",
              items: ["Hergestellt in DE/AT", "Lab Tested", "GMP Certified", "Non-GMO", "Mit Experten entwickelt"],
            },
            { type: "paragraph", text: "Wir arbeiten nur mit höchsten Qualitätsstandards." },
          ],
        },
        {
          icon: "bot",
          tone: "caution",
          question: "Wie funktioniert Dein +1?",
          answer: [
            { type: "paragraph", text: "Dein +1 ist eine KI-Begleitung, die dir personalisierte Empfehlungen gibt." },
            {
              type: "list",
              heading: "Dein +1 ist NICHT:",
              headingColor: "coral",
              items: [
                "Ein Therapeut (wir ersetzen keine professionelle Hilfe)",
                "Ein Arzt (wir geben keine medizinischen Ratschläge)",
              ],
            },
            {
              type: "list",
              heading: "Dein +1 IST:",
              headingColor: "green",
              items: [
                "Ein Begleiter (emotionale Unterstützung)",
                "Ein Coach (praktische Tipps)",
                "Verfügbar 24/7 (immer für dich da)",
                "Auf rein wissenschaftlicher Basis entwickelt und greift ausschließlich auf Wissen von fundierten Publikationen und Quellen zurück",
              ],
            },
          ],
        },
        {
          icon: "trending",
          tone: "positive",
          question: "Funktioniert das wirklich?",
          answer: [
            { type: "paragraph", text: "Das hängt von dir ab. H2HUMANS funktioniert am besten, wenn du:" },
            {
              type: "list",
              items: [
                "Die Supplements regelmäßig nimmst",
                "Die App täglich nutzt",
                "Dein +1 Empfehlungen befolgst",
                "Geduldig bist",
              ],
            },
          ],
        },
        {
          icon: "mail",
          tone: "neutral",
          question: "Wie können wir mit H2HUMANS Kontakt aufnehmen?",
          answer: [
            {
              type: "paragraph",
              text: "Sende uns eine E-Mail an info@h2humans.com und wir melden uns schnellstmöglich bei dir.",
            },
          ],
        },
      ],
    },

    // Supplement Value Comparison
    supplementComparison: {
      headline: "Orientierung statt",
      headlineAccent: "Überforderung",
      subline: "Ein abgestimmtes System, entwickelt für deinen Körper,\ndeine Ziele und dein Leben.",
      chaosLabel: "OHNE SYSTEM",
      chaosPoints: [
        "Zu viele Produkte,\nkeine Übersicht",
        "Unklare Dosierung &\nfalsches Timing",
        "Keine Anpassung an\nGLP-1",
        "Widersprüchliche\nInformationen",
        "Hoher Aufwand,\nkeine Konstanz",
      ],
      chaosBottom: "Unsicherheit · Überforderung · kein Fortschritt",
      systemLabel: "MIT H2HUMANS",
      systemWith: "Mit",
      systemPoints: [
        "Ein abgestimmtes System\nstatt Einzelprodukte",
        "Klare Dosierung &\noptimales Timing",
        "Speziell für GLP-1-Therapie\nentwickelt",
        "Wissenschaftlich fundiert",
        "App, Supplements &\nDein +1 inklusive",
      ],
      systemBottomPrefix: "Klarheit · Struktur · ",
      systemBottomAccent: "echte Ergebnisse",
      trustBadges: [
        { label: "Hergestellt in DE/AT", sub: "Höchste Qualität" },
        { label: "Non GMO", sub: "Ohne Gentechnik" },
        { label: "Glutenfrei", sub: "Verträglich" },
        { label: "GMP Certified", sub: "Geprüfte Herstellung" },
        { label: "Lab Tested", sub: "Laborgeprüft" },
      ],
    },

    // 404 Not Found
    notFound: {
      seoTitle: "404: Seite nicht gefunden | H2HUMANS",
      seoDescription: "Die gesuchte Seite konnte nicht gefunden werden.",
      code: "404",
      heading: "Hoppla! Seite nicht gefunden",
      homeLink: "Zurück zur Startseite",
      body: "Diese Seite existiert nicht (mehr). Vielleicht findest du hier weiter:",
      blogLink: "Zum Ratgeber",
      shopLink: "Zum Shop",
    },

    // Unsubscribe page
    unsubscribe: {
      seoTitle: "Abmelden | H2HUMANS",
      seoDescription: "Verwalte deine E-Mail-Abonnement-Einstellungen.",
      loading: "Wird verarbeitet…",
      successTitle: "Erfolgreich abgemeldet",
      successBody: "Du wurdest erfolgreich von zukünftigen Marketing-E-Mails abgemeldet.",
      errorTitle: "Abmeldung fehlgeschlagen",
      errorBody: "Der Abmeldelink ist ungültig oder abgelaufen.",
      back: "Zurück zur Startseite",
    },

    // Email Unsubscribe page
    emailUnsubscribe: {
      title: "E-Mail abmelden",
      intro: "Möchtest du dich von H2HUMANS-Mails abmelden?",
      confirm: "Abmeldung bestätigen",
      success: "Du wurdest erfolgreich abgemeldet.",
      already: "Diese E-Mail ist bereits abgemeldet.",
      error: "Der Link ist ungültig oder abgelaufen.",
      back: "Zurück zur Startseite",
      loading: "Wird verarbeitet…",
    },

    // Checkout Return page
    checkoutReturn: {
      title: "Zahlung erfolgreich!",
      body: "Vielen Dank für deine Bestellung. Du erhältst in Kürze eine Bestätigung per E-Mail.",
      back: "Zurück zur Startseite",
      emailSending: "Bestätigungs-E-Mail wird gesendet…",
      emailSent: "Bestätigungs-E-Mail wurde versendet.",
      emailError: "Bestätigungs-E-Mail konnte nicht gesendet werden. Bei Fragen melde dich unter info@h2humans.com.",
      orderLabel: "Bestellnummer:",
      orderReference: "Bitte gib diese Bestellnummer bei Rückfragen an.",
      guideTitle: "Dein 30-Tage-Routine-Guide.",
      guideBody: "Mit Einnahmeplan, Zubereitung, Ideen für Tage mit wenig Appetit und Checkliste zum Abhaken.",
      guideCta: "Zum Routine-Guide",
      nextOrderTip: "Tipp für deine nächste Bestellung: Im Daily Routine Komplett-Set ist Daily Balance gratis dabei.",
    },
    setValue: {"needTitle": "Kleinere Portionen. Bewusst ergänzen.", "need": ["Weniger Appetit kann mit kleineren Mahlzeiten und einer veränderten Flüssigkeitsaufnahme einhergehen. Welche Ergänzung sinnvoll ist, hängt von deiner Ernährung und deinem persönlichen Bedarf ab.", "Daily Body-Care kombiniert Protein, Kreatin und Kollagen in einem Shake. Die Zubereitung und Portionsgröße findest du in der Anwendungsempfehlung.", "Und fünf einzelne Dosen ohne Plan halten im Alltag selten lange durch."], "needClose": "Deshalb haben wir drei Produkte zu einer Routine gemacht.", "needCta": "Zum Paket wählen", "costTitle": "Einzeln gekauft vs. Komplett-Set.", "costSub": "Was die enthaltenen Komponenten einzeln für 30 Tage kosten würden.", "costCols": ["Komponente", "Menge pro Portion", "Einzeln*"], "costExtra": [{"name": "Elektrolyt-Mix (Daily Hydration)", "benefit": "1 Stick", "competitor": "~30 €"}, {"name": "Mikronährstoff-Basis (Daily Balance)", "benefit": "1 Kapsel", "competitor": "~15 €"}], "costTotal": "Summe Einzelkomponenten", "costTotalValue": "~173 €", "costSet": "Komplett-Set ab 84,90 €", "costSetNote": "pro Monat im 3-Monats-Paket", "vsTitle": "Komplett-Set vs. Alternativen.", "vsCols": ["Komplett-Set", "Normaler Proteinshake", "Einzelne Supplements"], "vsRows": [["Protein + Kreatin + Kollagen in einer Portion", 1, 0, 0], ["Elektrolyte für unterwegs", 1, 0, 1], ["Mikronährstoff-Basis", 1, 0, 1], ["Plan pro Phase in der App", 1, 0, 0], ["GMP & Hergestellt in DE/AT", 1, 2, 2], ["Eine Bestellung statt fünf", 1, 1, 0]], "vsYes": "Ja", "vsNo": "Nein", "vsVaries": "Je nach Produkt", "vsNote": "Vergleich mit typischen Produktkategorien, nicht mit einzelnen Anbietern.", "needDemand": "Als allgemeine Orientierung: Die Deutsche Gesellschaft für Ernährung empfiehlt Erwachsenen rund 0,8 g Protein pro Kilogramm Körpergewicht am Tag, ab 65 Jahren rund 1,0 g.", "needSourceLabel": "Quelle: DGE-Referenzwerte Protein", "needMetaphor": "Ein Einkaufszettel mit fünf Produkten ist noch kein Plan. Die Daily Routine ist der Wochenplan dazu."},
    threeStep: {"title": "So funktioniert die 3-Schritte-Methode™.", "steps": [["Morgens", "Daily Balance", "1 Kapsel: deine Mikronährstoff-Basis."], ["Tagsüber", "Daily Hydration", "1 Stick in die Flasche: Elektrolyte für unterwegs."], ["Nachmittags", "Daily Body-Care", "1 Shake in 30 Sekunden, mit Protein, Kreatin und Kollagen."]], "stepLabel": "Schritt {n}", "app": "Den passenden Plan für deine Phase bekommst du in der App.", "tlTitle": "Deine ersten 30 Tage.", "tl": [["Tag 1", "Set auspacken, Routine-Guide öffnen."], ["Tag 3", "Die Routine findet ihren Platz."], ["Tag 14", "Sitzt ohne Nachdenken."], ["Tag 30", "Nachschub bestellen oder Garantie nutzen."]], "compactTitle": "Teil der 3-Schritte-Methode™.", "compactCurrent": "Dieses Produkt", "compactCta": "Alle drei im Komplett-Set"},
    routineGuide: {"seoTitle": "30-Tage-Routine-Guide | H2HUMANS", "seoDesc": "Mit Einnahmeplan, Zubereitung, Ideen für Tage mit wenig Appetit und Checkliste zum Abhaken.", "eyebrow": "Daily Routine", "title": "Dein 30-Tage-Routine-Guide.", "intro": "Ob ein Produkt oder alle drei: Dieser Guide hilft dir, deine Routine in den ersten 30 Tagen einzurichten.", "pdf": "Als PDF speichern", "pdfHint": "Im Druckdialog „Als PDF speichern“ wählen.", "planTitle": "Einnahmeplan.", "plan": [["Morgens: Daily Balance", "1 Kapsel mit einem Glas Wasser, am besten zum Frühstück oder zu deiner ersten Mahlzeit."], ["Tagsüber: Daily Hydration", "1 Stick in deine erste Wasserflasche des Tages. Über den Vormittag oder unterwegs austrinken."], ["Nachmittags: Daily Body-Care", "1 Shake als fester Termin, z. B. als Snack zwischen Mittag und Abend oder nach dem Training."]], "planNote": "Das ist ein Vorschlag. Wenn ein anderer Zeitpunkt besser in deinen Tag passt, nimm ihn: wichtig ist, dass er jeden Tag gleich bleibt.", "prepTitle": "Zubereitung.", "prep": [["Daily Body-Care", "1 Messlöffel in 300 ml kaltes Wasser oder Milch bzw. Pflanzendrink geben, 15 Sekunden kräftig schütteln. Mit Eiswürfeln schmeckt er frischer."], ["Daily Hydration", "1 Stick in eine Flasche kaltes Wasser geben und kurz schütteln. Mehr Wasser macht den Geschmack milder."], ["Daily Balance", "1 Kapsel unzerkaut mit ausreichend Flüssigkeit schlucken."]], "lowTitle": "Ideen für Tage mit wenig Appetit.", "low": [["Klein anfangen", "Trink den Shake in kleinen Schlucken über 20 bis 30 Minuten statt auf einmal."], ["Teilen", "Bereite den Shake mit etwas mehr Flüssigkeit zu und trink die eine Hälfte am Nachmittag, die andere am frühen Abend."], ["Variieren", "Mix den Shake mit einem Espresso zum Mokka-Shake oder mit ein paar Eiswürfeln und einer halben Banane im Mixer."], ["Kalt hilft", "Gekühlt schmecken Shake und Drink oft angenehmer, wenn dir Essen gerade schwerfällt."]], "lowNote": "Wenn dein Appetit über längere Zeit sehr gering bleibt, sprich mit deiner Ärztin oder deinem Arzt.", "drinkTitle": "Trink-Erinnerung.", "drink": [["Sichtbar machen", "Stell deine Flasche mit dem Hydration-Stick dorthin, wo du sie den ganzen Tag siehst: Schreibtisch, Küche, Tasche."], ["Koppeln", "Verbinde jede Flasche mit einem festen Moment, z. B. Arbeitsbeginn, Mittagspause, Heimweg."], ["Erinnern lassen", "Stell dir für die ersten zwei Wochen einen Handy-Wecker oder nutze die Erinnerungen in der H2HUMANS App."]], "checkTitle": "Wochen-Checkliste zum Abhaken.", "week": "Woche {n}", "weeks": [["Einrichten", "Leg deine drei Zeitpunkte fest und stell die Produkte dorthin, wo du sie brauchst."], ["Festigen", "Gleiche Zeitpunkte, jeden Tag. Wenn ein Termin nicht passt, verschieb ihn, aber lass ihn nicht weg."], ["Dranbleiben", "Achte auf deine Trinkflasche. Ist sie bis zum Nachmittag leer?"], ["Bilanz", "Was hat gut funktioniert, was willst du ändern? Dein Set reicht noch ein paar Tage: plane deinen Nachschub."]], "days": ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"], "checks": ["Balance", "Hydration", "Body-Care"], "checkLabel": "{item}, Woche {n}, {day}", "reorder": "Rechtzeitig nachbestellen: Mit dem 2- oder 3-Monats-Paket sparst du am meisten pro Set.", "reorderCta": "Zum Komplett-Set", "guarantee": "Passt die Routine nicht in deinen Alltag? Unsere 30-Tage-Routine-Garantie gilt ab Lieferung.", "guaranteeLink": "Zur Garantie", "legal": "Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche und ausgewogene Ernährung und eine gesunde Lebensweise. Die angegebene empfohlene tägliche Verzehrmenge darf nicht überschritten werden. Außerhalb der Reichweite von kleinen Kindern aufbewahren. Wenn du Medikamente nimmst, schwanger bist oder stillst, sprich vor der Einnahme mit deiner Ärztin oder deinem Arzt."},
    shippingPage: {"and": "und", "metaTitle": "Versandbedingungen | H2HUMANS", "metaDesc": "Versand mit H2HUMANS: {cost} je Bestellung, kostenlos ab {amount} Warenwert, das Komplett-Set immer versandkostenfrei. Lieferung innerhalb Deutschlands in {timeDat}.", "back": "Zurück zur Startseite", "title": "Versandbedingungen", "tableTitle": "Versandkosten & Lieferzeiten", "colCountry": "Land", "colCost": "Versandkosten", "colTime": "Lieferzeit", "rowCost": "{cost} ({carrier}) · kostenlos ab {amount} Warenwert", "countries": {"DE": "Deutschland", "AT": "Österreich"}, "bundleNote": "Das Daily Routine Komplett-Set versenden wir immer versandkostenfrei.", "basisNote": "Maßgeblich ist der Warenwert nach Abzug von Rabatten (Mengenrabatt, Rabattcodes), ohne Versandkosten.", "condTitle": "Lieferbedingungen", "cond1": "Wir liefern derzeit nach {countries}. Sofern im jeweiligen Angebot keine abweichende Frist angegeben ist, erfolgt die Lieferung der Ware innerhalb von {timeDat} nach Vertragsschluss (bei vereinbarter Vorauszahlung nach dem Zeitpunkt deiner Zahlungsanweisung).", "cond2": "Bitte beachte, dass keine Zustellungen an Sonn- und Feiertagen erfolgen. Deine Bestellung wird automatisch bearbeitet und abgewickelt. Daher können wir in der Regel kurze Zeit nach der Bestellung keine Änderungen mehr vornehmen.", "cond3": "Sofern du Artikel mit unterschiedlichen Lieferzeiten bestellt hast, versenden wir die Ware in einer gemeinsamen Sendung, sofern wir mit dir keine abweichenden Absprachen getroffen haben. Die Lieferzeit bestimmt sich in diesem Fall nach dem von dir bestellten Artikel mit der längsten Lieferzeit.", "partnerTitle": "Versandpartner", "partner": "Der Versand erfolgt mit unseren Versandpartnern {carriers}.", "costTitle": "Versandkosten", "costVat": "Alle vorstehenden Angaben zu den Versandkosten verstehen sich inklusive der gesetzlichen Umsatzsteuer.", "updated": "Stand: {date}"},
    paymentMethodList: {"withPaypal": "Karte, PayPal, Apple Pay, Google Pay und Klarna", "withoutPaypal": "Karte, Apple Pay, Google Pay und Klarna"},
    shopTerms: {"title": "Shop-AGB", "pricesTitle": "Preise und Versandkosten", "prices": "Alle Preise verstehen sich inklusive der gesetzlichen Umsatzsteuer. Zusätzlich fallen Versandkosten in Höhe von {cost} je Bestellung an. Ab einem Warenwert von {amount} nach Abzug von Rabatten liefern wir innerhalb Deutschlands versandkostenfrei. Das Daily Routine Komplett-Set wird stets versandkostenfrei geliefert. Die Lieferzeit beträgt {time}. Einzelheiten unter", "link": "Versandbedingungen", "paymentTitle": "Zahlungsarten", "payment": "Die Zahlung erfolgt über unseren Zahlungsdienstleister Stripe. Zur Verfügung stehen {payMethods}. Apple Pay und Google Pay werden nur auf unterstützten Geräten und Browsern angezeigt.", "paymentPaypal": "Bei Zahlung mit PayPal erfolgt eine Weiterleitung zu PayPal; ergänzend gelten die Bedingungen von PayPal."},
    agbShop: {"pageTitle": "Allgemeine Geschäftsbedingungen", "title": "Kaufbedingungen (Shop)", "placeholder": "Wird ergänzt.", "earlyTitle": "Early-Access-Bedingungen"},
    privacyPayments: {"title": "Zahlungsdienste PayPal und Google Pay", "paypal": "Anbieter des Zahlungsdienstes PayPal ist die PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburg. Wenn Sie im Checkout PayPal als Zahlungsart wählen, werden Sie zu PayPal weitergeleitet. Dabei werden Ihre Zahlungsdaten (z. B. Name, E-Mail-Adresse, Zahlungsbetrag und Bestellnummer) an PayPal übermittelt und dort zum Zwecke der Zahlungsabwicklung verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsabwicklung). Weitere Informationen finden Sie in der Datenschutzerklärung von PayPal: ", "googlePay": "Anbieter des Zahlungsdienstes Google Pay ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Wenn Sie im Checkout Google Pay nutzen, werden Ihre Zahlungsdaten (z. B. die in Google Pay hinterlegte Karte, Name, Rechnungsadresse und Zahlungsbetrag) zum Zwecke der Zahlungsabwicklung zwischen Google und unserem Zahlungsdienstleister Stripe verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsabwicklung). Google kann diese Daten gemäß den Nutzungsbedingungen der Google Pay API und der Google-Datenschutzerklärung verarbeiten: ", "googleApiTerms": "Nutzungsbedingungen der Google Pay API", "googlePrivacy": "Google-Datenschutzerklärung"},

    // Order Overview page
    orderOverview: {
      seoTitle: "Bestellübersicht | H2HUMANS",
      seoDescription: "Wähle dein Supplement-Modul oder das Komplett-Bundle.",
      backToCart: "Zurück zum Warenkorb",
      orderNow: "Jetzt bestellen",
      successTitle: "Bestellung erfolgreich!",
      successBody: "Du erhältst in Kürze eine Bestellbestätigung per E-Mail.",
      successBack: "Zurück zum Shop",
      errorNotConfigured: "Zahlungen sind noch nicht für diese Umgebung konfiguriert.",
      errorItemUnavailable: "Ein Artikel im Warenkorb ist nicht mehr verfügbar.",
    },

    // Cart drawer
    cart: {
      title: "Warenkorb",
      empty: "Dein Warenkorb ist leer",
      bundleDiscountActive: "Bundle-Rabatt aktiv!",
      youSave: "Du sparst",
      total: "Gesamt",
      checkout: "Zur Kasse",
      pricesNote: "Alle Preise inkl. MwSt.",
      openCart: "Warenkorb öffnen",
    },

    // Index page SEO
    index: {
      seoTitle: "H2Humans: Begleitung beim Reduzieren und Absetzen der Abnehmspritze",
      seoDescription:
        "Ob Dosis reduzieren, pausieren oder absetzen: H2Humans begleitet dich durch die Übergangsphase der GLP-1-Therapie. Mit App, Supplements und wissenschaftlichem Ratgeber.",
      appDescription:
        "Der smarte Protocol Companion für Ernährung, Routinen, Supplements und Tracking während deiner GLP-1 Journey.",
      faqSupplementsSafe:
        "Alle unsere Supplements sind hergestellt in Deutschland und Österreich, Lab Tested, GMP Certified, Non-GMO und mit Experten entwickelt. Wir arbeiten nur mit höchsten Qualitätsstandards.",
      faqHowPlus1Works:
        "Dein +1 ist eine KI-Begleitung mit personalisierten Empfehlungen. Sie ersetzt weder Therapeut noch Arzt, sondern ist ein 24/7 Coach auf rein wissenschaftlicher Basis.",
      faqDoesItWork:
        "Das hängt von dir ab. H2HUMANS funktioniert am besten, wenn du die Supplements regelmäßig nimmst, die App täglich nutzt, Dein +1 Empfehlungen befolgst und geduldig bist.",
    },

    // Payment Test Mode Banner
    paymentBanner: {
      notConfigured:
        "Produktions-Checkout ist nicht konfiguriert. Schließe die Zahlungs-Freischaltung ab, um echte Zahlungen zu akzeptieren.",
      testMode: "Alle Zahlungen in der Vorschau befinden sich im Testmodus.",
      readMore: "Mehr erfahren",
    },

    // Info Tooltip
    infoTooltip: {
      ariaLabel: "Mehr Informationen",
      glp1Title: "Was ist eine Abnehmspritze?",
      glp1Body:
        "GLP-1-Medikamente mit Wirkstoffen wie Semaglutid oder Tirzepatid werden zur Gewichtsreduktion ärztlich verschrieben. Sie verstärken das Sättigungsgefühl und regulieren den Appetit.",
    },

    // Language Picker
    languagePicker: {
      ariaLabel: "Sprache auswählen",
      de: "Deutsch",
      en: "English",
      pt: "Português",
    },

    // Products Section
    products: {
      title: "Drei Produkte.",
      titleEm: "Ein komplettes System.",
      description:
        "Drei Produkte mit Protein, Elektrolyten und Mikronährstoffen für deine tägliche Routine.",

      bodycare: {
        category: "Multi-Formel",
        title: "Daily Body-Care",
        description:
          "Multifunktionales Proteinpulver mit Whey, Kreatin-Monohydrat, Kollagen-Hydrolysat, L-Carnitin. Kakao-Geschmack.",
        shortDescription: "Das enthaltene Protein kann zur Erhaltung von Muskelmasse beitragen.",
        pills: ["Protein & Kollagen", "Protein + Creatin"],
        saleBadge: "Early Access Deal",
        ingredientsHeading: "Pro Portion (35 g / 1 Messlöffel) · 0 g zugesetzter Zucker",
        ingredientsNote: "1 Messlöffel (35 g) in 300 ml Wasser oder Milch einrühren. Kakao-Geschmack.",
        fullIngredientsHeading: "Inhaltsstoffe",
        fullIngredients:
          "BIO Molkenweiß, Molkenweißisolat (Emulgator: Lecithine (Sonnenblume)), fettarmes Kakaopulver, Glycin, Kreatinmonohydrat, Kollagenhydrolysat (Rind), natürliches Kakao-Aroma, L-Carnitin-Tartrat, Verdickungsmittel: Xanthan; Inulin, Kakaobohnen-Extrakt, Bacillus coagulans, Enzymmischung (Alpha-Amylase, Protease, Lactase, Cellulase, Lipase), Cyanocobalamin, Pyridoxinhydrochlorid",
        whyTitle:
          "Daily Body-Care kombiniert Molkenprotein mit Kreatin, Kollagen-Hydrolysat und weiteren Inhaltsstoffen. Die enthaltenen Nährstoffe können zu folgenden normalen Körperfunktionen beitragen; ergänzend findest du Angaben zur Zusammensetzung:",
        whyPoints: [
          "<strong>Kollagen</strong> ist als Kollagen-Hydrolysat enthalten und liefert Aminosäuren.",
          "<strong>L-Carnitin</strong> ist als L-Carnitin-Tartrat enthalten.",
          "<strong>Enzyme und Bakterien-Kulturen</strong> sind Bestandteil der Rezeptur.",
        ],
        functionHeading: "Funktion",
        functionPoints: [
          "<strong>Protein</strong> kann zur Erhaltung von Muskelmasse beitragen.",
          "<strong>Kreatin</strong> kann zu einer erhöhten körperlichen Leistung bei Schnellkrafttraining im Rahmen kurzzeitiger intensiver körperlicher Betätigung beitragen. Für diese Angabe ist eine tägliche Aufnahme von 3 g Kreatin Voraussetzung. Diese Angabe richtet sich an Erwachsene, die intensiver körperlicher Betätigung nachgehen.",
          "<strong>Vitamin B6 und B12</strong> können zu einem normalen Energiestoffwechsel beitragen.",
        ],
        applicationHeading: "Unsere Anwendungsempfehlung",
        applicationText:
          "Wir empfehlen eine tägliche Einnahme von 35 g Daily Body-Care Pulver. Dazu einfach einen Messlöffel in 300 ml Flüssigkeit auflösen und trinken.\n\nDie angegebene empfohlene tägliche Verzehrmenge sollte nicht überschritten werden. Etwaige Druck- und Satzfehler vorbehalten.",
      },

      balance: {
        category: "Mikronährstoff-Komplex",
        title: "Daily Balance",
        description: "Hochdosiertes Multivitamin mit D3, B12, Folat, Magnesium, Zink und Selen. 30 Kapseln.",
        shortDescription: "Vitamin- und Mineralstoff-Komplex für die tägliche Routine.",
        pills: ["Mikronährstoff-Basis", "Vitamine & Mineralstoffe"],
        saleBadge: "Early Access Deal",
        ingredientsHeading: "Pro Kapsel · tägliche Dosis",
        ingredientsNote: "1 Kapsel täglich zu einer Mahlzeit einnehmen.",
        fullIngredientsHeading: "Inhaltsstoffe",
        fullIngredients:
          "Magnesiumbisglycinat, Vitamin C (L-Ascorbinsäure), Magnesiumoxid, Spirulina Pulver, Zinkbisglycinat, Vitamin E (D-Alpha Tocopherylacetat), Nicotinamid, Mangangluconat, Vitamin D3 (Cholecalciferol, vegan aus Flechten), D-Calcium-Pantothenat, Natriummolybdat, Vitamin K2 (MK7), Natriumborat (Di-Natriumtetraborat), Kupferbisglycinat, Vitamin B12 (Methylcobalamin), Vitamin B2 (Riboflavin-5-Phosphat), Vitamin B1 (Thiamin HCL), Vitamin B6 (Pyridoxal-5-Phosphat), D-Biotin, Vitamin A (Retinylpalmitat), Folsäure (Quatrefolic®), Chrompicolinat, Kaliumiodid, Natriumselenit; Hydroxypropylmethylcellulose (Kapselhülle)",
        whyTitle:
          "Daily Balance kombiniert Vitamine, Mineralstoffe und Spurenelemente. Die enthaltenen Mikronährstoffe können zu folgenden normalen Körperfunktionen beitragen:",
        whyPoints: [
          "<strong>Vitamin B1, B2, B6, B12 und Vitamin C</strong> können zu einem normalen <strong>Energiestoffwechsel</strong> beitragen.",
          "<strong>Vitamin A, C, D, Zink und Selen</strong> können zu einer normalen Funktion des <strong>Immunsystems</strong> beitragen.",
          "<strong>Vitamin B1, B2, B6, B12 und Magnesium</strong> können zu einer normalen Funktion des <strong>Nervensystems</strong> beitragen.",
          "<strong>Vitamin C, B2, B6, B12 und Folat</strong> können zur <strong>Verringerung von Müdigkeit und Ermüdung</strong> beitragen.",
          "<strong>Vitamin C, Vitamin E, Zink und Selen</strong> können dazu beitragen, die <strong>Zellen vor oxidativem Stress zu schützen</strong>.",
          "<strong>Vitamin D und K</strong> können zur Erhaltung normaler Knochen beitragen. <strong>Vitamin D</strong> kann zur Erhaltung einer normalen Muskelfunktion beitragen. <strong>Vitamin A</strong> kann zur Erhaltung normaler Sehkraft beitragen.",
          "<strong>Folat</strong> kann zu einer normalen Blutbildung beitragen. <strong>Vitamin B12</strong> kann zu einer normalen Bildung roter Blutkörperchen beitragen. <strong>Folat und Vitamin B12</strong> können zu einer normalen Funktion bei der Zellteilung beitragen.",
        ],
        applicationHeading: "Unsere Anwendungsempfehlung",
        applicationText:
          "Wir empfehlen eine tägliche Einnahme von einer Kapsel Daily Balance. Dazu einfach eine Kapsel zusammen mit einem Glas Flüssigkeit einnehmen.\n\nDie angegebene empfohlene tägliche Verzehrmenge sollte nicht überschritten werden. Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene und abwechslungsreiche Ernährung sowie eine gesunde Lebensweise. Bitte außerhalb der Reichweite von Kindern aufbewahren. Das Produkt sollte kühl und trocken gelagert werden. Etwaige Druck- und Satzfehler vorbehalten.",
      },

      hydration: {
        category: "Elektrolyt-Formel",
        title: "Daily Hydration",
        description:
          "Tägliche Elektrolytformel mit Natrium, Chlorid, Kalium und Magnesium. Zitrus-Geschmack. 30× 5g Sticks.",
        shortDescription: "Elektrolyte für aktive Tage in jeder Phase.",
        pills: ["Elektrolyt-Mischung", "Mineralstoffe"],
        saleBadge: "Early Access Deal",
        ingredientsHeading: "Pro Stick (5 g) · Zitrus · kein zugesetzter Zucker",
        ingredientsNote: "1 Stick in 500 ml Wasser auflösen. Täglich oder nach Bedarf trinken.",
        fullIngredientsHeading: "Inhaltsstoffe",
        fullIngredients:
          "Steinsalz, Säuerungsmittel (Citronensäure), Trikaliumcitratmonohydrat, Trimagnesiumdicitrat 8,59 %, Magnesiumbisglycinat, natürliches Aroma, Färbendes Lebensmittel (Saflor), Süßungsmittel (Steviolglykoside aus Stevia)",
        whyTitle:
          "Natrium, Chlorid, Kalium und Magnesium gehören zu den wichtigsten Elektrolyten im menschlichen Körper. Sie kommen in verschiedenen Geweben und Körperflüssigkeiten vor und werden regelmäßig über die Ernährung aufgenommen.",
        whyPoints: [
          "<strong>Magnesium</strong> kann zum <strong>Elektrolytgleichgewicht</strong> und zu einer <strong>normalen Muskelfunktion</strong> beitragen.",
          "<strong>Magnesium</strong> kann zu einer <strong>normalen Funktion des Nervensystems</strong> und zur <strong>Verringerung von Müdigkeit und Ermüdung</strong> beitragen.",
          "<strong>Kalium</strong> kann zu einer normalen Muskelfunktion beitragen.",
          "<strong>Kalium</strong> kann zu einer normalen Funktion des Nervensystems beitragen.",
        ],
        applicationHeading: "Unsere Anwendungsempfehlung",
        applicationText:
          "Wir empfehlen die tägliche Einnahme von einem Elektrolyte Stick. Dieser liefert 810 mg Natrium, 1240 mg Chlorid, 300 mg Kalium und 100 mg Magnesium. Den Inhalt eines Beutels in Wasser auflösen und trinken.\n\nDie angegebene empfohlene tägliche Verzehrmenge sollte nicht überschritten werden. Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene und abwechslungsreiche Ernährung sowie eine gesunde Lebensweise. Bitte außerhalb der Reichweite von Kindern aufbewahren. Das Produkt sollte kühl und trocken gelagert werden. Etwaige Druck- und Satzfehler vorbehalten.",
      },

      bundle: {
        badgeValue: "BEST VALUE",

        title: "Daily Routine Komplett-Set",
        description:
          "Drei Produkte in einer Box: Daily Body-Care, Daily Hydration und Daily Balance.",
        shortDescription: "Drei Supplements für deine tägliche Routine.",
        pills: [],
        cta: "Bundle in den Warenkorb",
        ctaShort: "In den Warenkorb",
        details: {
          intro:
            "Drei Produkte ergänzen deine tägliche Ernährungsroutine.",
          contentsHeading: "Das ist drin",
          benefitsHeading: "Deine Vorteile",
          benefits: [
            "Drei Produkte können deine bewusste Ernährungsroutine in einem System ergänzen.",
            "Das System kann deine Zufuhr von Elektrolyten, Vitaminen, Mineralstoffen und essenziellen Aminosäuren ergänzen.",
            "Drei feste Momente für deine tägliche Routine.",
          ],
          products: {
            bodycare:
              "Proteinpulver mit Molkenprotein, Kreatin, Kollagen-Hydrolysat und weiteren Inhaltsstoffen.",
            balance: "Multivitamin mit Vitamin D3, B12, Folat, Magnesium, Zink und Selen.",
            hydration: "Elektrolytformel mit Natrium, Chlorid, Kalium und Magnesium.",
          },
        },
      },

      common: {
        details: "Details",
        addToCart: "In den Warenkorb",
        back: "Zurück",
        whyItWorks: "Warum es wirkt",
        whatsInside: "Was drin ist",
        overview: "Übersicht",
        close: "Schließen",
        bundleUpsellTitle: "Das komplette System",
        bundleUpsellText: "Alle drei Produkte als System: perfekt aufeinander abgestimmt.",
        bundleUpsellCta: "Bundle in den Warenkorb",
        relatedTitle: "Das passt dazu",
        perMonth: "/ Monat",
        savePill: "Spare {amount}",
        routinePill: "30 Tage Routine",
        showAllIngredients: "Alle Inhaltsstoffe anzeigen",
        hideAllIngredients: "Weniger anzeigen",
        msrpLabel: "UVP",
        zoomIn: "Vergrößern",
        zoomOut: "Verkleinern",
        zoomReset: "Zoom zurücksetzen",
        zoomHint: "Tippen zum Vergrößern",
        detailBadges: ["GLP-1 Fokus", "30 Tage Routine", "Mit Ärzten entwickelt"],
      },
    },

    // Footer
    footer: {
      tagline: "We make wellbeing personal - your +1.",
      description: "We make wellbeing personal",
      privacy: "Datenschutz",
      imprint: "Impressum",
      terms: "AGB",
      privacySettings: "Datenschutz-Einstellungen",
      productsTitle: "Produkte",
      companyTitle: "Unternehmen",
      supportTitle: "Support",
      aboutUs: "Über uns",
      blog: "Ratgeber",
      careers: "Karriere",
      faq: "FAQ",
      shipping: "Versand",
      returns: "Rückgaben",
      privacyPolicy: "Datenschutz",
      imprintLink: "Impressum",
      termsOfService: "AGB",
      copyright: "© H2HUMANS 2026 · h2humans.com",
      disclaimer:
        "Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche und ausgewogene Ernährung und eine gesunde Lebensweise. Die angegebene empfohlene tägliche Verzehrmenge darf nicht überschritten werden. Außerhalb der Reichweite von kleinen Kindern aufbewahren.",
    },

    // Questionnaire
    questionnaire: {
      progress: "Schritt",
      of: "von",
      back: "Zurück",
      next: "Weiter",
      finish: "Abschließen & zur App",

      phase00: {
        title: "Sei von Anfang an dabei",
        subtitle: "Sichere dir frühen Zugang: unverbindlich und vor offiziellem Start.",
        email: {
          label: "Deine E-Mail-Adresse",
          placeholder: "name@beispiel.de",
        },
        username: {
          label: "Wie sollen wir dich nennen?",
          placeholder: "Dein Name",
        },
      },

      phase01: {
        title: "Kurzer Sicherheitscheck",
        subtitle: "Bitte beantworte diese Fragen ehrlich.",
        q1: "Bist du derzeit schwanger oder stillst du?",
        q2: "Wurde bei dir jemals Pankreatitis oder Schilddrüsenkrebs diagnostiziert?",
        q3: "Hast du eine schwere Magen-Darm-Erkrankung oder unkontrollierten Diabetes?",
        yes: "Ja",
        no: "Nein",
        exitTitle: "Bitte sprich zuerst mit deinem Arzt",
        exitMessage:
          "Wir empfehlen, vor der Nutzung von H2HUMANS ärztlichen Rat einzuholen. Wir sind da, wenn du bereit bist.",
        exitButton: "Verstanden",
      },

      phase02: {
        title: "Was ist dein Ziel?",
        subtitle: "Hilf uns, dich besser zu verstehen.",
        q1: {
          label: "Was möchtest du mit der Abnehmspritze erreichen?",
          options: [
            "Gewicht reduzieren",
            "Nebenwirkungen besser managen",
            "Langfristig dranbleiben",
            "Mehr Energie im Alltag",
            "Emotionale Stabilität",
            "Anderes",
          ],
        },
        q2: {
          label: "Wie gut fühlst du dich aktuell während deiner Therapie begleitet?",
          low: "Gar nicht",
          high: "Sehr gut",
        },
        q3: {
          label: "Was wäre für dich in 12 Wochen ein Erfolg?",
          placeholder: "z.B. Nebenwirkungen im Griff, mehr Energie, meine Routinen funktionieren",
        },
        reward: {
          title: "Kleine Schritte, große Wirkung",
          message: "Studien zeigen: Wer begleitet wird, bleibt länger dran und erzielt deutlich bessere Ergebnisse.",
        },
      },

      phase03: {
        title: "Erzähl uns mehr über dich",
        subtitle: "",
        section1: {
          title: "Ein paar grundlegende Informationen",
          age: {
            label: "Alter",
            placeholder: "Jahre",
          },
          gender: {
            label: "Geschlecht",
            options: ["Weiblich", "Männlich", "Divers", "Keine Angabe"],
          },
          weight: {
            label: "Aktuelles Gewicht",
            placeholder: "kg",
          },
        },
        section2: {
          title: "Deine Erfahrung mit der Abnehmspritze",
          glp1Status: {
            label: "Nutzt du aktuell eine Abnehmspritze?",
            options: ["Ja", "Nein"],
          },
          // Ja, aktuell
          brand: {
            label: "Welches Präparat nutzt du?",
            options: ["Ozempic", "Wegovy", "Mounjaro", "Sonstige", "Weiß ich nicht"],
          },
          therapyWeek: {
            label: "In welcher Woche deiner Therapie bist du?",
            start: "0",
            end: "12+",
          },
          // In der Vergangenheit
          endReason: {
            label: "Warum hast du aufgehört?",
            options: ["Erfolgreich beendet", "Abgebrochen"],
          },
          abortReasons: {
            label: "Was waren die Gründe?",
            hint: "Mehrfachauswahl möglich",
            options: ["Nebenwirkungen", "Kosten", "Fehlende Wirkung", "Alltag nicht passend", "Sonstiges"],
          },
          pastBrand: {
            label: "Welches Präparat hast du genutzt?",
            options: ["Ozempic", "Wegovy", "Mounjaro", "Sonstige", "Weiß ich nicht"],
          },
          // Nein
          startPlan: {
            label: "Planst du eine Abnehmspritze zu nutzen?",
            options: ["Nein", "In 1–4 Wochen", "In 4–8 Wochen", "In mehr als 8 Wochen"],
          },
        },
      },

      phase04: {
        title: "Fast geschafft.",
        subtitle: "Wir informieren dich, sobald Dein +1 für dich bereit ist.",
        privacyConsent:
          "Ich habe die Early Access-Bedingungen gelesen und akzeptiere diese. Die Datenschutzerklärung habe ich zur Kenntnis genommen.",
        privacyLink: "Datenschutzerklärung",
        marketing:
          "Ja, ich möchte per E-Mail Informationen, Updates und Angebote von H2HUMANS erhalten. Meine Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen (z.B. über den Abmeldelink in jeder E-Mail oder per Nachricht an info@h2humans.com). Weitere Informationen zur Verarbeitung deiner Daten findest du in unserer Datenschutzerklärung.",
        required: "Pflichtfeld",
        trustMicrocopy: "Keine Weitergabe an Dritte. Kein Spam.",
        cta: "Platz sichern: kostenlos",
      },

      complete: {
        title: "Du bist dabei!",
        message:
          "Du bist auf der Warteliste für Dein +1. Was jetzt passiert: Wir teilen exklusive Updates, Einblicke hinter die Kulissen und deine persönliche Einladung zur ersten Nutzergruppe.",
        button: "Zurück zur Startseite",
      },
    },

    // Checkout
    checkout: {
      title: "Bestellung",
      backToShop: "Zurück zum Shop",
      step: "Schritt",
      of: "von",

      // Step 1: Identification
      identification: {
        title: "Identifikation",
        subtitle: "Gib deine Kontaktdaten ein",
        email: {
          label: "E-Mail-Adresse",
          placeholder: "name@beispiel.de",
          error: "Bitte gib eine gültige E-Mail-Adresse ein",
        },
        firstName: {
          label: "Vorname",
          placeholder: "Max",
          error: "Vorname ist erforderlich",
        },
        lastName: {
          label: "Nachname",
          placeholder: "Mustermann",
          error: "Nachname ist erforderlich",
        },
        phone: {
          label: "Telefon (optional)",
          placeholder: "+49 123 456789",
        },
      },

      // Step 2: Delivery
      delivery: {
        title: "Lieferung",
        subtitle: "Wähle Versandart und Adresse",
        address: {
          label: "Lieferadresse",
          street: "Straße & Hausnummer",
          streetPlaceholder: "Musterstraße 42",
          streetError: "Straße ist erforderlich",
          zip: "PLZ",
          zipPlaceholder: "12345",
          zipError: "Gültige PLZ erforderlich",
          city: "Stadt",
          cityPlaceholder: "Berlin",
          cityError: "Stadt ist erforderlich",
          country: "Land",
          countryOptions: ["Deutschland", "Österreich", "Schweiz"],
        },
      },

      // Step 3: Payment
      payment: {
        title: "Zahlung",
        subtitle: "Zahlungsmethode und Rabattcode",
        method: {
          label: "Zahlungsmethode",
          notConfigured: "Zahlungsanbieter wird eingerichtet",
          comingSoon: "In Kürze verfügbar",
        },
        promoCode: {
          label: "Rabattcode",
          placeholder: "Code eingeben",
          apply: "Anwenden",
          remove: "Entfernen",
          applied: "Rabatt aktiviert",
          freeShipping: "Kostenloser Versand",
          invalid: "Ungültiger Rabattcode",
        },
        summary: {
          subtotal: "Zwischensumme",
          bundleDiscount: "Bundle-Rabatt",
          promoDiscount: "Rabattcode",
          shipping: "Versand",
          shippingFree: "Kostenlos",
          total: "Gesamtsumme",
        },
        cta: "Jetzt kostenpflichtig bestellen",
      },
    },

    knowledge: {
      prevArticle: "Vorheriger Artikel",
      nextArticle: "Nächster Artikel",
      goToArticle: "Artikel {n} von {total}",
      title: "Wissen, das dich",
      titleEm: "begleitet",
      titleAfter: ".",
      subtitle: "Wissenschaftlich eingeordnet: rund um GLP-1, Ernährung und den Weg danach.",
      sourcesNote: "Wir arbeiten mit über 100 wissenschaftlichen Quellen.",
      homeKicker: "Ratgeber",
      homeTitle: "Was die Forschung zu GLP-1 wirklich sagt.",
      homeAllArticles: "Alle Artikel",
      homeTopicsLabel: "Themen im Ratgeber",
      homeTrustHundred: "Über 100 wissenschaftliche Quellen",
      homeTrustSources: "Jeder Artikel mit wissenschaftlichen Quellen",
      homeTrustWeekly: "Wöchentlich neue Studien",
      viewAll: "Zum Ratgeber",
      related: "Passend dazu im Wissen",
      phaseLink: "{count} Artikel zu dieser Phase",
      phaseLinkOne: "1 Artikel zu dieser Phase",
      categoryCount: "{count} Artikel",
      categoryCountOne: "1 Artikel",
      germanOnly: "",
      listLabel: "Wissensartikel",
    },
    journey: {
      v2: {
        eyebrow: 'Wofür H2Humans da ist',
        title1: 'Andere begleiten den Start.',
        title2: 'Wir begleiten den Übergang.',
        intro: 'Mit der Abnehmspritze ist dein Körper im Wandel, vor, während und nach der Therapie. Der Übergang entscheidet, was du behältst. Genau dafür ist H2Humans gebaut.',
        transitionLabel: 'Der Übergang',
        steps: [
          { num: '01 · Vor der Spritze', title: 'Gut vorbereitet starten', text: 'Realistische Erwartungen und erste Routinen, bevor sich alles verändert.' },
          { num: '02 · Mit der Spritze', title: 'Kraft im Blick behalten', text: 'Eiweiß, Bewegung und feste Routinen, solange der Appetit leise ist.' },
          { num: '03 · Nach der Spritze', title: 'Das Erreichte behalten', text: 'Begleitung beim Absetzen und danach. Ohne Druck, ohne Scham.' },
        ],
        cardTitle: 'Jede Änderung ist ein Übergang.',
        cardText: 'H2Humans begleitet dich in jede Richtung, täglich, mit App, Wissen und abgestimmten Produkten. Immer in Absprache mit deiner Ärztin oder deinem Arzt.',
        cta: 'App kostenlos testen',
      },
      eyebrow: "DER GANZE WEG",
      title: "Aus Fortschritt wird langfristige Veränderung.",
      titleEm: "",
      subtitle: "**Viele erleben nach dem Absetzen eine schwierige Übergangszeit.**\nFür genau diesen Moment ist H2Humans gebaut.",
      transitionLabel: "Übergangsphase",
      pathTitle: "Drei Phasen. Ein",
      pathTitleEm: "Übergang",
      changes: ["Dosis anpassen", "Abstände verlängern", "Pausieren", "Neu starten", "Absetzen"],
      guideHint: "Hier begleiten wir dich.",
      explTitle: "Die",
      explText: "Jede Veränderung deiner Therapie bringt Fragen zu Körper, Hunger und Routinen mit sich. Wir begleiten dich in jede Richtung, in Absprache mit deiner Ärztin oder deinem Arzt.",
      articlesLink: "{count} Artikel zur Übergangsphase im Ratgeber",
      articlesLinkOne: "1 Artikel zur Übergangsphase im Ratgeber",
      pathAlt: "Ein Weg in drei Phasen: Pre GLP-1, On GLP-1 und Post GLP-1, der ab der Mitte der aktiven Phase bis in die Erhaltung in einer Übergangsphase hin und her schwingt: Dosis anpassen, Abstände verlängern, pausieren, neu starten oder absetzen.",
      phaseSubs: ["Vorbereitung", "Aktive Phase", "Erhaltung"],
      transitionText: "Jede Veränderung deiner Therapie: Dosis anpassen, Abstände verlängern, pausieren, neu starten oder absetzen. Wir begleiten dich in jede Richtung, in Absprache mit deiner Ärztin oder deinem Arzt.",
      bothWays: "Bewegung in beide Richtungen möglich.",
      source: "Quelle: Budini, Luo et al., eClinicalMedicine 2026.",
      disclaimer: "Schematische Darstellung, kein Leistungsversprechen.",
      more: "Mehr erfahren",
      less: "Weniger anzeigen",
      labels: {
        happens: "Was passiert",
        challenge: "Größte Herausforderung",
        h2h: "Was H2Humans bietet",
      },
      phases: [
        {
          tag: "Phase 1",
          name: "Pre GLP-1",
          timing: "Vor Therapiestart",
          happens: "Die Entscheidung fällt: finanziell, mental und praktisch. Selten alles im Gleichschritt.",
          challenge: "„Readiness Mismatch“: Budget, Verhaltens-Timeline und Commitment sind von Anfang an nicht synchron.",
          h2h: "Ehrliche Erwartungssteuerung statt Wunder-Versprechen: Vorbereitung auf den ganzen Weg, nicht nur den Start.",
        },
        {
          tag: "Phase 2",
          name: "On GLP-1",
          timing: "Aktive Behandlung: Monate bis Jahre",
          happens: "Substanzielle Veränderung. Das leichteste Zeitfenster für neue Gewohnheiten schließt früh (Tag 10–21).",
          challenge: "Muskelverlust ist real. Rund zwei Drittel brechen innerhalb eines Jahres ab: Cycling ist der Normalfall.",
          h2h: "Protein- & Trainings-Guidance nach Delphi-Konsens und Coaching, das über das Wirkstofffenster hinausträgt.",
        },
        {
          tag: "Phase 3",
          name: "Übergangsphase",
          timing: "Dosisreduktion, Absetzen oder Pause",
          happens: "Körpersysteme resetten nicht synchron: Stoffwechsel, Fett-Muskel-Verhältnis und Wellbeing verschieben sich unterschiedlich schnell.",
          challenge: "Der branchenweite blinde Fleck: Dosisreduktion und Nachbetreuung sind kaum erforscht.",
          h2h: "Genau hier setzt H2Humans an: täglich begleitet, nicht nur während der Spritze.",
        },
        {
          tag: "Phase 4",
          name: "Post GLP-1",
          timing: "Neues Gleichgewicht: Monate bis Jahre danach",
          happens: "Viele erleben nach dem Absetzen eine schwierige Übergangszeit.",
          challenge: "„Identity Lag“ am Maintenance-Plateau: man fühlt sich noch nicht als die neue Version seiner selbst.",
          h2h: "Routine-Support für die Zeit danach und ein echter „Welcome back“-Flow statt Rückfall-Scham-Narrativ.",
        },
      ],
    },

    comparison: {
      eyebrow: "",
      title: "Multiformulierung statt Multi-Kauf.",
      titleEm: "",
      subtitle: "30 Portionen, 7 Komponenten, 1 Produkt.",
      productLabel: "Daily Body-Care · 1000 g",
      columns: {
        component: "Komponente",
        benefit: "Menge pro Portion",
        competitor: "Führende Hersteller*",
        competitorSub: "(30 Tage anteilig)",
        h2: "H2Humans",
        h2Sub: "Daily Body-Care",
      },
      rows: [
        { name: "Whey Protein Isolate", benefit: "22,4 g Eiweiß", competitor: "~50 €" },
        { name: "Kollagenpeptide Hydrolysate", benefit: "3.000 mg", competitor: "~40 €" },
        { name: "Kreatin Monohydrat", benefit: "3.000 mg", competitor: "~6 €" },
        { name: "L-Carnitin-Tartrat", benefit: "500 mg", competitor: "~5 €" },
        { name: "Kakao-Polyphenol-Extrakt", benefit: "250 mg", competitor: "~12 €" },
        { name: "Bacillus Coagulans", benefit: "2 Mrd. KBE", competitor: "~10 €" },
        { name: "Vitamin B6 + B12", benefit: "1,4 mg · 2,89 µg", competitor: "~5 €" },
      ],
      includedLabel: "Enthalten",
      totalLabel: "Gesamt Wettbewerb",
      totalValue: "~128 €",
      h2Price: "69,90 €",
      savingsLabel: "Deine monatliche Ersparnis mit Daily Body-Care",
      savingsValue: "~58 €",
      savingsNote: "Alle sieben Komponenten in einem Produkt, ohne sieben Einzeldosen.",
      imageAlt: "Daily Body-Care Pulver im Messlöffel",
      singleLabel: "Einzeln",
      cta: "Daily Body-Care im Shop ansehen",
      footnote: "* Vergleich anhand aktueller Online-Marktpreise (2026) hochwertiger, markenrohstoffbasierter EU-Supplementhersteller. Preise strikt anteilig auf 30 Tagesportionen umgerechnet (Packungspreis ÷ Portionen × 30).",
    },

    foundingMembers: {
      title: "Unsere Founding Members.",
      body: "Wir arbeiten mit Menschen zusammen, die ihre GLP-1-Reise ehrlich mit ihrer Community teilen, mit echten Erfolgen, echten Rückschlägen und ganz ohne Filter.",
      productBody: "Wir arbeiten mit Menschen zusammen, die ihren Alltag und ihre Routinen ehrlich mit ihrer Community teilen.",
      productRoles: ["HYROX & feste Routinen", "HYROX-Vorbereitung", "Kraftsport & lange Spaziergänge"],
      badge: "Founding Member",
      showCard: "Karte anzeigen",
      prevCard: "Vorherige Karte",
      nextCard: "Nächste Karte",
      backCta: "Zurück",
      campaignBadge: "BE ACTIVE! KAMPAGNE",
      hyroxStoryCta: "HYROX-Story ansehen",
      cards: [
        {
          emoji: "✦",
          name: "Angelika",
          role: "Founding Member",
          subtitle: ["GLP-1 & HYROX", "@piks_zu_mir"],
          facts: ["GLP-1 & HYROX", "2× HYROX Finisher"],
          quote: "„Ich glaube nicht an Wundermittel. Ich glaube an Systeme, Routinen und ehrliche Begleitung. Deshalb bin ich Founding Member von H2Humans.“",
          cta: "Erfahre mehr",
          frontOnly: false,
          profileLabel: "Profil",
          instagramUrl: "https://www.instagram.com/piks_zu_mir/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "1,4K Follower",
          front: "„Ich glaube nicht an Wundermittel. Ich glaube an Systeme, Routinen und ehrliche Begleitung. Deshalb bin ich Founding Member von H2Humans.“",
          paragraphs: [
            "Was ich auf meiner GLP-1-Reise gelernt habe: Die Spritze nimmt dir nicht die Arbeit ab. Sie schafft die Möglichkeit, neue Gewohnheiten aufzubauen.",
            "Genau deshalb passe ich zu H2Humans. Mich überzeugt nicht das Versprechen eines Wundermittels, sondern der Ansatz, Menschen mit Wissen, Routinen und sinnvoll abgestimmten Produkten langfristig zu begleiten.",
            "Auf meinem Instagram-Account teile ich ehrlich meinen Weg, mit Erfolgen, Rückschlägen und allem, was dazwischen liegt. Mein Ziel ist es, Menschen Mut zu machen und zu zeigen, dass Veränderung nicht perfekt sein muss, sondern nachhaltig.",
          ],
          tags: ["GLP-1", "HYROX", "Founding Member"],
        },
        {
          emoji: "✦",
          name: "Nicole",
          role: "Founding Member",
          subtitle: ["GLP-1 & Lipödem", "@abnehmspritze_mit_lipoodem"],
          facts: ["GLP-1 & Lipödem", "HYROX-Vorbereitung"],
          quote: "„Kein ‚schnell-schnell‘, kein Vergleich. Gesundheit ist das Wichtigste, was wir haben: es geht darum, den eigenen Körper zu verstehen und Schritt für Schritt zu stärken.“",
          cta: "Erfahre mehr",
          frontOnly: false,
          profileLabel: "Profil",
          instagramUrl: "https://www.instagram.com/abnehmspritze_mit_lipoedem/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "1,3K Follower",
          front: "„Kein ‚schnell-schnell‘, kein Vergleich. Gesundheit ist das Wichtigste, was wir haben: es geht darum, den eigenen Körper zu verstehen und Schritt für Schritt zu stärken.“",
          paragraphs: [
            "Mein Weg verläuft bewusst langsam, kontrolliert und stetig, denn für mich steht eine Sache an erster Stelle: meine Gesundheit. Was ich dabei gelernt habe? Abnehmen bedeutet nicht, möglichst schnell Zielgewicht zu erreichen oder sich mit anderen zu vergleichen. Es geht darum, den eigenen Körper wieder kennenzulernen und nachhaltig zu stärken.",
            "Genau deshalb passe ich zu H2Humans. Mich überzeugt das ganzheitliche System: Mit nur drei aufeinander abgestimmten Produkten ist der Körper optimal versorgt: ganz ohne stundenlange Recherche oder kompliziertes Nachdenken. Es fügt sich einfach und schnell in den Alltag ein.",
            "Auf meinem Instagram-Account nehme ich meine Community ehrlich und unverblümt mit. Ich teile Vorher-Nachher-Einblicke, praxistaugliche Essenstipps, meine Vorbereitung auf den nächsten HYROX und alle Höhen und Tiefen. Mein Ziel ist es zu zeigen, dass Gesundheit das wichtigste Gut ist, das wir haben und dass der Weg dorthin Spaß machen darf.",
          ],
          tags: ["GLP-1", "Lipödem", "Founding Member"],
        },
        {
          emoji: "✦",
          name: "Sandra",
          role: "Founding Member",
          subtitle: ["GLP-1 & Perimenopause", "@sonnen.bunt"],
          facts: ["GLP-1 & Perimenopause", "Kraftsport & lange Spaziergänge"],
          quote: "„Jahrelange Diäten hatte ich genug, mit den Wechseljahren ging gar nichts mehr. Mit GLP-1 klappt es endlich wieder und ich konnte nachhaltige Routinen etablieren. H2Humans sieht den Menschen hinter den Produkten.“",
          cta: "Erfahre mehr",
          frontOnly: false,
          profileLabel: "Profil",
          instagramUrl: "https://www.instagram.com/sonnen.bunt/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "3,5K Follower",
          front: "„Jahrelange Diäterfahrungen hatte ich genug. Aber mit Beginn der Wechseljahre gelang es mir nicht mehr, Gewicht zu verlieren. Mit GLP-1 hat es bei mir endlich wieder funktioniert.“",
          paragraphs: [
            "Seit meiner GLP-1-Reise hat sich für mich vieles verändert.",
            "Ich nutze GLP-1 nicht, weil ich dachte, dass mir jemand die Arbeit abnimmt. Sondern weil es mir dabei hilft, etwas leiser zu machen, was mich früher ständig begleitet hat: Foodnoise. Und ganz ehrlich? Früher dachte ich, das sei bei allen Menschen so.",
            "Krafttraining begleitet mich dagegen schon seit vielen Jahren und ist für mich ein wichtiger Teil meiner Reise: gerade auch in der hormonellen Umbruchsphase und den Wechseljahren. Für mich bedeutet Veränderung deshalb nicht nur weniger Gewicht, sondern vor allem: stärker werden, Muskeln erhalten und mich in meinem Körper wieder wohlfühlen.",
            "Genau deshalb finde ich das Konzept von H2Humans so spannend. Kein wildes Zusammensuchen von Supplements und die ewige Frage: Was brauche ich eigentlich wirklich? Stattdessen ein durchdachtes Konzept mit Produkten, die sinnvoll aufeinander abgestimmt sind und mich genau dort unterstützen, wo ich gerade stehe.",
            "Denn das Leben ist oft kompliziert genug: da muss die Suche nach den passenden Supplements das nicht auch noch sein.",
          ],
          tags: ["GLP-1", "Perimenopause", "Founding Member"],
        },
      ],
    },
    // Blog
    about: {
      seoTitle: "Über uns | H2HUMANS",
      seoDescription: "Die Geschichte hinter H2HUMANS und wofür wir stehen: die Menschen, die Haltung und die Werte hinter dem H2HUMANS System.",
      blogTitle: "Mehr Wissen im Ratgeber.",
      blogBody: "Wissenschaftlich eingeordnete Beiträge zu GLP-1, Ernährung und dem Weg danach.",
      blogCta: "Zum Ratgeber",
    },
    blog: {
      title: "H2Humans Ratgeber",
      titleBefore: "Der H2Humans ",
      titleEm: "Ratgeber",
      titleAfter: ".",
      metaTitle: "H2Humans Ratgeber: GLP-1, Absetzen & Ernährung",
      metaDescription: "Wissenschaftlich eingeordnete Artikel rund um GLP-1, das Absetzen der Abnehmspritze, Ernährung und den Weg danach.",
      intro: "Wissenschaftlich eingeordnet. Verständlich erklärt. Rund um GLP-1, Ernährung und den Weg danach.",
      pageTitleSuffix: " | H2Humans Ratgeber",
      categoryKicker: "Ratgeber · {category}",
      featured: "Neuester Beitrag",
      aiImageLabel: "KI-generiertes Bild",
      aiImageMark: "KI",
      allCategories: "Alle Themen",
      articleCount: "{count} Beiträge",
      articleCountOne: "1 Beitrag",
      allPosts: "Alle Beiträge",
      backToBlog: "Zurück zur Ratgeber-Übersicht",
      readTime: "ca. {min} Min. Lesezeit",
      readTimeShort: "{min} Min. Lesezeit",
      readMoreLink: "Weiterlesen",
      readArticle: "Artikel lesen",
      readTimeCompact: "{min} Min.",
      heroKicker: "Ratgeber",
      heroTitle: "Antworten rund um GLP-1. Evidenzbasiert, mit Quellen.",
      searchLabel: "Ratgeber durchsuchen",
      searchPlaceholder: "Wonach suchst du? z. B. Absetzen, Muskelmasse, Food Noise",
      searchClear: "Suche zurücksetzen",
      searchResults: "{count} Artikel zu „{query}“.",
      searchResultsOne: "1 Artikel zu „{query}“.",
      searchNone: "Keine Artikel gefunden. Versuche einen anderen Begriff.",
      trustSources: "Jeder Artikel mit wissenschaftlichen Quellen",
      trustWeekly: "Wöchentlich neue Studien eingeordnet",
      trustOrientation: "Keine Therapieempfehlung, sondern Orientierung",
      newThisWeek: "Neu diese Woche.",
      topicsHeading: "Themen.",
      topicCount: "{count} Artikel",
      topicCountOne: "1 Artikel",
      allArticles: "Alle Artikel.",
      filterLabel: "Nach Thema filtern",
      filterAll: "Alle",
      mostRead: "Meistgelesen.",
      bandTitle: "Neue Studien, verständlich eingeordnet. Jeden Donnerstag.",
      bandHint: "15 % auf deine erste Bestellung.",
      loadMore: "Mehr laden",
      sourcesCount: "Mit {count} wissenschaftlichen Quellen",
      sourcesCountOne: "Mit 1 wissenschaftlichen Quelle",
      sourcesToggle: "Quellen ({count})",
      noTherapy: "Wir ersetzen keine medizinische Behandlung und geben keine Therapieempfehlung.",
      continueReading: "Weiterlesen.",
      readingProgress: "Lesefortschritt",
      topics: {
        transition: { short: "Absetzen", description: "Was nach dem Absetzen passiert." },
        "food-noise-psychologie": { short: "Psychologie", description: "Hunger, Appetit und Kopf verstehen." },
        wissenschaft: { short: "Studien", description: "Neue Studien verständlich eingeordnet." },
        ernaehrung: { short: "Ernährung", description: "Essen und Routinen für jeden Tag." },
        community: { short: "Community", description: "Erfahrungen von Menschen wie dir." },
        klinik: { short: "Klinik", description: "Einordnung für Praxis und Klinik." },
      } as Record<string, { short: string; description: string }>,
      ratingNone: "Noch keine Bewertung",
      ratingSummary: "{avg} von 5 · {count} Bewertungen",
      ratingSummaryOne: "{avg} von 5 · 1 Bewertung",
      rateTitle: "Wie hilfreich war dieser Artikel?",
      rateHint: "Bewerte mit 1 bis 5 Sternen.",
      rateStar: "{n} von 5 Sternen",
      rateThanks: "Danke für deine Bewertung.",
      rateError: "Bewertung konnte nicht gespeichert werden. Bitte versuche es erneut.",
      sortLabel: "Sortieren nach",
      sortNewest: "Neueste zuerst",
      sortTopRated: "Beste Bewertung",
      publishedShort: "Veröffentlicht am {date}",
      publishedOn: "Veröffentlicht am {date}",
      updatedOn: "Aktualisiert am {date}",
      author: "H2Humans Redaktion",
      toc: "Inhaltsverzeichnis",
      sources: "Quellen",
      faqHeading: "Häufige Fragen",
      related: "Verwandte Artikel",
      disclaimer: "Dieser Beitrag basiert ausschließlich auf öffentlich zugänglichen wissenschaftlichen Quellen, die oben vollständig und transparent aufgeführt sind.",
      empty: "Aktuell sind hier noch keine Beiträge veröffentlicht.",
      loading: "Beiträge werden geladen...",
      ctaTitle: "Bleib informiert.",
      ctaBody: "15% auf deine erste Bestellung: plus neue Beiträge und GLP-1-Forschung direkt in dein Postfach.",
      ctaCompact: "15% auf deine erste Bestellung: direkt in dein Postfach.",
      previewBanner: "Vorschau: dieser Artikel ist noch nicht veröffentlicht.",
      onlyGermanNotice: "Dieser Beitrag liegt bisher nur auf Deutsch vor.",
      breadcrumb: "Breadcrumb",
      breadcrumbHome: "Ratgeber",
      lastUpdated: "Zuletzt aktualisiert am {date}",
      backToBlogButton: "Zurück",
      toShop: "Zum Shop",
      productsTitle: "Unsere Produkte.",
      productsBody: "Das H2HUMANS System: wissenschaftlich entwickelte Supplements für deinen Alltag.",
      productsCta: "Im Shop ansehen",
      productsPrev: "Vorheriges Produkt",
      productsNext: "Nächstes Produkt",
      postsPrev: "Vorheriger Beitrag",
      postsNext: "Nächster Beitrag",
      communityTitle: "Werde Teil der Community.",
      communityBody: "Tägliche Impulse, Erfahrungen und Antworten rund um GLP-1: folge uns auf Instagram.",
      communityCta: "Auf Instagram folgen",
      comingSoonTitle: "Coming soon.",
      comingSoonBody: "Diese Kategorie startet bald: die ersten Beiträge sind bereits in Arbeit.",
      comingSoonClose: "Schließen",
    },
    // Admin
    admin: {
      metaTitle: "Redaktion | H2Humans",
      brand: "H2Humans Redaktion",
      logout: "Abmelden",
      login: {
        heading: "Redaktion",
        subtitle: "Bitte melde dich mit deinem Redaktions-Zugang an.",
        email: "E-Mail",
        password: "Passwort",
        submit: "Anmelden",
        loading: "Anmeldung läuft...",
        error: "Anmeldung fehlgeschlagen. Bitte prüfe deine Zugangsdaten.",
      },
      list: {
        heading: "Blogartikel",
        newPost: "Neuer Artikel",
        empty: "Noch keine Artikel vorhanden.",
        loading: "Artikel werden geladen...",
        colTitle: "Titel",
        colCategory: "Kategorie",
        colStatus: "Status",
        colUpdated: "Zuletzt geändert",
        sortBy: "Sortieren nach",
        sortDate: "Datum",
        sortStatus: "Status",
        noCategory: "—",
        analytics: "Statistik",
      },
      analytics: {
        heading: "Blog-Statistik",
        backToList: "Zurück zur Übersicht",
        period: "Zeitraum",
        periodDays: "Letzte {days} Tage",
        period6m: "Letzte 6 Monate",
        loading: "Statistik wird geladen...",
        error: "Statistik konnte nicht geladen werden.",
        empty: "Noch keine Daten in diesem Zeitraum.",
        visitors: "Besucher",
        pageViews: "Seitenaufrufe",
        totalTime: "Gesamte Lesezeit",
        avgTime: "Ø Lesezeit",
        dailyHeading: "Verlauf pro Tag",
        categoriesHeading: "Kategorien",
        postsHeading: "Artikel",
        visitorsShort: "Besucher",
        viewsShort: "Aufrufe",
      },
      status: {
        draft: "Entwurf",
        published: "Veröffentlicht",
        archived: "Archiviert",
      },
      form: {
        newHeading: "Neuer Artikel",
        editHeading: "Artikel bearbeiten",
        back: "Zurück zur Übersicht",
        title: "Titel",
        slug: "Slug",
        slugHint: "Wird automatisch aus dem Titel erzeugt, kann überschrieben werden.",
        category: "Kategorie",
        categoryNone: "Keine Kategorie",
        language: "Sprache",
        translationOf: "Übersetzung von …",
        translationOfNone: "Eigenständiger Artikel (neue Übersetzungsgruppe)",
        translationOfHint: "Wähle einen bestehenden Artikel, wenn dies dessen Übersetzung ist.",
        metaDescription: "Meta-Description",
        metaCounter: "{count}/160 Zeichen",
        metaWarning: "Über 160 Zeichen: Suchmaschinen kürzen den Text.",
        excerpt: "Excerpt",
        content: "Content (Markdown)",
        previewTab: "Live-Vorschau",
        sources: "Quellen",
        sourceText: "Quelle",
        sourceUrl: "URL (optional)",
        addSource: "Quelle hinzufügen",
        removeSource: "Quelle entfernen",
        faq: "Häufige Fragen (optional)",
        faqHint: "Nur ausgefüllte Fragen werden auf der Seite und im FAQ-Schema ausgegeben.",
        faqQuestion: "Frage",
        faqAnswer: "Antwort",
        addFaq: "Frage hinzufügen",
        removeFaq: "Frage entfernen",
        ogImage: "Titelbild-URL (optional)",
        ogImageHint: "Fotorealistisches Themenbild im Querformat (mindestens 1200 × 675 px) für Übersicht und Artikel. Leer lassen: Nach der Veröffentlichung wird automatisch ein passendes Titelbild erstellt. Das Hauptmotiv muss auch im mobilen Ausschnitt vollständig erkennbar bleiben.",
        ogImageRequired: "Bitte ein Titelbild angeben, bevor der Artikel veröffentlicht wird.",
        status: "Status",
        save: "Speichern",
        saving: "Wird gespeichert...",
        saved: "Gespeichert.",
        saveError: "Speichern fehlgeschlagen.",
        previewLink: "Vorschau öffnen",
        unsaved: "Ungespeicherte Änderungen",
        llmsNotice: "Nach dem Veröffentlichen eines neuen Artikels muss public/llms.txt manuell ergänzt werden.",
        altWarning: "Hinweis: {count} Bild(er) im Inhalt haben keinen Alt-Text.",
        leaveConfirm: "Es gibt ungespeicherte Änderungen. Seite wirklich verlassen?",
        requiredMissing: "Titel, Slug und Meta-Description sind Pflichtfelder.",
      },
    },
  },

  en: {
    trustVideos: {"title": "Real people. Real routines.", "subtitle": "Founding Members and our founder share how H2Humans fits into their everyday lives.", "thanksTitle": "Everyday routines in real life.", "strip": "Founding Members share their routine*", "play": "Play video by {name}", "close": "Close video", "prev": "Previous video", "next": "Next video", "setCta": "View the complete set", "shopCta": "Go to shop", "bodyCta": "View Daily Body-Care", "advertising": "Advertisement · Founding Member, receives a commission", "videoName": "H2Humans Trust Card – {name}", "people": {"sandra": {"name": "Sandra", "role": "Founding Member · Strength training & everyday life", "quote": "I mix a shake every day. Not sweet, with a light cocoa note.", "sourceRole": "Founding Member"}, "nicole": {"name": "Nicole", "role": "Founding Member · HYROX preparation", "quote": "My routine starts every morning with Daily Balance.", "sourceRole": "Founding Member"}, "patrick": {"name": "Patrick", "role": "Founder & CEO, H2Humans", "quote": "Human to human: we are building the system for the time that follows.", "sourceRole": "Founder & CEO"}, "angelika": {"name": "Angelika", "role": "Founding Member · HYROX athlete", "quote": "They're always in my gym bag. Perfect on the go.", "sourceRole": "Founding Member"}}, "quoteOpen": "“", "quoteClose": "”", "source": "— {name}, {role}", "footnote": "* Advertisement: Founding Members are cooperation partners of H2HUMANS and receive a commission. Read more under", "legalLink": "Legal notice", "modalAdvertising": "* Advertisement · Founding Member receiving commission", "cooperationTitle": "Cooperations with Founding Members.", "cooperationText": "On our website, social-media channels and in advertisements, we show personal accounts from Founding Members. Founding Members are cooperation partners of H2HUMANS. They may receive products free of charge and a commission on orders placed through their personal link or code. The content reflects the personal opinion and experience of the respective person. Patrick is the founder and CEO of H2HUMANS.", "carouselSubtitle": "Real people. Real routines. Unfiltered.", "hydrationCta": "View Daily Hydration", "dot": "Go to video {n} of {total}"},
    legalNotice: {"title": "Legal Notice.", "metaTitle": "Legal Notice | H2HUMANS", "description": "Legal information for H2HUMANS, operated by Cosmic Gap, Lda in Lisbon, Portugal.", "back": "Back to homepage", "company": "Cosmic Gap, Lda.", "address": "Avenida da Liberdade 230, 2 Floor, Andar 1250-148", "city": "Lisbon, Portugal", "emailLabel": "Email", "email": "info@h2humans.com", "phoneLabel": "Phone", "phone": "+351 910 734 628", "management": "Management.", "manager": "Patrick Eichiner", "registration": "Company Registration.", "registrationValue": "NIPC: 519218299", "tax": "VAT ID.", "taxValue": "VAT Identification Number: PT519218299", "disputeTitle": "Dispute Resolution.", "disputeIntro": "The European Commission provides a platform for online dispute resolution (ODR):", "disputeText": "We do not participate in dispute resolution proceedings before a consumer arbitration board and are not obliged to do so."},
    productHeroAlts: {"bundle": "Daily Routine complete set: Daily Hydration, Daily Body-Care and Daily Balance, Daily Balance free", "body-care": "Daily Body-Care cocoa-flavoured protein powder, 1000 g, 22.4 g protein per serving", "hydration": "Daily Hydration citrus-flavoured electrolytes, 30 sticks", "balance": "Daily Balance vitamins and minerals, 30 capsules, 1 capsule per day"},
    productReviews: {"summary": "{avg} out of 5 · {count} reviews", "title": "Reviews.", "verified": "Verified purchase", "incentivized": "Review after voucher incentive", "note": "All reviews come from verified buyers. We check that reviews come from people who bought the product.", "stars": "{n} out of 5 stars", "perCapsule": "{price} / capsule", "formTitle": "Your review.", "formIntro": "Thank you for your purchase. How do you like {product}?", "formRating": "Stars", "formText": "Your experience", "formName": "First name", "formSubmit": "Send review", "formSending": "Sending …", "formThanks": "Thank you! Your review will be checked and then published.", "formUsed": "A review has already been submitted for this link.", "formInvalid": "This review link is invalid.", "formError": "That did not work. Please try again.", "formRequired": "Please add stars, text and first name.", "metaTitle": "Write a review | H2HUMANS", "metaDesc": "Review your H2HUMANS product via your personal link.", "adminTitle": "Moderate reviews.", "adminHint": "Reject only for spam or legal violations, never because of a bad rating.", "adminApprove": "Approve", "adminReject": "Reject", "adminEmpty": "No reviews in this view.", "adminForbidden": "No access. Your account has no admin role.", "statusPending": "Pending", "statusApproved": "Approved", "statusRejected": "Rejected", "adminReviewsLink": "Reviews", "videosTitle": "Voices on video."},
    shippingUnits: {"daysNom": "{min}–{max} working days", "daysDat": "{min}–{max} working days", "countryNotice": "We currently deliver only within Germany."},
    shop: {
      navLabel: "Shop",
      promoMessages: {
        label: "Current offers",
        freeShipping: "Free shipping from {amount}",
        app: "New: try the H2Humans app for free",
        freeShippingShort: "Free shipping from {amount}",
        appShort: "New: H2Humans app free",
        startOffer: "Launch offer: Complete Set €24.80 less · Daily Balance free · free shipping from {amount}",
        startOfferShort: "Complete Set €24.80 less · Balance free",
      },
      order: {"title": "Your order.", "continueToPayment": "Continue to payment", "continueShopping": "Continue shopping", "summaryTitle": "Order summary", "stripeHint": "By clicking the pay button below, you place an order with an obligation to pay.", "empty": "Your cart is empty.", "toShop": "To the shop", "back": "Back", "seoTitle": "Order | H2HUMANS", "seoDesc": "Review your H2HUMANS order and pay securely.", "legalTerms": "Our {terms} apply to your order.", "legalTermsLink": "terms of sale", "legalWithdrawal": "Information about your right of withdrawal can be found in the {withdrawal}.", "legalWithdrawalLink": "withdrawal policy", "legalDelivery": "Delivery within {timeDat} in Germany.", "legalDeliveryShort": "Delivery within {timeDat}.", "newTab": "(opens in a new tab)"},
      upgrade: {"title": "Make it complete", "saved": "Daily Balance free · {amount} saved", "extra": "Only {amount} more for {products}", "cta": "Upgrade to the set", "decline": "No thanks, just {product}", "yourChoice": "Your choice", "recommended": "Recommended", "close": "Close", "andWord": " + "},
      miniCart: {
        shipping: "Shipping",
        shippingFreeValue: "free",
        total: "Total",
        vatNote: "incl. VAT",
        deliveryLine: "Delivery in {time} · shipped from Germany",
        swapSet: "Swap for the set",
        swapSetText: "With the set you get Daily Balance free and save {amount}.",
        reachesFree: "This makes your shipping free",
        title: "Your cart",
        itemCount: "{count} items",
        shippingRemaining: "{amount} away from free shipping",
        codeActive: "Code {code} is active",
        tierActive: "Quantity discount −{pct} %",
        codeLineActive: "Code {code} −{pct} %",
        tierLabel: "Quantity discount",
        shippingRemainingOrSet: "{amount} away from free shipping or get the set (always free shipping)",
        shippingFree: "Your shipping is free ✓",
        crossSellTitle: "Goes well with",
        add: "Add",
        promoHint: "Enter your promo code in the next step",
        subtotal: "Subtotal",
        checkout: "Checkout",
        trust: "Secure payment · Shipped from Germany",
        empty: "Your cart is empty",
        toShop: "Go to shop",
        close: "Close cart",
        open: "Open cart",
        decrease: "Decrease quantity",
        increase: "Increase quantity",
        remove: "Remove",
        quantity: "Quantity",
      },
      title: "All products.",
      subtitle: "The H2HUMANS supplement concept at a glance.",
      metaTitle: "Shop | H2HUMANS",
      metaDescription: "All H2HUMANS products at a glance.",
      viewProduct: "View product",
      cart: "Cart",
      backToShop: "Back to shop",
      productMetaTitleSuffix: " | H2HUMANS",
      productMetaDescriptionFallback: "Product description coming soon.",
      priceNote: "Price incl. VAT, plus shipping.",
      pdp: {"tbd": "[TEXT TO FOLLOW]", "unitPrice": "Unit price: {price} / kg", "unitPriceMissing": "Unit price: [TEXT TO FOLLOW]", "gallery": "Product images", "galleryAlts": {"set-1-routine": "3-step method: Daily Balance in the morning, Daily Hydration during the day, Daily Body-Care in the afternoon. 2 minutes a day.", "set-2-preis": "Individual components approx. €173 for 30 days vs. complete set from €84.90 per month in the 3-month package. Daily Balance free, free shipping.", "bodycare-1-inhalt": "Daily Body-Care per serving: 22.4 g protein, 3,000 mg creatine, 3,000 mg collagen, vitamin B6 and B12, with organic whey protein, 0 g added sugar.", "bodycare-2-vergleich": "Comparison of Daily Body-Care with a regular protein shake.", "hydration-1-inhalt": "Daily Hydration per stick: 810 mg sodium, 300 mg potassium, 100 mg magnesium, no added sugar, 30 sticks.", "hydration-2-vergleich": "Comparison of Daily Hydration with a ready-made sports drink.", "balance-1-inhalt": "Daily Balance: 22 vitamins and minerals in 1 capsule, including vitamin D3, B12, folic acid, selenium, zinc, magnesium.", "balance-2-basis": "Daily Balance: nutrients for energy, immune system, less tiredness, hair, bones and muscles, and cell protection.", "nutrition-body-care": "Nutrition facts and ingredients of Daily Body-Care", "nutrition-hydration": "Nutrition facts and ingredients of Daily Hydration", "nutrition-balance": "Nutrition facts and ingredients of Daily Balance"}, "slide": "Image {n} of {total}", "placeholderNutrition": "Nutrition image to follow", "placeholderLifestyle": "Lifestyle image to follow", "reviews": "{count} reviews", "purchaseOptions": "Purchase option", "oneTime": "One-time purchase", "subscribe": "Subscribe & save", "subscriptionPreview": "Subscription", "comingSoon": "Coming soon", "tiers": "packs", "save": "Save {amount}", "quantity": "Quantity", "addToCart": "Add to cart · {price}", "addShort": "Add to cart", "delivery": "Delivery in {time}", "trust": ["Lab tested", "GMP certified", "Made in DE/AT", "Non-GMO"], "accIngredients": "Ingredients", "accUsage": "How to use", "accShipping": "Shipping & returns", "shippingText": "We ship from Germany. The delivery time is {time}. Shipping costs {cost}. From {amount} in goods value (after discounts) we deliver free of charge. The Complete Set always ships free. Details on your right of withdrawal are in the withdrawal policy.", "shippingLink": "Shipping information", "withdrawalLink": "Withdrawal policy", "termsLink": "Terms", "upsellTitle": "Everything in the Daily Routine Komplett-Set", "upsellSave": "you save {amount}", "upsellCta": "To the Komplett-Set", "phaseTitle": "How it fits your", "phaseTitleEm": "phase.", "phases": ["Before the injection", "With the injection", "After the injection"], "ingredientsTitle": "Ingredients in", "ingredientsTitleEm": "detail.", "perServing": "per daily serving", "compareTitle": "H2Humans vs.", "compareTitleEm": "buying separately.", "compareCols": ["", "H2Humans", "Separate supplements"], "compareRows": ["Number of products", "Price per month", "Tailored to GLP-1 phases", "App support"], "compareProducts": "1 system (3 products)", "compareYes": "Yes", "compareApp": "Yes, try for free", "usageTitle": "How to use in", "usageTitleEm": "3 steps.", "usageSteps": ["Measure a serving", "Take with liquid", "Make it part of your daily routine"], "faqTitle": "Frequently asked", "faqTitleEm": "questions.", "appUpsellTitle": "Your system. Your ", "appUpsellTitleEm": "+1.", "crossTitle": "Complete your", "crossTitleEm": "system.", "bundleContents": "Included in the system", "reviewsTitle": "Reviews", "pkgLegend": "Choose a package", "pkgMonth1": "1 month", "pkgMonths": "{n} months", "pkgInstead": "instead of {price}", "pkgPerDay": "only {price} per day", "pkgPerSet": "{price} per set", "pkgSaved": "{amount} saved", "pkgPopular": "Most popular", "pkgBest": "Best price", "pkgGuideFree": "Free bonus: your 30-day routine guide", "pkgFreeBalance": "Daily Balance FREE in every set (worth {price})", "free": "FREE", "setContentsTitle": "Contents per set", "promoExcluded": "Promo codes do not apply to the already discounted Komplett-Set.", "setShippingFree": "Free shipping", "tplSetEyebrow": "Daily Routine Komplett-Set · 3-Step Method™", "tplSetH1": ["Three products. 2\u00a0minutes a day.", "For everyday life on weight-loss injections."], "tplSetSeoTitle": "Daily Routine Komplett-Set for everyday life on weight-loss injections | H2Humans", "tplSetSeoDesc": "Three products, one routine, 2 minutes a day: protein, electrolytes and micronutrients for your everyday life on weight-loss injections. Daily Balance free, free shipping, 30-day routine guarantee.", "tplSetSubline": "Protein, electrolytes and micronutrients in one coordinated system. No clutter of tubs and no hours of research. Made for days when meals are smaller.", "tplSetBullets": [["Protein may contribute to the maintenance of muscle mass", "1", ". Including on days with smaller meals."], ["Creatine may contribute to increased physical performance in short-term, high-intensity exercise", "2", ""], ["Magnesium and vitamin B12 may contribute to the reduction of tiredness and fatigue", "3", ""], ["One plan instead of five tubs: morning, daytime, afternoon and the good feeling of having thought of everything", "", ""], ["Tastes good: cocoa shake and citrus drink", "", ""]], "jumpNavLabel": "On this page", "jumpNav": ["Benefits", "How it works", "Voices", "FAQ"], "guaranteeBadge": "30-day routine guarantee: try risk-free", "deliveryLineSet": "Delivery in {time} · Shipped from Germany · free shipping", "balanceFreeShort": "Daily Balance free", "footnotesLabel": "Footnotes", "jumpGuarantee": "Guarantee", "priceNoteSet": "Price incl. VAT · free shipping", "priceNoteSinglePrefix": "incl. VAT, plus", "priceNoteShippingLink": "shipping", "paymentMethodsLabel": "Available payment methods", "guaranteeTitle": "Try it for 30 days. If it doesn't fit your everyday life, you get your money back.", "guaranteeSteps": ["Order", "Test for 30 days", "Informal email to info@h2humans.com with your order number"], "guaranteeNoReturn": "Opened pack? No need to send it back.", "guaranteeTermsLink": "All conditions", "footnotes": ["¹ Protein may contribute to the maintenance of muscle mass.", "² Creatine may contribute to increased physical performance in successive bursts of short-term, high-intensity exercise. A daily intake of 3 g of creatine is a prerequisite for this statement; the claim is aimed at adults performing high-intensity exercise.", "³ Magnesium and vitamin B12 may contribute to the reduction of tiredness and fatigue.", "Food supplements are not a substitute for a varied and balanced diet and a healthy lifestyle."], "gpNav": "Guarantee", "gpSeoTitle": "30-day routine guarantee | H2HUMANS", "gpSeoDesc": "Test your first order for 30 days. If it doesn't fit your everyday life, we refund the purchase price.", "gpBack": "Back to homepage", "gpTitle": "30-day routine guarantee.", "gpIntro": "Test your first order for 30 days from delivery. If it doesn't fit your everyday life, we refund the purchase price.", "gpHowTitle": "How it works.", "gpHow": "Write to us at info@h2humans.com within 30 days of delivery with your order number. We refund to your original payment method within 14 days.", "gpCondTitle": "Conditions.", "gpConditions": ["Applies to your first order, once per customer.", "We fully refund one opened pack per product or one opened set, without return.", "For supply packages (2 or 3 sets), you return the additional sets unopened; you bear the return shipping costs.", "The guarantee is a voluntary service and does not affect your statutory rights (withdrawal, warranty)."], "tplSetFaq": [["I hardly eat anymore: how does this fit into my day?", "Easily: the shake is mixed in 30 seconds, the stick goes into your water bottle, plus one capsule. You don't need to feel hungry."], ["When do I take it on days with little appetite?", "Whenever it feels right for you. Feel free to sip the shake slowly or mix it with more liquid."], ["I already eat well: do I need this?", "The set is a supplement for days with small portions. It is not a substitute for a varied and balanced diet."], ["Is this a meal replacement?", "No. The set complements your meals."], ["What does it taste like?", "Daily Body-Care is a cocoa shake, Daily Hydration a citrus drink: both without added sugar."], ["How long does a set last?", "One set lasts 30 days."], ["Which package is right for me?", "1 month is ideal for getting to know it. 2 or 3 months suit a steady routine, with the best price per set."], ["How does the guarantee work?", "In 3 steps: order, test for 30 days, send an informal email to info@h2humans.com with your order number.", "/garantie"], ["Do promo codes apply to the set?", "No, the set is already discounted."]], "pkgPiece1": "1 piece", "pkgPieces": "{n} pieces", "pkgPctSaved": "{pct} % saved", "pkgPerPiece": "{price} per piece", "pkgPopularShort": "Popular", "pkgListPrice": "Regular price", "priceNotePdpPrefix": "Price incl. VAT, plus", "priceNoteFreeFrom": "free from {amount}", "setBoxText": "Save from {amount} with the Daily Routine Komplett-Set: Daily Balance included free", "balanceInSet": "Daily Balance is included free in the Komplett-Set.", "tilesLabel": "At a glance", "tplBodyEyebrow": "Multi-formula · Step 3 of the Daily Routine", "tplBodyH1": "Your protein shake for days with little appetite. Ready in 30 seconds.", "tplBodySubline": "22.4 g protein, 3 g creatine and 3 g collagen in one shake. Cocoa flavour, no added sugar.", "tplBodyBullets": [["Protein may contribute to the maintenance of muscle mass", "1", ""], ["Creatine may contribute to increased physical performance in short-term, high-intensity exercise", "2", ""], ["Vitamin B6 and B12 may contribute to normal energy-yielding metabolism", "3", ""], ["Seven ingredients in one shake instead of seven tubs and the good feeling of having thought of everything", "", ""], ["Tastes of cocoa: 1 scoop, liquid, shake", "", ""]], "tplBodyTiles": ["22.4 g protein", "3,000 mg creatine", "3,000 mg collagen", "30 servings"], "tplBodyFaq": [["How do I prepare the shake?", "Add 1 scoop (35 g) to 300 ml water or milk, shake, done."], ["Is it a meal replacement?", "No. Daily Body-Care complements your meals."], ["How does it taste?", "Of cocoa, with no added sugar."], ["Which allergens does it contain?", "Milk (whey protein, according to the ingredient list). The full ingredient list is above under “Ingredients”."], ["How long does a tub last?", "A tub contains 30 servings: at 1 serving a day it lasts 30 days."], ["Is there a quantity discount or codes?", "Yes: from 2 pieces you save 5 %, from 3 pieces 10 %. Quantity discount and promo codes cannot be combined: the higher discount applies automatically per product."], ["How does the guarantee work?", "In 3 steps: order, test for 30 days, send an informal email to info@h2humans.com with your order number.", "/garantie"]], "tplBodyFootnotes": ["¹ Protein may contribute to the maintenance of muscle mass.", "² Creatine may contribute to increased physical performance in successive bursts of short-term, high-intensity exercise. A daily intake of 3 g of creatine is a prerequisite for this statement; the claim is aimed at adults performing high-intensity exercise.", "³ Vitamin B6 and vitamin B12 may contribute to normal energy-yielding metabolism.", "Food supplements are not a substitute for a varied and balanced diet and a healthy lifestyle."], "tplHydEyebrow": "Electrolyte formula · Step 2 of the Daily Routine", "tplHydH1": "Drinking you won't forget. One stick, one bottle, done.", "tplHydSubline": "Sodium, potassium and magnesium in one stick. Citrus flavour, no added sugar, 30 sticks for 30 days.", "tplHydBullets": [["Magnesium may contribute to electrolyte balance", "1", ""], ["Potassium and magnesium may contribute to normal muscle function", "2", ""], ["Stick into the bottle: on the go, at the office, during training", "", ""], ["Citrus instead of sweet: no added sugar and the good feeling of having thought of everything", "", ""], ["30 sticks = 30 days, no measuring", "", ""]], "tplHydTiles": ["810 mg sodium", "300 mg potassium", "100 mg magnesium", "30 sticks"], "tplHydFaq": [["How much water per stick?", "Dissolve 1 stick in 500 ml water."], ["When is the best time to drink it?", "Whenever it suits you, for example in the morning, on the go or during training. 1 stick a day."], ["How does it taste?", "Of citrus: fresh rather than sweet."], ["Does it contain sugar or sweetener?", "No sugar is added. According to the ingredient list it is sweetened with steviol glycosides from stevia."], ["Can I take more than one stick?", "Please stick to the recommended daily amount of 1 stick. It should not be exceeded."], ["Is there a quantity discount or codes?", "Yes: from 2 pieces you save 5 %, from 3 pieces 10 %. Quantity discount and promo codes cannot be combined: the higher discount applies automatically per product."], ["How does the guarantee work?", "In 3 steps: order, test for 30 days, send an informal email to info@h2humans.com with your order number.", "/garantie"]], "tplHydFootnotes": ["¹ Magnesium may contribute to electrolyte balance.", "² Potassium and magnesium may contribute to normal muscle function.", "Food supplements are not a substitute for a varied and balanced diet and a healthy lifestyle."], "tplBalEyebrow": "Micronutrient complex · Step 1 of the Daily Routine", "tplBalH1": "Your micronutrients in one capsule. Take it in the morning, tick it off.", "tplBalSubline": "Vitamin D3, B12, folate, magnesium, zinc and selenium in one capsule. 30 capsules for 30 days.", "tplBalBullets": [["Vitamin B12 and magnesium may contribute to the reduction of tiredness and fatigue", "1", ""], ["Vitamin D, zinc and selenium may contribute to the normal function of the immune system", "2", ""], ["1 capsule in the morning: no sorting, no pill chaos", "", ""], ["For days when portions are small and the good feeling of having thought of everything", "", ""], ["30 capsules = 30 days", "", ""]], "tplBalTiles": ["30 µg vitamin B12", "72 mg magnesium", "22 vitamins & minerals", "30 capsules"], "tplBalFaq": [["When do I take the capsule?", "Ideally in the morning: 1 capsule a day."], ["With or without food?", "Take the capsule with a meal and a glass of liquid."], ["Can I combine it with other supplements?", "If you already take other food supplements, check the total amounts of vitamins and minerals. If in doubt, ask your pharmacist or doctor."], ["How long does a tub last?", "A tub contains 30 capsules: at 1 capsule a day it lasts 30 days."], ["Is there a quantity discount or codes?", "Yes: from 2 pieces you save 5 %, from 3 pieces 10 %. Quantity discount and promo codes cannot be combined: the higher discount applies automatically per product."], ["How does the guarantee work?", "In 3 steps: order, test for 30 days, send an informal email to info@h2humans.com with your order number.", "/garantie"]], "tplBalFootnotes": ["¹ Vitamin B12 and magnesium may contribute to the reduction of tiredness and fatigue.", "² Vitamin D, zinc and selenium may contribute to the normal function of the immune system.", "Food supplements are not a substitute for a varied and balanced diet and a healthy lifestyle."], "deliveryLine": "Delivery in {time} · shipped from Germany", "tplSetOutcome": "So your basics are covered and you feel well looked after every day.", "tplBodyOutcome": "So your shake fits your routine even on days with little appetite.", "tplHydOutcome": "So drinking is no longer a to-do.", "tplBalOutcome": "So your daily capsule becomes a simple routine.", "seoTitleBody": "Daily Body-Care Protein Shake, for days with little appetite | H2HUMANS", "seoTitleHyd": "Daily Hydration Electrolyte Sticks: 30 days | H2HUMANS", "seoTitleBal": "Daily Balance Micronutrient Capsules: 30 days | H2HUMANS", "setBodyCareBenefit": "Protein, creatine and collagen in one shake.", "appDescPdp": "Your personal companion for routine, knowledge and motivation: in every phase.", "appFeature1Pdp": "Personal plan for every phase", "whyShakesTitle": "Why regular shakes don't fit.", "whyShakes": ["Large portions for big hunger.", "Protein alone, without creatine and collagen.", "Seven tubs instead of one."], "whyShakesClose": "That's why Daily Body-Care puts everything in one scoop.", "guideBonusTitle": "Free bonus: your 30-day routine guide.", "guideBonusBody": "With an intake plan, preparation, ideas for low-appetite days and a checklist to tick off.", "preparationVideoLabel": "Preparation video.", "claimNotesTitle": "Nutrient statements and sources.", "claimSourceLabel": "Source: EU Regulation 432/2012", "whyShakesDemand": "For guidance: the German Nutrition Society recommends around 0.8 g of protein per kilogram of body weight per day for adults, and around 1.0 g from age 65.", "whyShakesMetaphor": "A shake for a big appetite is like an overfilled plate: it often stays unfinished.", "whyHydTitle": "Why drinking often slips your mind.", "whyHydPoints": ["Fewer meals often mean fewer drinks alongside them.", "Without a fixed moment, it is easy to forget.", "A full bottle in your backpack is not yet a habit."], "whyHydClose": "That is why: one stick, one bottle, one fixed moment a day.", "whyBalTitle": "Why the basics often get overlooked.", "whyBalPoints": ["Smaller portions often mean less variety on your plate.", "Few people keep sorting six separate supplements for long.", "A cupboard full of vitamins is not yet a routine."], "whyBalClose": "That is why: one capsule, in the morning, ticked off."},
      shippingFaq: {"deliveryQ": "How fast is delivery?", "deliveryA": "We ship from Germany. The delivery time is {time}.", "costQ": "How much is shipping?", "costA": "Shipping costs {cost}. From {amount} in goods value (after discounts) we deliver free of charge. The Complete Set always ships free.", "title": "Shipping"},
      trustBar: {"label": "Benefits at a glance", "stripLabel": "Our promises", "setFree": "Complete Set always ships free", "qualityLabel": "Quality seals", "seals": ["Made in DE/AT", "GMP certified", "Non-GMO", "Lab tested"], "guarantee": "30-day money-back guarantee", "freeFrom": "Free shipping from {amount}", "delivery": "Delivery in {time}", "madeIn": "Made in DE/AT", "set": ["Daily Balance free", "Free shipping", "2 minutes a day", "Made in DE/AT"], "body": ["22.4 g protein per serving", "3 g creatine", "With organic whey protein", "No added sugar"], "hyd": ["Sodium, potassium, magnesium", "No added sugar", "30 sticks for 30 days", "Made in DE/AT"], "bal": ["22 vitamins & minerals", "1 capsule a day", "30 capsules for 30 days", "Made in DE/AT"], "card": {"bundle": "Daily Balance free", "body-care": "22.4 g protein", "hydration": "No added sugar", "balance": "1 capsule a day"}},
      trustLine: {"freeFrom": "Free shipping from {amount}", "setFree": "Set always ships free", "delivery": "Delivery in {time}", "guarantee": "30-day routine guarantee", "label": "Shipping and guarantee"},
      setMonthly3: "Or from {price} per month with the 3-month package",
      listing: {"bundleSubline": "3 products, 1 routine, 2 minutes a day: Daily Balance included free.", "bundleAlt": "Daily Routine Complete Set with Daily Body-Care, Daily Hydration and Daily Balance", "title": "Your GLP-1 Supplement System.", "subtitle": "Three coordinated products for every phase of your therapy: individually or as a complete system.", "bestseller": "RECOMMENDED", "allProducts": "All products", "saveVsSingle": "You save {amount} compared to buying separately", "singlesTitle": "Individual products", "listLabel": "Products", "faqTitle": "Questions about", "faqTitleEm": "ordering.", "faq": [["How can I pay?", "You can pay by {payMethods}. Payment is processed securely via Stripe."], ["How do I redeem a promo code?", "Enter the code on the order page before payment. New-customer codes apply to your first order, loyalty codes from our Founding Members to every reorder. One code per order, not combinable with the quantity discount or the set price: the higher discount applies automatically."]]},
      affiliate: {"welcome": "Great to have you here via {name}. Your 20 % discount on individual products is active. The Complete Set is already reduced, with Daily Balance included free.", "close": "Close notice", "admin": {"title": "Partner report.", "loginTitle": "Sign in.", "loginHint": "We will send you a login link by e-mail.", "email": "E-mail address", "send": "Send login link", "sent": "Link sent. Check your inbox.", "denied": "No access with this account.", "logout": "Sign out", "period": "Period", "thisMonth": "This month", "lastMonth": "Last month", "custom": "Custom period", "dateFrom": "From", "dateTo": "To", "partner": "Influencer", "all": "All", "none": "Without influencer", "orders": "Orders", "net": "Net revenue", "set": "Set", "singles": "Individual products", "first": "First purchases", "reorders": "Reorders", "viaLink": "Via link", "viaCode": "Via code", "refunds": "Refunds", "commission": "Commission", "csv": "Export CSV", "backfill": "Import past orders", "backfillDone": "{n} orders imported.", "colOrder": "Order number", "colDate": "Date", "colKind": "Type", "colType": "First/Reorder", "colProducts": "Products", "colDiscount": "Discount", "colRefunded": "Refunded", "testOrder": "Test order · no commission", "colCustomer": "Customer", "link": "Link", "code": "Code", "firstOne": "First purchase", "reorder": "Reorder", "yes": "yes", "no": "no", "empty": "No orders in this period.", "netHint": "Net revenue: paid product value after discount, excluding shipping and VAT (rate by delivery country). Test orders are excluded from partner revenue and, like refunded orders, earn no commission."}},
    },
    // Header
    nav: {
      howItWorks: "How it works",
      benefits: "Benefits",
      trust: "Trust",
      products: "Products",
      science: "Quality",
      experts: "Experts",
      app: "App",
      about: "About",
      blog: "Guide",
      community: "Community",
      shopCta: "Shop now",
      openMenu: "Open navigation menu",
      closeMenu: "Close navigation menu",
      primaryNavLabel: "Primary navigation",
      mobileNavLabel: "Mobile navigation",
      homeLabel: "H2HUMANS home",
    },
    langToggle: "DE",

    // Hero
    hero: {
      beActiveSection: {"filmLabel":"FROM THE COMMUNITY","videoAlt":"BE ACTIVE campaign film with Angelika at HYROX","eyebrow":"FOUNDING MEMBER · HYROX KARLSRUHE · 04.10.2026","title":"BE ACTIVE!","sub1":"Get strong.","sub2":"Stay strong.","body":"Angelika isn't a pro. She has a job, everyday life and a routine that fits into it. How she prepares for HYROX, what she eats on race day and why recovery is part of the plan: she shows it honestly and unfiltered.","stats":[{"v":"8 km","l":"Running"},{"v":"8","l":"Stations"},{"v":"1","l":"Routine behind it"}],"chapters":["01 Preparation","02 Race Day","03 Recovery"],"ctaStory":"Watch Angelika's story","ctaShop":"Her routine in the shop","newTab":"(opens in new tab)","nextStop":"Next stop: HYROX Frankfurt · 13.12.2026"},
      beActiveLanding: {"metaTitle":"BE ACTIVE! HYROX for regular people: Angelika's road to the finish | H2Humans","metaDescription":"Preparation, race day and recovery: how H2Humans founding member Angelika ran HYROX Karlsruhe, with training week, race-day plan and her routine.","eyebrow":"H2HUMANS × ANGELIKA · HYROX KARLSRUHE · 04.10.2026","sub1":"HYROX for regular people.","sub2":"Angelika's road to the finish.","body":"No pro, no miracle cure. A job, everyday life and a routine that fits in. Angelika shows you everything in three chapters: how she trained, what she ate on race day and why six days of rest afterwards are part of the plan.","filmLink":"Full film on Instagram ▸","chooseChapter":"Choose your chapter","chapters":[{"n":"01","title":"Preparation","sub":"Training week & race week","alt":"Angelika training for HYROX"},{"n":"02","title":"Race Day","sub":"Hour by hour","alt":"Angelika on race day at HYROX Karlsruhe"},{"n":"03","title":"Recovery","sub":"The days after","alt":"Angelika recovering after the race"}],"routineTab":"Angelika's routine","navLabel":"Chapter navigation","communityBack":"← Community","communityMore":"Meet more founding members →"},
      beActivePrep: {"eyebrow":"CHAPTER 01 · PREPARATION","h1":"A normal week.","h2":"No pro plan.","imgAlt":"Angelika doing sandbag lunges in class","imgLabel":"TRAINING IN CLASS · NO PERSONAL COACH","intro":"Angelika didn't rebuild her life for HYROX. She built a week that works alongside her job and everyday life, and that she could stick to week after week.","week":[{"v":"1×","l":"Strength training"},{"v":"1–2×","l":"HYROX workout in class"},{"v":"2×","l":"Running: zone 2 + intervals"},{"v":"1–2","l":"real rest days"}],"dailyTitle":"Everyday life","dailyText":"Protein always in focus, electrolytes during training, 6–7 hours of sleep.","rwTitle1":"Race week.","rwTitle2":"What changes, what stays.","rwSource":"From Angelika's race-week plan","rw":[{"label":"5–3 DAYS BEFORE","title":"No carb-loading yet","text":"Don't cut carbs, keep eating protein, stay normal and balanced, drink enough.","alt":"Porridge with fruit"},{"label":"2–1 DAYS BEFORE","title":"Carbs take centre stage","text":"Pasta, rice, potatoes, bread, fruit. Deliberately more, but not until you burst.","alt":"Plate of pasta"},{"label":"EVERY DAY","title":"Drink regularly","text":"Not three litres at once on race morning. Electrolytes can make sense depending on the situation. Goal: well hydrated at the start line, not with a water belly.","alt":""},{"label":"MOVEMENT","title":"Stay loose","text":"A walk, easy cycling, mobility, maybe a very easy run. Nothing that makes your legs ask the next day: \"What was that about?\"","alt":""}],"productLabel":"IN ANGELIKA'S PREPARATION · ADVERTISEMENT","howLead":"How Angelika uses it:","howText":"Protein always in view, in her overnight oats in the morning or as a shake after training.","unit":"Unit price: {price} / kg · incl. VAT","next":"Continue to chapter 02: Race Day"},
      beActiveRace: { eyebrow: 'CHAPTER 02 · RACE DAY · 04.10.2026', h1: 'Her race-day plan.', h2: 'Hour by hour.', steps: [{ time: '3–4 H BEFORE', title: 'The last bigger meal', text: 'Easily digestible carbs, a moderate amount of protein, rather little fat and fibre. For Angelika: porridge or overnight oats with Daily Body-Care and fruit. Alternatives: rice, toast, banana.' }, { time: 'UNTIL THE START', title: 'Drink regularly, warm up easy', text: 'Water plus electrolytes in small sips. Warm-up on the bike and rower.' }, { time: '15–30 MIN BEFORE', title: 'A small energy boost', text: 'Fast carbs: banana, fruit purée, rice cake with honey or a gel. But only what has already been tested in training.' }, { time: 'IN THE RACE', title: '8 × 1 km running, 8 stations', text: 'SkiErg, Sled Push, Sled Pull, Burpee Broad Jumps, Rowing, Farmers Carry, Sandbag Lunges, Wall Balls.' }, { time: 'AT THE FINISH', title: 'Refuel first, then celebrate', text: 'Fluids and electrolytes with Daily Hydration, then a Daily Body-Care shake.' }], ruleLabel: "ANGELIKA'S MOST IMPORTANT RULE", rule: 'Nothing new on race day.', alts: ['Angelika in front of the HYROX wall', 'Angelika doing wall balls', 'Angelika on the rower', 'Angelika doing the farmers carry', 'Angelika running across the finish line'], productLabel: 'THERE ON RACE DAY · ADVERTISEMENT', howText: 'in training, before the start and first thing at the finish.', next: 'Continue to chapter 03: Recovery' },
      beActiveRecovery: { eyebrow: 'CHAPTER 03 · RECOVERY', h1: '6 days.', h2: 'No training.', imgAlt: 'Angelika relaxing after the race', quote1: '"My body has just done something incredible.', quote2: 'Now I get to take care of it."', intro: "Recovery isn't a lost training day, it's the reason you keep going. Walks, massage and stretching are a fixed part of Angelika's plan.", tips: [{ title: 'Drink first', text: 'After more than 60 minutes of effort, you are low on fluids. Not litres at once, but regularly over the next hours, electrolytes included.' }, { title: "Don't skimp on food now", text: 'Carbs refill the stores, protein for muscle recovery, plus fruit and vegetables. No "reward diet", but no "now I go wild" either.' }, { title: 'Movement yes. Strain no.', text: 'A walk, gentle mobility, feet up and plenty of sleep. Wiped out the morning after? Totally fine.' }], dontLabel: "WHAT ANGELIKA DOESN'T DO AFTER HYROX", dont1: '', dontEm: 'Punish', dont2: 'her body for going all out.', donts: ['"Burning off" calories', 'Cutting back on food', 'Going full throttle straight away', 'Harder training "to make up for it"'], productLabel: "IN ANGELIKA'S RECOVERY · ADVERTISEMENT", productAlt: 'Daily Body-Care shake after the race', productQuote: '"After HYROX I\'m not in the mood for complicated."', textBefore: 'That is why, after the race, she has a', textBold: 'Daily Body-Care shake', textAfter: 'ready: mix, drink, done.' },
      beActiveRoutine: {"eyebrow":"ANGELIKA'S ROUTINE · ALL THREE CHAPTERS","h1":"One routine.","h2":"From training to recovery.","intro":"Three products that accompanied Angelika through preparation, race day and recovery.","bestseller":"RECOMMENDED","label":"ANGELIKA'S COMPLETE ROUTINE","text":"Daily Body-Care, Daily Balance and Daily Hydration in one set: everything that appears in the three chapters.","lines":["Preparation: Daily Body-Care & Daily Balance","Race day: Daily Hydration","Recovery: Daily Body-Care shake"],"vat":"incl. VAT · Free shipping from {amount}","singleLabels":{"body-care":"MULTI-FORMULA · CHAPTER 01 + 03","balance":"MICRONUTRIENT COMPLEX · EVERY DAY","hydration":"ELECTROLYTE FORMULA · CHAPTER 02"},"addToCart":"Add to cart","disclaimer":"Advertisement: Angelika is a founding member of H2Humans. Shown is her personal routine, not a general or medical recommendation. Food supplements are not a substitute for a varied, balanced diet and a healthy lifestyle."},
      headline: "The first wellbeing protocol for GLP-1.",
      subheadline:
        "The H2HUMANS System, designed by experts for everyday life on GLP-1, brings together the app, digital guidance through Your +1 and scientifically developed supplements.",
      trustLine: "Science based and built with experts.",
      supportingCopy:
        "Built by experts for your everyday life on GLP-1. The app, Your +1 AI companion and complementary, science based supplements come together as one system.",
      ctaPrimary: "Secure Early Access now",
      ctaPrimaryHeader: "Early Access",
      earlyAccessNote:
        "We are launching the H2HUMANS System with a small founding group of GLP-1 users, so we can build it the right way together. The waitlist secures your spot in the first group.",
      headlineLine1: "The weight goes.",
      headlineLine2: "The feeling stays.",
      body: "H2Humans supports you through everyday life on a weight-loss injection: reducing, pausing and stopping. For your strength, your routines and that very feeling.",
      ctaPrimaryApp: "Try the app for free",
      ctaMicro: "Early access · free · no obligation",
      ctaShop: "Go to shop",
      intro:
        "Germany's first GLP-1 support system, scientifically developed to support your body during therapy and beyond: preventively and in the long term.",
      badges: {
        labTested: "Lab tested",
        gmpCertified: "GMP certified",
        nonGmo: "Non-GMO",
        madeInGermany: "Made in DE/AT",
      },
      scienceLink: "The science →",
    },

    // Is This For Me Section
    isThisForMe: {
      title: "Does this sound familiar?",
      items: [
        "You just started GLP-1 and feel uncertain",
        "Therapy changes your everyday life: smaller portions, a different rhythm, new questions",
        "You notice emotional changes you cannot quite place",
        "You want clear answers, not medical jargon",
        "You do not want to go through this alone",
      ],
      notFor: "",
    },

    // Problem Section
    problem: {
      title: "You are on the path of change,\nbut energy, digestion and mood are lagging behind.",
      subtitle: "",
      items: [
        {
          title: "SMALL APPETITE",
          stat: "",
          description: "Less hunger often means less protein, less drinking, fewer micronutrients.",
        },
        {
          title: "FEELING LOST",
          stat: "68 %",
          description: "feel left alone in everyday life with therapy, without clear guidance.",
        },
        {
          title: "DROPOUT & DOUBT",
          stat: "> 50 %",
          description: "stop therapy early or doubt their path, often because support is missing.",
        },
        {
          title: "EMOTIONAL SHIFT",
          stat: "> 50 %",
          description: 'report mood swings, irritability or the feeling of being "beside themselves".',
        },
      ],
      conclusion: "",
      bridge: "",
      cta: "",
    },

    // Solution Section
    solution: {
      title: "Your +1, your daily companion during GLP-1 therapy.",
      titleOverride: "Your +1 for everyday life on GLP-1.",
      subtitle:
        "Your personal support system for the moments when GLP-1 therapy alone is hard to manage.",
      betaNote: "App in beta status, available free of charge.",
      items: [
        "Personalised support at every stage of your GLP-1 therapy",
        "Evidence based recommendations, explained in clear language",
        "Supplement routine matched to your phase",
        "Your AI companion gives you emotional support and helps you understand changes",
        "Always practical. Always human. Always clear.",
      ],
    },

    // Benefits Section
    benefits: {
      title: "What changes for you.",
      subtitle: "Less friction, more clarity, at your own pace.",
      items: [
        {
          title: "More confidence",
          description: "Clear guidance and understandable knowledge for every phase.",
        },
        {
          title: "Less stress",
          description: "Calm support instead of an information overload.",
        },
        {
          title: "Clearer orientation",
          description: "Understand what is happening, and why.",
        },
        {
          title: "Sustainable routines",
          description: "Small, doable steps for long term success.",
        },
        {
          title: "Emotional support",
          description: "You are not alone, we are here.",
        },
      ],
    },

    // How It Works Section
    howItWorks: {
      title: "How Your +1 supports you every day.",
      subtitle: "Your +1 adapts to your day.\nHow you feel decides what you need.",
      steps: [
        {
          number: "01",
          title: "Arrive",
          description: "Your +1 understands your situation with a short introduction to your everyday life.",
        },
        {
          number: "02",
          title: "Stay on track",
          description: "Reminders, small nudges and routines that fit your day.",
        },
        {
          number: "03",
          title: "Move forward",
          description: "Support that evolves with you, step by step.",
        },
      ],
      moodIntro: "Every day feels different. Your +1 responds to that.",
      scenarios: [
        {
          title: "TOUGH MORNING",
          mood: "Tired, uncertain, unmotivated",
          responses: [
            "Gentle start without pressure",
            "Find out what you need today",
            "Simple steps for more energy",
          ],
        },
        {
          title: "BUSY DAY",
          mood: "Active but mentally overloaded",
          responses: [
            "Do not forget your breaks",
            "Spot overload early",
            "Keep meals and supplements in view",
          ],
        },
        {
          title: "RESTLESS EVENING",
          mood: "Irritated, exhausted, restless",
          responses: ["Take time for yourself", "Reflect on what helped today", "Wind down and sleep well"],
        },
      ],
    },

    // What Happens Next Section
    whatHappensNext: {
      title: "What happens after sign-up?",
      signupTitle: "What happens after your non-binding sign-up?",
      signupSubtitle: "Three simple steps and you are in.",
      signupSteps: [
        {
          title: "Email confirmation",
          description: "You receive an instant confirmation. Your spot is reserved.",
        },
        { title: "Early Access invitation", description: "As soon as we launch, you are among the first to get access." },
        {
          title: "Meet Your +1",
          description: "Short onboarding, then your personal companion is ready for you.",
        },
      ],
      dataPrivacyTooltip: {
        title: "Your data belongs to you",
        description: "GDPR compliant. No data sharing. Full control.",
      },
      steps: [
        {
          number: "1",
          title: "Email confirmation",
          description: "You receive an instant confirmation and know that your spot is reserved.",
        },
        {
          number: "2",
          title: "Early Access invitation",
          description: "As soon as we launch, you are among the first to get access.",
        },
        {
          number: "3",
          title: "Meet Your +1",
          description: "Short onboarding, then your personal companion is ready for you right away.",
        },
      ],
    },

    // Founding Member Section
    foundingMember: {
      title: "Be part of it from the start",
      subtitle: "Secure early access, free and before the official launch.",
      benefits: [
        "30 day free trial",
        "No upfront payment",
        "Cancel any time",
        "Limited spots available",
      ],
      cta: "Start for free",
    },

    // Trust Section
    trust: {
      title: "Built on trust. Backed by science.",
      items: [
        {
          title: "Science based",
          description: "Our recommendations are based on current GLP-1 research.",
        },
        {
          title: "Your data belongs to you",
          description: "GDPR compliant. No data sharing. Full control.",
        },
        {
          title: "No health claims. Just honest support.",
          description: "H2HUMANS is a wellbeing companion, not a medical device. We make no health claims.",
        },
      ],
      disclaimer:
        "Your +1 is a wellbeing companion from H2HUMANS, not a medication, and it does not replace medical advice.",
      expertsTitle: "What experts say about Your +1",
      experts: [
        {
          name: "Anna Pereira, PhD, MS",
          title: "Embodied Cognition · Behavioural Science · Mind-Body Research",
          quote:
            "Your +1 combines scientific depth with real everyday usability. The focus on mood, self-awareness and routines shows how important it is not to optimise people, but to support them.",
          website: "actincycle.com",
        },
        {
          name: "Johannes Weiss",
          title: "Longevity & Performance · Health Strategies · Practical Prevention",
          quote:
            "What convinces me about Your +1 is the structured, responsible approach. Instead of quick fixes, it focuses on orientation, prevention and sustainable routines, exactly what many people miss in everyday life.",
          website: "longevity-wien.at",
        },
      ],
    },

    // Privacy Block
    privacy: {
      title: "Your data stays human.",
      items: [
        "Your data is never sold",
        "You decide what is stored",
        "No medical diagnoses",
        "Guidance complements, it does not replace doctors",
      ],
    },

    // Sticky Banner
    stickyBanner: {
      ticker: {
        label: "News",
        newArticleKey: "New in the Guide",
        newArticleRest: ": Preserving muscle mass after stopping",
        articlesKey: "{count} articles",
        articlesRest: " scientifically grounded in the Guide",
        qualityRest: "Lab tested · GMP certified · Made in DE/AT",
        appKey: "Try the app for free",
        appRest: ": Early Access",
        pause: "Pause",
        play: "Play",
      },
      guideTeaser: "New in the guide: Maintaining muscle mass after stopping",
    },

    // Newsletter Section
    newsletter: {
      title: "A healthier tomorrow",
      titleEm: "starts today.",
      description: "15% off your first order: plus insider updates and GLP-1 research straight to your inbox.",
      discountHighlight: "15% off your first order",
      descriptionRest: "plus insider updates and GLP-1 research straight to your inbox.",
      placeholder: "your@email.com",
      submitting: "Submitting...",
      submit: "Get 15%",
      success: "Thank you, you are on the waitlist.",
      error: "Something went wrong. Please try again.",
      note: "No spam. Unsubscribe any time.",
      consentPrefix: "By subscribing you agree to our ",
      consentLink: "Privacy Policy",
      consentSuffix: ".",
      finePrint: "Valid for your first order. Cannot be combined with other discount codes.",
      finePrintPartner: "Exclusive discounts via our partners may be higher.",
      pendingTitle: "Almost there!",
      pendingBody: "We sent you an email. Please confirm your signup to receive your 15% code.",
      resend: "No email received? Send again",
      resending: "Sending again...",
      resent: "Email sent again.",
      resendWait: "Please wait a moment before trying again.",
      alreadyConfirmed: "This email is already signed up with us.",
      confirmedTitle: "Confirmed!",
      confirmedBody: "Your code is on its way. Check your inbox for your 15% discount code.",
      confirmedCta: "Go to shop",
      failedTitle: "Link invalid or expired.",
      failedBody: "This confirmation link was already used or has expired. Simply sign up again.",
      failedCta: "Sign up again",
      popupClose: "Close",
      popupTitle: "15% off your",
      popupTitleEm: "first order.",
      popupSentence: "Plus insider updates and GLP-1 research straight to your inbox.",
      popupSuccess: "Almost there. Please confirm your email.",
    },


    // Promise Section
    promise: {
      title: "Quality you can ",
      titleEm: "see and verify.",
      subtitle: "Every ingredient in a clinically studied dosage. No fillers, no shortcuts.",
      moleqlarTitle: "Developed with MoleQlar",
      moleqlarBody1:
        "Our supplements were developed together with the scientists at MoleQlar, a leading German company in longevity and molecular health research.",
      moleqlarBody2:
        "The formulations are based on current scientific evidence and are developed and produced according to the highest quality standards. That is how we ensure every H2HUMANS product is science based, transparent and uncompromisingly high quality.",
      tags: ["GMP", "IFS Food", "ISO 22000", "HACCP"],
    },

    // Journal Section
    journal: {
      titleEm: "Our story",
      titleSuffix: "behind H2Humans.",
      subtitle: "Deep dives into GLP-1 research, performance nutrition, life hacks and the people behind H2Humans.",
      heading: "Why we founded H2Humans.",
      body1:
        "H2Humans grew out of our own experiences with GLP-1 therapy, as well as countless conversations with friends, family, physicians and people on the journey.",
      body2:
        "Millions of people regain control over their weight for the first time thanks to GLP-1 medications. Yet the real challenge often begins afterwards. Many feel left alone when it comes to nutrition, nutrient supply, muscle health and long term weight maintenance.",
      body3:
        "We believe lasting success requires more than a prescription. That is why we are building H2Humans: a science based system of products, knowledge and guidance that helps people move through their GLP-1 journey with awareness, success and health.",
      body4:
        "With a global community of soon more than 200 million GLP-1 users, we see the opportunity to solve one of the greatest health challenges of our time, so that short term weight loss becomes long term health.",
      learnMore: "Learn more",
      aboutImageAlt: "H2Humans about us",
    },

    // App Section
    app: {
      betaBadge: "Free BETA Version",
      earlyAccessBadge: "Early Access Version 0€",
      title: "Your +1 for everyday life on ",
      titleEm: "GLP-1.",
      description:
        "Your personal support system for the moments when GLP-1 therapy alone is hard to manage.",
      screenHomeAlt: "H2Humans app: home screen",
      screenProgressAlt: "H2Humans app: progress",
      features: [
        { title: "Personalised support at every stage of your GLP-1 therapy", body: "" },
        { title: "Evidence based recommendations, explained clearly", body: "" },
        { title: "Supplement routine matched to your phase", body: "" },
        { title: "Your AI companion gives emotional support and helps you understand changes better", body: "" },
        { title: "Always practical. Always human. Always clear.", body: "" },
      ],
    },

    // Science Section
    science: {
      title: "Built on science. Guided by ",
      titleEm: "experience.",
      subtitle:
        "Two trusted partners. One shared mission:\nmaking evidence based health more accessible through scientific expertise, premium formulations and practical guidance for everyday life.",
      learnMore: "Learn more",
      back: "Back",
      next: "Next",
      moleqlarTags: ["GMP", "ISO/IEC 17025", "HACCP", "Lab tested"],
      experts: [
        {
          badge: "Trusted Supplement Partner",
          name: "MoleQlar",
          role: "Physician founded · Berlin/Munich · ISO/IEC 17025",
          backRole: "Physician founded · Germany & Austria",
          backItems: [
            "Founded by three physicians",
            "Every batch independently lab tested",
            "Produced in certified German and Austrian facilities",
            "More than 100,000 customers across Europe",
            "Science driven quality and transparency",
          ],
          credentials: ["Quality Assurance", "Longevity Science", "Evidence-Based Formulation"],
          alt: "MoleQlar supplement partner presentation",
        },
        {
          badge: "Health Ambassador",
          name: "Nuriel Molcho",
          role: "Health · Nutrition · Sport",
          backRole: "Health · Nutrition · Sport",
          backItems: [
            "Co-founder of the NENI restaurant group",
            "Advocate of nutrition, movement and healthy living",
            "Passionate about longevity and performance",
            "Supports the H2Humans mission to bring wellbeing into everyday life",
          ],
          credentials: ["Healthy Lifestyle", "Nutrition", "Performance"],
          alt: "Portrait of Nuriel Molcho",
        },
      ],
    },

    // Principles Section
    principles: {
      title: "What we ",
      titleEm: "stand for.",
      subtitle: "Everything we build is grounded in science, transparency and real everyday usefulness.",
      items: [
        {
          number: "01",
          title: "Built with intent and impact",
          body: "Every product solves a clearly defined, evidence based problem. No supplement without a clinically sound reason.",
        },
        {
          number: "02",
          title: "Clinically studied dosages",
          body: "We dose by the science. Bioactive forms instead of cheaper alternatives.",
        },
        {
          number: "03",
          title: "Manufactured to GMP standards in Germany and Austria",
          body: "",
        },
        {
          number: "04",
          title: "We use it ourselves",
          body: "No product we would not take ourselves every day. Our toughest quality filter.",
        },
      ],
    },

    // FAQ Section
    faq: {
      title: "Frequently asked questions.",
      items: [
        {
          icon: "help",
          tone: "neutral",
          question: "Is H2HUMANS a medication?",
          answer: [
            {
              type: "paragraph",
              text: "No. H2HUMANS is a wellbeing companion, not a medication. We do not replace medical advice. Always consult your doctor before taking supplements.",
            },
          ],
        },
        {
          icon: "clock",
          tone: "positive",
          question: "How long does it take to see results?",
          answer: [
            {
              type: "paragraph",
              text: "Our guidance protocol is designed to support changes in a structured way and to make them measurable. First effects can appear within the first few weeks. For a sound assessment we recommend at least 3 months.",
            },
          ],
        },
        {
          icon: "shield",
          tone: "positive",
          question: "Are the supplements safe?",
          answer: [
            { type: "paragraph", text: "All of our supplements are:" },
            {
              type: "list",
              items: ["Made in DE/AT", "Lab Tested", "GMP Certified", "Non-GMO", "Developed with experts"],
            },
            { type: "paragraph", text: "We work only with the highest quality standards." },
          ],
        },
        {
          icon: "bot",
          tone: "caution",
          question: "How does Your +1 work?",
          answer: [
            { type: "paragraph", text: "Your +1 is an AI companion that gives you personalised recommendations." },
            {
              type: "list",
              heading: "Your +1 is NOT:",
              headingColor: "coral",
              items: [
                "A therapist (we do not replace professional help)",
                "A doctor (we do not give medical advice)",
              ],
            },
            {
              type: "list",
              heading: "Your +1 IS:",
              headingColor: "green",
              items: [
                "A companion (emotional support)",
                "A coach (practical tips)",
                "Available 24/7 (always there for you)",
                "Built on a purely scientific basis and draws only on knowledge from well founded publications and sources",
              ],
            },
          ],
        },
        {
          icon: "trending",
          tone: "positive",
          question: "Does this really work?",
          answer: [
            { type: "paragraph", text: "That depends on you. H2HUMANS works best when you:" },
            {
              type: "list",
              items: [
                "Take the supplements regularly",
                "Use the app every day",
                "Follow Your +1 recommendations",
                "Stay patient",
              ],
            },
          ],
        },
        {
          icon: "mail",
          tone: "neutral",
          question: "How can we get in touch with H2HUMANS?",
          answer: [
            {
              type: "paragraph",
              text: "Send us an email at info@h2humans.com and we will get back to you as soon as possible.",
            },
          ],
        },
      ],
    },

    // Supplement Value Comparison
    supplementComparison: {
      headline: "Orientation instead of",
      headlineAccent: "overwhelm",
      subline: "One coordinated system, designed for your body,\nyour goals and your life.",
      chaosLabel: "WITHOUT A SYSTEM",
      chaosPoints: [
        "Too many products,\nno overview",
        "Unclear dosing and\nwrong timing",
        "Not adapted to\nGLP-1",
        "Contradictory\ninformation",
        "Lots of effort,\nno consistency",
      ],
      chaosBottom: "Uncertainty · Overwhelm · no progress",
      systemLabel: "WITH H2HUMANS",
      systemWith: "With",
      systemPoints: [
        "One coordinated system\ninstead of single products",
        "Clear dosing and\noptimal timing",
        "Built specifically for\nGLP-1 therapy",
        "Science based",
        "App, supplements and\nYour +1 included",
      ],
      systemBottomPrefix: "Clarity · Structure · ",
      systemBottomAccent: "real results",
      trustBadges: [
        { label: "Made in DE/AT", sub: "Highest quality" },
        { label: "Non GMO", sub: "No genetic engineering" },
        { label: "Gluten free", sub: "Well tolerated" },
        { label: "GMP Certified", sub: "Certified manufacturing" },
        { label: "Lab Tested", sub: "Independently verified" },
      ],
    },

    // 404 Not Found
    notFound: {
      seoTitle: "404 | Page not found | H2HUMANS",
      seoDescription: "The page you were looking for could not be found.",
      code: "404",
      heading: "Oops! Page not found",
      homeLink: "Back to home",
      body: "This page does not exist (anymore). Maybe one of these helps:",
      blogLink: "To the Guide",
      shopLink: "To the shop",
    },

    // Unsubscribe page
    unsubscribe: {
      seoTitle: "Unsubscribe | H2HUMANS",
      seoDescription: "Manage your email subscription preferences.",
      loading: "Processing…",
      successTitle: "Successfully unsubscribed",
      successBody: "You have been successfully unsubscribed from future marketing emails.",
      errorTitle: "Unsubscribe failed",
      errorBody: "The unsubscribe link is invalid or has expired.",
      back: "Back to home",
    },

    // Email Unsubscribe page
    emailUnsubscribe: {
      title: "Unsubscribe from emails",
      intro: "Do you want to unsubscribe from H2HUMANS emails?",
      confirm: "Confirm unsubscribe",
      success: "You have been successfully unsubscribed.",
      already: "This email is already unsubscribed.",
      error: "The link is invalid or has expired.",
      back: "Back to home",
      loading: "Processing…",
    },

    // Checkout Return page
    checkoutReturn: {
      title: "Payment successful!",
      body: "Thank you for your order. You will receive a confirmation by email shortly.",
      back: "Back to home",
      emailSending: "Sending confirmation email…",
      emailSent: "Confirmation email has been sent.",
      emailError: "Confirmation email could not be sent. For questions please contact info@h2humans.com.",
      orderLabel: "Order number:",
      orderReference: "Please include this order number in any follow up.",
      guideTitle: "Your 30-day routine guide.",
      guideBody: "With an intake plan, preparation, ideas for low-appetite days and a checklist to tick off.",
      guideCta: "Open routine guide",
      nextOrderTip: "Tip for your next order: Daily Balance is included free in the Daily Routine Complete Set.",
    },
    setValue: {"needTitle": "Smaller portions. Mindful supplementation.", "need": ["Less appetite may come with smaller meals and changes in fluid intake. Appropriate supplementation depends on your diet and individual needs.", "Daily Body-Care combines protein, creatine and collagen in one shake. Preparation and serving size are listed in the recommended directions for use.", "And five separate tubs without a plan rarely last in everyday life."], "needClose": "That's why we turned three products into one routine.", "needCta": "Choose your package", "costTitle": "Bought separately vs. Complete Set.", "costSub": "What the included components would cost separately for 30 days.", "costCols": ["Component", "Amount per serving", "Separately*"], "costExtra": [{"name": "Electrolyte mix (Daily Hydration)", "benefit": "1 stick", "competitor": "~€30"}, {"name": "Micronutrient base (Daily Balance)", "benefit": "1 capsule", "competitor": "~€15"}], "costTotal": "Total of single components", "costTotalValue": "~€173", "costSet": "Complete Set from €84.90", "costSetNote": "per month in the 3-month package", "vsTitle": "Complete Set vs. alternatives.", "vsCols": ["Complete Set", "Regular protein shake", "Single supplements"], "vsRows": [["Protein + creatine + collagen in one serving", 1, 0, 0], ["Electrolytes on the go", 1, 0, 1], ["Micronutrient base", 1, 0, 1], ["Plan per phase in the app", 1, 0, 0], ["GMP & Made in DE/AT", 1, 2, 2], ["One order instead of five", 1, 1, 0]], "vsYes": "Yes", "vsNo": "No", "vsVaries": "Depends on product", "vsNote": "Comparison with typical product categories, not with individual providers.", "needDemand": "For general guidance: the German Nutrition Society (DGE) recommends around 0.8 g of protein per kilogram of body weight per day for adults, and around 1.0 g from age 65.", "needSourceLabel": "Source: DGE reference values for protein", "needMetaphor": "A shopping list with five products is not yet a plan. The Daily Routine is the weekly plan that goes with it."},
    threeStep: {"title": "How the 3-step method™ works.", "steps": [["Morning", "Daily Balance", "1 capsule: your micronutrient base."], ["During the day", "Daily Hydration", "1 stick in your bottle: electrolytes on the go."], ["Afternoon", "Daily Body-Care", "1 shake in 30 seconds, with protein, creatine and collagen."]], "stepLabel": "Step {n}", "app": "You get the right plan for your phase in the app.", "tlTitle": "Your first 30 days.", "tl": [["Day 1", "Unpack your set, open the routine guide."], ["Day 3", "The routine finds its place."], ["Day 14", "Runs without thinking."], ["Day 30", "Reorder or use the guarantee."]], "compactTitle": "Part of the 3-step method™.", "compactCurrent": "This product", "compactCta": "All three in the Complete Set"},
    routineGuide: {"seoTitle": "30-day routine guide | H2HUMANS", "seoDesc": "With an intake plan, preparation, ideas for low-appetite days and a checklist to tick off.", "eyebrow": "Daily Routine", "title": "Your 30-day routine guide.", "intro": "One product or all three: this guide helps you set up your routine over the first 30 days.", "pdf": "Save as PDF", "pdfHint": "Choose “Save as PDF” in the print dialog.", "planTitle": "Intake plan.", "plan": [["Morning: Daily Balance", "1 capsule with a glass of water, ideally with breakfast or your first meal."], ["During the day: Daily Hydration", "1 stick in your first water bottle of the day. Finish it over the morning or on the go."], ["Afternoon: Daily Body-Care", "1 shake as a fixed slot, e.g. as a snack between lunch and dinner or after training."]], "planNote": "This is a suggestion. If another time suits your day better, use it. What matters is that it stays the same every day.", "prepTitle": "Preparation.", "prep": [["Daily Body-Care", "Add 1 scoop to 300 ml cold water, milk or plant drink and shake vigorously for 15 seconds. Tastes fresher with ice cubes."], ["Daily Hydration", "Add 1 stick to a bottle of cold water and shake briefly. More water makes the taste milder."], ["Daily Balance", "Swallow 1 capsule whole with enough liquid."]], "lowTitle": "Ideas for low-appetite days.", "low": [["Start small", "Sip the shake slowly over 20 to 30 minutes instead of all at once."], ["Split it", "Prepare the shake with a little more liquid and drink one half in the afternoon, the other in the early evening."], ["Vary it", "Mix the shake with an espresso for a mocha shake, or blend it with a few ice cubes and half a banana."], ["Cold helps", "Chilled, shake and drink often taste more pleasant when eating feels hard."]], "lowNote": "If your appetite stays very low for a longer time, talk to your doctor.", "drinkTitle": "Drink reminder.", "drink": [["Make it visible", "Put your bottle with the hydration stick where you see it all day: desk, kitchen, bag."], ["Pair it", "Link each bottle to a fixed moment, e.g. starting work, lunch break, commute home."], ["Get reminded", "Set a phone alarm for the first two weeks or use the reminders in the H2HUMANS app."]], "checkTitle": "Weekly checklist.", "week": "Week {n}", "weeks": [["Set up", "Fix your three times and put the products where you need them."], ["Consolidate", "Same times, every day. If a slot doesn't fit, move it, but don't skip it."], ["Keep going", "Watch your water bottle. Is it empty by the afternoon?"], ["Review", "What worked well, what do you want to change? Your set lasts a few more days. Plan your refill."]], "days": ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], "checks": ["Balance", "Hydration", "Body-Care"], "checkLabel": "{item}, week {n}, {day}", "reorder": "Reorder in time: the 2- or 3-month package saves you the most per set.", "reorderCta": "Go to the Complete Set", "guarantee": "Routine doesn't fit your everyday life? Our 30-day routine guarantee applies from delivery.", "guaranteeLink": "View guarantee", "legal": "Food supplements are not a substitute for a varied, balanced diet and a healthy lifestyle. Do not exceed the stated recommended daily intake. Keep out of reach of young children. If you take medication, are pregnant or breastfeeding, talk to your doctor before use."},
    shippingPage: {"and": "and", "metaTitle": "Shipping Policy | H2HUMANS", "metaDesc": "Shipping with H2HUMANS: {cost} per order, free from {amount} in goods value, the Complete Set always ships free. Delivery within Germany in {time}.", "back": "Back to homepage", "title": "Shipping Policy", "tableTitle": "Shipping Costs & Delivery Times", "colCountry": "Country", "colCost": "Shipping Costs", "colTime": "Delivery Time", "rowCost": "{cost} ({carrier}) · free from {amount} in goods value", "countries": {"DE": "Germany", "AT": "Austria"}, "bundleNote": "We always ship the Daily Routine Complete Set free of charge.", "basisNote": "The goods value after discounts (quantity discount, discount codes), excluding shipping costs, is decisive.", "condTitle": "Delivery Conditions", "cond1": "We currently deliver to {countries}. Unless a different deadline is specified in the respective offer, the goods are delivered after the conclusion of the contract (in the case of agreed advance payment, after the time of your payment instruction). The delivery time is {time}.", "cond2": "Please note that no deliveries are made on Sundays and public holidays. Your order will be processed and handled automatically. Accordingly, we are usually unable to make any changes shortly after the order has been placed.", "cond3": "If you have ordered items with different delivery times, we will ship the goods in a single shipment, unless we have made different arrangements with you. The delivery time is determined in this case by the item with the longest delivery time that you have ordered.", "partnerTitle": "Shipping Partner", "partner": "Shipping is carried out with our shipping partners {carriers}.", "costTitle": "Shipping Costs", "costVat": "All information on shipping costs includes statutory value-added tax.", "updated": "Last updated: {date}"},
    paymentMethodList: {"withPaypal": "card, PayPal, Apple Pay, Google Pay and Klarna", "withoutPaypal": "card, Apple Pay, Google Pay and Klarna"},
    shopTerms: {"title": "Shop terms", "pricesTitle": "Prices and shipping costs", "prices": "All prices include statutory VAT. In addition, shipping costs of {cost} per order apply. From a goods value of {amount} after discounts, we deliver free of charge within Germany. The Daily Routine Complete Set is always delivered free of charge. The delivery time is {time}. Details under", "link": "Shipping Policy", "paymentTitle": "Payment methods", "payment": "Payment is processed by our payment service provider Stripe. The following payment methods are available: {payMethods}. Apple Pay and Google Pay are only shown on supported devices and browsers.", "paymentPaypal": "If you pay with PayPal, you are redirected to PayPal; PayPal's terms apply in addition."},
    agbShop: {"pageTitle": "Terms and Conditions", "title": "Terms of sale (shop)", "placeholder": "To be added.", "earlyTitle": "Early Access Terms"},
    privacyPayments: {"title": "Payment services PayPal and Google Pay", "paypal": "The provider of the PayPal payment service is PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg. If you choose PayPal as your payment method at checkout, you are redirected to PayPal. Your payment data (e.g. name, email address, payment amount and order number) is transmitted to PayPal and processed there for the purpose of payment processing. The legal basis is Art. 6(1)(b) GDPR (contract processing). Further information can be found in PayPal's privacy statement: ", "googlePay": "The provider of the Google Pay payment service is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland. If you use Google Pay at checkout, your payment data (e.g. the card stored in Google Pay, name, billing address and payment amount) is processed between Google and our payment service provider Stripe for the purpose of payment processing. The legal basis is Art. 6(1)(b) GDPR (contract processing). Google may process this data in accordance with the Google Pay API Terms of Service and the Google Privacy Policy: ", "googleApiTerms": "Google Pay API Terms of Service", "googlePrivacy": "Google Privacy Policy"},

    // Order Overview page
    orderOverview: {
      seoTitle: "Order overview | H2HUMANS",
      seoDescription: "Choose your supplement module or the complete bundle.",
      backToCart: "Back to cart",
      orderNow: "Order now",
      successTitle: "Order successful!",
      successBody: "You will receive an order confirmation by email shortly.",
      successBack: "Back to shop",
      errorNotConfigured: "Payments are not yet configured for this environment.",
      errorItemUnavailable: "An item in your cart is no longer available.",
    },

    // Cart drawer
    cart: {
      title: "Cart",
      empty: "Your cart is empty",
      bundleDiscountActive: "Bundle discount active!",
      youSave: "You save",
      total: "Total",
      checkout: "Checkout",
      pricesNote: "All prices incl. VAT.",
      openCart: "Open cart",
    },

    // Index page SEO
    index: {
      seoTitle: "H2Humans: Support for reducing and stopping your weight-loss jab",
      seoDescription:
        "Whether you reduce, pause or stop: H2Humans supports you through the GLP-1 transition phase with an app, supplements and a science-based guide.",
      appDescription:
        "The smart Protocol Companion for nutrition, routines, supplements and tracking throughout your GLP-1 journey.",
      faqSupplementsSafe:
        "All of our supplements are made in Germany and Austria, Lab Tested, GMP Certified, Non-GMO and developed with experts. We work only with the highest quality standards.",
      faqHowPlus1Works:
        "Your +1 is an AI companion with personalised recommendations. It does not replace a therapist or doctor, it is a 24/7 coach built on a purely scientific basis.",
      faqDoesItWork:
        "That depends on you. H2HUMANS works best when you take the supplements regularly, use the app every day, follow Your +1 recommendations and stay patient.",
    },

    // Payment Test Mode Banner
    paymentBanner: {
      notConfigured:
        "Production checkout is not configured. Complete the payments go-live to accept real payments.",
      testMode: "All payments in the preview are in test mode.",
      readMore: "Learn more",
    },

    // Info Tooltip
    infoTooltip: {
      ariaLabel: "More information",
      glp1Title: "What is GLP-1?",
      glp1Body:
        "GLP-1 medications with active ingredients such as semaglutide or tirzepatide are prescribed by doctors for weight reduction. They enhance the feeling of satiety and regulate appetite.",
    },

    // Language Picker
    languagePicker: {
      ariaLabel: "Select language",
      de: "Deutsch",
      en: "English",
      pt: "Português",
    },

    // Products Section
    products: {
      title: "Three products.",
      titleEm: "One complete system.",
      description:
        "Three products with protein, electrolytes and micronutrients for your daily routine.",

      bodycare: {
        category: "Multi-formula",
        title: "Daily Body-Care",
        description:
          "Multi-functional protein powder with whey, creatine monohydrate, collagen hydrolysate and L-carnitine. Cacao flavour.",
        shortDescription: "The protein it contains may contribute to the maintenance of muscle mass.",
        pills: ["Muscle and tissue", "Protein + Creatine"],
        saleBadge: "Early Access Deal",
        ingredientsHeading: "Per serving (35 g / 1 scoop) · 0 g added sugar",
        ingredientsNote: "Stir 1 scoop (35 g) into 300 ml of water or milk. Cacao flavour.",
        fullIngredientsHeading: "Ingredients",
        fullIngredients:
          "Organic whey protein, whey protein isolate (emulsifier: lecithins (sunflower)), low-fat cocoa powder, glycine, creatine monohydrate, collagen hydrolysate (bovine), natural cocoa flavouring, L-carnitine-L-tartrate, thickener: xanthan gum; inulin, cocoa bean extract, Bacillus coagulans, enzyme blend (alpha-amylase, protease, lactase, cellulase, lipase), cyanocobalamin, pyridoxine hydrochloride",
        whyTitle:
          "Daily Body-Care combines whey protein with creatine, collagen hydrolysate and other ingredients. The nutrients it contains may contribute to the following normal body functions; composition details are also listed:",
        whyPoints: [
          "<strong>Collagen</strong> is included as collagen hydrolysate and provides amino acids.",
          "<strong>L-carnitine</strong> is included as L-carnitine tartrate.",
          "<strong>Enzymes and bacterial cultures</strong> are part of the formulation.",
        ],
        functionHeading: "Function",
        functionPoints: [
          "<strong>Protein</strong> may contribute to the maintenance of muscle mass.",
          "<strong>Creatine</strong> may contribute to increased physical performance in successive bursts of short-term, high-intensity exercise. A daily intake of 3 g of creatine is a prerequisite for this statement. This statement is intended for adults performing high-intensity exercise.",
          "<strong>Vitamin B6 and B12</strong> may contribute to normal energy metabolism.",
        ],
        applicationHeading: "Our application recommendation",
        applicationText:
          "We recommend a daily intake of 35 g Daily Body-Care powder. Simply dissolve one scoop in 300 ml of liquid and drink.\n\nThe stated recommended daily intake should not be exceeded. Errors and misprints excepted.",
      },

      balance: {
        category: "Micronutrient complex",
        title: "Daily Balance",
        description: "High dose multivitamin with D3, B12, folate, magnesium, zinc and selenium. 30 capsules.",
        shortDescription: "Vitamin and mineral complex for your daily routine.",
        pills: ["Micronutrient foundation", "Energy and immune system"],
        saleBadge: "Early Access Deal",
        ingredientsHeading: "Per capsule · daily dose",
        ingredientsNote: "Take 1 capsule daily with a meal.",
        fullIngredientsHeading: "Ingredients",
        fullIngredients:
          "Magnesium bisglycinate, vitamin C (L-ascorbic acid), magnesium oxide, spirulina powder, zinc bisglycinate, vitamin E (D-alpha tocopheryl acetate), nicotinamide, manganese gluconate, vitamin D3 (cholecalciferol, vegan from lichen), D-calcium pantothenate, sodium molybdate, vitamin K2 (MK7), sodium borate (di-sodium tetraborate), copper bisglycinate, vitamin B12 (methylcobalamin), vitamin B2 (riboflavin-5-phosphate), vitamin B1 (thiamine HCl), vitamin B6 (pyridoxal-5-phosphate), D-biotin, vitamin A (retinyl palmitate), folic acid (Quatrefolic®), chromium picolinate, potassium iodide, sodium selenite; hydroxypropyl methylcellulose (capsule shell)",
        whyTitle:
          "Daily Balance combines vitamins, minerals and trace elements. The micronutrients it contains may contribute to the following normal body functions:",
        whyPoints: [
          "<strong>Vitamins B1, B2, B6, B12 and vitamin C</strong> may contribute to normal <strong>energy metabolism</strong>.",
          "<strong>Vitamins A, C, D, zinc and selenium</strong> may contribute to the normal function of the <strong>immune system</strong>.",
          "<strong>Vitamins B1, B2, B6, B12 and magnesium</strong> may contribute to the normal function of the <strong>nervous system</strong>.",
          "<strong>Vitamins C, B2, B6, B12 and folate</strong> may contribute to the <strong>reduction of tiredness and fatigue</strong>.",
          "<strong>Vitamin C, vitamin E, zinc and selenium</strong> may contribute to the <strong>protection of cells from oxidative stress</strong>.",
          "<strong>Vitamins D and K</strong> may contribute to the maintenance of normal bones. <strong>Vitamin D</strong> may contribute to the maintenance of normal muscle function. <strong>Vitamin A</strong> may contribute to the maintenance of normal vision.",
          "<strong>Folate</strong> may contribute to normal blood formation. <strong>Vitamin B12</strong> may contribute to normal red blood cell formation. <strong>Folate and vitamin B12</strong> may contribute to a normal role in the process of cell division.",
        ],
        applicationHeading: "Our application recommendation",
        applicationText:
          "We recommend a daily intake of one capsule of Daily Balance. Simply take one capsule with a glass of liquid.\n\nThe recommended daily amount should not be exceeded. Food supplements are not a substitute for a varied and balanced diet and a healthy lifestyle. Please keep out of reach of children. The product should be stored in a cool, dry place. Printing and typographical errors reserved.",
      },

      hydration: {
        category: "Electrolyte formula",
        title: "Daily Hydration",
        description:
          "Daily electrolyte formula with sodium, chloride, potassium and magnesium. Citrus flavour. 30 sticks × 5 g.",
        shortDescription: "Electrolytes for active days in every phase.",
        pills: ["Electrolyte mixture", "Minerals"],
        saleBadge: "Early Access Deal",
        ingredientsHeading: "Per stick (5 g) · citrus · no added sugar",
        ingredientsNote: "Dissolve 1 stick in 500 ml of water. Drink daily or as needed.",
        fullIngredientsHeading: "Ingredients",
        fullIngredients:
          "Rock salt, acidifier (citric acid), tripotassium citrate monohydrate, trimagnesium dicitrate 8.59%, magnesium bisglycinate, natural flavouring, colouring food (safflower), sweetener (steviol glycosides from stevia)",
        whyTitle:
          "Sodium, chloride, potassium and magnesium are among the most important electrolytes in the human body. They occur in various tissues and body fluids and are regularly taken in through the diet.",
        whyPoints: [
          "<strong>Magnesium</strong> may contribute to <strong>electrolyte balance</strong> and to <strong>normal muscle function</strong>.",
          "<strong>Magnesium</strong> may contribute to the <strong>normal function of the nervous system</strong> and to the <strong>reduction of tiredness and fatigue</strong>.",
          "<strong>Potassium</strong> may contribute to normal muscle function.",
          "<strong>Potassium</strong> may contribute to the normal function of the nervous system.",
        ],
        applicationHeading: "Our application recommendation",
        applicationText:
          "We recommend taking one Electrolyte Stick daily. It provides 810 mg sodium, 1240 mg chloride, 300 mg potassium and 100 mg magnesium. Dissolve the contents of one sachet in water and drink.\n\nThe stated recommended daily intake should not be exceeded. Food supplements are not a substitute for a balanced and varied diet and a healthy lifestyle. Please keep out of reach of children. The product should be stored in a cool, dry place. Errors and misprints excepted.",
      },

      bundle: {
        badgeValue: "BEST VALUE",

        title: "Daily Routine Komplett-Set",
        description:
          "Three products in one box: Daily Body-Care, Daily Hydration and Daily Balance.",
        shortDescription: "Three supplements for your daily routine.",
        pills: [],
        cta: "Add bundle to cart",
        ctaShort: "Add to cart",
        details: {
          intro:
            "Three products complement your everyday nutrition routine.",
          contentsHeading: "What is inside",
          benefitsHeading: "Your benefits",
          benefits: [
            "Three products may complement your mindful nutrition routine in one system.",
            "The system may supplement your intake of electrolytes, vitamins, minerals and essential amino acids.",
            "Three fixed moments for your daily routine.",
          ],
          products: {
            bodycare:
              "Protein powder with whey protein, creatine, collagen hydrolysate and other ingredients.",
            balance: "Multivitamin with vitamin D3, B12, folate, magnesium, zinc and selenium.",
            hydration: "Electrolyte formula with sodium, chloride, potassium and magnesium.",
          },
        },
      },

      common: {
        details: "Details",
        addToCart: "Add to cart",
        back: "Back",
        whyItWorks: "Why it works",
        whatsInside: "What is inside",
        overview: "Overview",
        close: "Close",
        bundleUpsellTitle: "The complete system",
        bundleUpsellText: "All three products as one system: perfectly aligned.",
        bundleUpsellCta: "Add bundle to cart",
        relatedTitle: "Goes well with",
        perMonth: "/ month",
        savePill: "Save {amount}",
        routinePill: "30 day routine",
        showAllIngredients: "Show all ingredients",
        hideAllIngredients: "Show less",
        msrpLabel: "RRP",
        zoomIn: "Zoom in",
        zoomOut: "Zoom out",
        zoomReset: "Reset zoom",
        zoomHint: "Tap to zoom",
        detailBadges: ["GLP-1 Focus", "30 Day Routine", "Developed with doctors"],
      },
    },

    // Footer
    footer: {
      tagline: "We make wellbeing personal - your +1.",
      description: "We make wellbeing personal",
      privacy: "Privacy",
      imprint: "Imprint",
      terms: "Terms",
      privacySettings: "Privacy settings",
      productsTitle: "Products",
      companyTitle: "Company",
      supportTitle: "Support",
      aboutUs: "About us",
      blog: "Guide",
      careers: "Careers",
      faq: "FAQ",
      shipping: "Shipping",
      returns: "Returns",
      privacyPolicy: "Privacy",
      imprintLink: "Imprint",
      termsOfService: "Terms",
      copyright: "© H2HUMANS 2026 · h2humans.com",
      disclaimer:
        "Food supplements are not a substitute for a varied and balanced diet and a healthy lifestyle. The stated recommended daily intake must not be exceeded. Keep out of reach of small children.",
    },

    // Questionnaire
    questionnaire: {
      progress: "Step",
      of: "of",
      back: "Back",
      next: "Continue",
      finish: "Finish and enter the app",

      phase00: {
        title: "Be part of it from the start",
        subtitle: "Secure early access, free and before the official launch.",
        email: {
          label: "Your email address",
          placeholder: "name@example.com",
        },
        username: {
          label: "What should we call you?",
          placeholder: "Your name",
        },
      },

      phase01: {
        title: "Quick safety check",
        subtitle: "Please answer these questions honestly.",
        q1: "Are you currently pregnant or breastfeeding?",
        q2: "Have you ever been diagnosed with pancreatitis or thyroid cancer?",
        q3: "Do you have a severe gastrointestinal condition or uncontrolled diabetes?",
        yes: "Yes",
        no: "No",
        exitTitle: "Please talk to your doctor first",
        exitMessage:
          "We recommend seeking medical advice before using H2HUMANS. We will be here when you are ready.",
        exitButton: "Understood",
      },

      phase02: {
        title: "What is your goal?",
        subtitle: "Help us understand you better.",
        q1: {
          label: "What do you want to achieve with GLP-1?",
          options: [
            "Reduce weight",
            "Manage side effects better",
            "Stay consistent long term",
            "More energy in everyday life",
            "Emotional stability",
            "Something else",
          ],
        },
        q2: {
          label: "How well supported do you feel during your therapy right now?",
          low: "Not at all",
          high: "Very well",
        },
        q3: {
          label: "What would success look like for you in 12 weeks?",
          placeholder: "e.g. side effects under control, more energy, my routines working",
        },
        reward: {
          title: "Small steps, big impact",
          message: "Studies show that people who receive guidance stay on track longer and achieve much better results.",
        },
      },

      phase03: {
        title: "Tell us more about you",
        subtitle: "",
        section1: {
          title: "A few basic details",
          age: {
            label: "Age",
            placeholder: "years",
          },
          gender: {
            label: "Gender",
            options: ["Female", "Male", "Non-binary", "Prefer not to say"],
          },
          weight: {
            label: "Current weight",
            placeholder: "kg",
          },
        },
        section2: {
          title: "Your experience with GLP-1",
          glp1Status: {
            label: "Are you currently using a GLP-1?",
            options: ["Yes", "No"],
          },
          // Yes, currently
          brand: {
            label: "Which product are you using?",
            options: ["Ozempic", "Wegovy", "Mounjaro", "Other", "Not sure"],
          },
          therapyWeek: {
            label: "Which week of your therapy are you in?",
            start: "0",
            end: "12+",
          },
          // In the past
          endReason: {
            label: "Why did you stop?",
            options: ["Successfully completed", "Discontinued"],
          },
          abortReasons: {
            label: "What were the reasons?",
            hint: "Multiple selection possible",
            options: ["Side effects", "Cost", "Lack of results", "Did not fit my everyday life", "Other"],
          },
          pastBrand: {
            label: "Which product did you use?",
            options: ["Ozempic", "Wegovy", "Mounjaro", "Other", "Not sure"],
          },
          // No
          startPlan: {
            label: "Are you planning to use a GLP-1?",
            options: ["No", "In 1 to 4 weeks", "In 4 to 8 weeks", "In more than 8 weeks"],
          },
        },
      },

      phase04: {
        title: "Almost there.",
        subtitle: "We will let you know as soon as Your +1 is ready for you.",
        privacyConsent:
          "I have read and accept the Early Access terms. I have taken note of the privacy policy.",
        privacyLink: "Privacy Policy",
        marketing:
          "Yes, I would like to receive information, updates and offers from H2HUMANS by email. I can withdraw my consent at any time with effect for the future (for example through the unsubscribe link in every email or by writing to info@h2humans.com). You can find more information about how we process your data in our privacy policy.",
        required: "Required field",
        trustMicrocopy: "No sharing with third parties. No spam.",
        cta: "Reserve your spot, free of charge",
      },

      complete: {
        title: "You are in!",
        message:
          "You are on the waitlist for Your +1. What happens now: we share exclusive updates, behind the scenes insights and your personal invitation to the first user group.",
        button: "Back to home",
      },
    },

    // Checkout
    checkout: {
      title: "Order",
      backToShop: "Back to shop",
      step: "Step",
      of: "of",

      identification: {
        title: "Identification",
        subtitle: "Enter your contact details",
        email: {
          label: "Email address",
          placeholder: "name@example.com",
          error: "Please enter a valid email address",
        },
        firstName: {
          label: "First name",
          placeholder: "Max",
          error: "First name is required",
        },
        lastName: {
          label: "Last name",
          placeholder: "Smith",
          error: "Last name is required",
        },
        phone: {
          label: "Phone (optional)",
          placeholder: "+49 123 456789",
        },
      },

      delivery: {
        title: "Delivery",
        subtitle: "Choose a shipping method and address",
        address: {
          label: "Delivery address",
          street: "Street and number",
          streetPlaceholder: "Sample Street 42",
          streetError: "Street is required",
          zip: "Postal code",
          zipPlaceholder: "12345",
          zipError: "Valid postal code required",
          city: "City",
          cityPlaceholder: "Berlin",
          cityError: "City is required",
          country: "Country",
          countryOptions: ["Germany", "Austria", "Switzerland"],
        },
      },

      payment: {
        title: "Payment",
        subtitle: "Payment method and discount code",
        method: {
          label: "Payment method",
          notConfigured: "Payment provider is being set up",
          comingSoon: "Available soon",
        },
        promoCode: {
          label: "Discount code",
          placeholder: "Enter code",
          apply: "Apply",
          remove: "Remove",
          applied: "Discount activated",
          freeShipping: "Free shipping",
          invalid: "Invalid discount code",
        },
        summary: {
          subtotal: "Subtotal",
          bundleDiscount: "Bundle discount",
          promoDiscount: "Discount code",
          shipping: "Shipping",
          shippingFree: "Free",
          total: "Total",
        },
        cta: "Place a binding order now",
      },
    },

    knowledge: {
      prevArticle: "Previous article",
      nextArticle: "Next article",
      goToArticle: "Article {n} of {total}",
      title: "Knowledge that",
      titleEm: "guides",
      titleAfter: " you.",
      subtitle: "Scientifically grounded: on GLP-1, nutrition and the road ahead.",
      sourcesNote: "We work with more than 100 scientific sources.",
      homeKicker: "Guide",
      homeTitle: "What research on GLP-1 really says.",
      homeAllArticles: "All articles",
      homeTopicsLabel: "Guide topics",
      homeTrustHundred: "More than 100 scientific sources",
      homeTrustSources: "Every article with scientific sources",
      homeTrustWeekly: "New studies every week",
      viewAll: "Go to guide",
      related: "Related reading",
      phaseLink: "{count} articles on this phase",
      phaseLinkOne: "1 article on this phase",
      categoryCount: "{count} articles",
      categoryCountOne: "1 article",
      germanOnly: "Article in German",
      listLabel: "Knowledge articles",
    },
    journey: {
      v2: {
        eyebrow: 'What H2Humans is for',
        title1: 'Others support the start.',
        title2: 'We support the transition.',
        intro: 'With the weight-loss jab, your body is changing, before, during and after treatment. The transition decides what you keep. That is exactly what H2Humans is built for.',
        transitionLabel: 'The transition',
        steps: [
          { num: '01 · Before the jab', title: 'Start well prepared', text: 'Realistic expectations and first routines, before everything changes.' },
          { num: '02 · On the jab', title: 'Keep your strength in view', text: 'Protein, movement and steady routines while your appetite is quiet.' },
          { num: '03 · After the jab', title: 'Keep what you achieved', text: 'Support while stopping and afterwards. No pressure, no shame.' },
        ],
        cardTitle: 'Every change is a transition.',
        cardText: 'H2Humans supports you in every direction, every day, with the app, knowledge and matched products. Always in consultation with your doctor.',
        cta: 'Try the app for free',
      },
      eyebrow: "THE WHOLE JOURNEY",
      title: "Not just the therapy.",
      titleEm: "The whole journey.",
      subtitle: "**Many people experience a difficult transition after stopping.**\nH2Humans was built for exactly this moment.",
      transitionLabel: "Transition phase",
      pathTitle: "Three phases. One",
      pathTitleEm: "transition",
      changes: ["Adjust dose", "Extend intervals", "Pause", "Restart", "Stop"],
      guideHint: "This is where we support you.",
      explTitle: "The",
      explText: "Every change to your therapy raises questions about your body, hunger and routines. We support you in every direction, in consultation with your doctor.",
      articlesLink: "{count} articles on the transition phase in the guide",
      articlesLinkOne: "1 article on the transition phase in the guide",
      pathAlt: "A path in three phases: Pre GLP-1, On GLP-1 and Post GLP-1: that swings back and forth in a transition phase from the middle of the active phase into maintenance: adjust dose, extend intervals, pause, restart or stop.",
      phaseSubs: ["Preparation", "Active phase", "Maintenance"],
      transitionText: "Every change to your therapy: adjusting the dose, extending intervals, pausing, restarting or stopping. We support you in every direction, in consultation with your doctor.",
      bothWays: "Movement possible in both directions.",
      source: "Source: Budini, Luo et al., eClinicalMedicine 2026.",
      disclaimer: "Schematic representation, not a performance claim.",
      more: "Learn more",
      less: "Show less",
      labels: {
        happens: "What happens",
        challenge: "Biggest challenge",
        h2h: "What H2Humans offers",
      },
      phases: [
        {
          tag: "Phase 1",
          name: "Pre GLP-1",
          timing: "Before starting therapy",
          happens: "The decision is made: financially, mentally and practically. Rarely all at the same pace.",
          challenge: "“Readiness mismatch”: budget, behaviour timeline and commitment are out of sync from day one.",
          h2h: "Honest expectation setting instead of miracle promises: preparing for the whole journey, not just the start.",
        },
        {
          tag: "Phase 2",
          name: "On GLP-1",
          timing: "Active treatment: months to years",
          happens: "Substantial change. The easiest window for new habits closes early (day 10–21).",
          challenge: "Muscle loss is real. Around two thirds stop within a year. Cycling is the norm.",
          h2h: "Protein and training guidance based on Delphi consensus, plus coaching that lasts beyond the drug window.",
        },
        {
          tag: "Phase 3",
          name: "Transition phase",
          timing: "Dose reduction, stopping or pausing",
          happens: "Body systems don’t reset in sync: metabolism, fat-to-muscle ratio and wellbeing shift at different speeds.",
          challenge: "The industry-wide blind spot: dose reduction and long-term aftercare are barely researched.",
          h2h: "This is exactly where H2Humans steps in: daily support, not only during the injection phase.",
        },
        {
          tag: "Phase 4",
          name: "Post GLP-1",
          timing: "New equilibrium: months to years after",
          happens: "Many people experience a difficult transition after stopping.",
          challenge: "“Identity lag” on the maintenance plateau: you don’t yet feel like the new version of yourself.",
          h2h: "Routine support for the time afterwards and a real “welcome back” flow instead of a relapse-shame narrative.",
        },
      ],
    },

    comparison: {
      eyebrow: "",
      title: "Multi-formulation instead of multi-purchase.",
      titleEm: "",
      subtitle: "30 servings, 7 components, 1 product.",
      productLabel: "Daily Body-Care · 1000 g",
      columns: {
        component: "Component",
        benefit: "Amount per serving",
        competitor: "Leading brands*",
        competitorSub: "(30 days, prorated)",
        h2: "H2Humans",
        h2Sub: "Daily Body-Care",
      },
      rows: [
        { name: "Whey Protein Isolate", benefit: "22.4 g protein", competitor: "~€50" },
        { name: "Collagen Peptides Hydrolysate", benefit: "3,000 mg", competitor: "~€40" },
        { name: "Creatine Monohydrate", benefit: "3,000 mg", competitor: "~€6" },
        { name: "L-Carnitine Tartrate", benefit: "500 mg", competitor: "~€5" },
        { name: "Cocoa Polyphenol Extract", benefit: "250 mg", competitor: "~€12" },
        { name: "Bacillus Coagulans", benefit: "2 bn CFU", competitor: "~€10" },
        { name: "Vitamin B6 + B12", benefit: "1.4 mg · 2.89 µg", competitor: "~€5" },
      ],
      includedLabel: "Included",
      totalLabel: "Competitor total",
      totalValue: "~€128",
      h2Price: "€69.90",
      savingsLabel: "Your monthly savings with Daily Body-Care",
      savingsValue: "~€58",
      savingsNote: "All seven components in one product: no seven separate doses.",
      imageAlt: "Daily Body-Care powder in a measuring scoop",
      singleLabel: "Single",
      cta: "See Daily Body-Care in the shop",
      footnote: "* Comparison based on current 2026 online market prices of premium, branded-ingredient EU supplement makers. Prices strictly prorated to 30 daily servings (pack price ÷ servings × 30).",
    },

    foundingMembers: {
      title: "Our Founding Members.",
      body: "We work with people who share their GLP-1 journey honestly with their community, with real successes, real setbacks and no filter at all.",
      productBody: "We work with people who honestly share their everyday lives and routines with their community.",
      productRoles: ["HYROX & daily routines", "Preparing for HYROX", "Strength training & long walks"],
      badge: "Founding Member",
      showCard: "Show card",
      prevCard: "Previous card",
      nextCard: "Next card",
      backCta: "Back",
      campaignBadge: "BE ACTIVE! CAMPAIGN",
      hyroxStoryCta: "Watch the HYROX story",
      cards: [
        {
          emoji: "✦",
          name: "Angelika",
          role: "Founding Member",
          subtitle: ["GLP-1 & HYROX", "@piks_zu_mir"],
          facts: ["GLP-1 & HYROX", "2× HYROX Finisher"],
          quote: "\"I don't believe in miracle cures. I believe in systems, routines and honest support. That's why I'm a Founding Member of H2Humans.\"",
          cta: "Learn more",
          frontOnly: false,
          profileLabel: "Profile",
          instagramUrl: "https://www.instagram.com/piks_zu_mir/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "1.4K followers",
          front: "\"I don't believe in miracle cures. I believe in systems, routines and honest support. That's why I'm a Founding Member of H2Humans.\"",
          paragraphs: [
            "What I learned on my GLP-1 journey: The injection doesn't do the work for you. It creates the opportunity to build new habits.",
            "That's exactly why I fit with H2Humans. What convinces me is not the promise of a miracle cure, but the approach of supporting people with knowledge, routines and sensibly coordinated products in the long term.",
            "On my Instagram account, I honestly share my journey, with successes, setbacks and everything in between. My goal is to encourage people and show that change doesn't have to be perfect, but sustainable.",
          ],
          tags: ["GLP-1", "HYROX", "Founding Member"],
        },
        {
          emoji: "✦",
          name: "Nicole",
          role: "Founding Member",
          subtitle: ["GLP-1 & lipedema", "@abnehmspritze_mit_lipoodem"],
          facts: ["GLP-1 & lipedema", "HYROX preparation"],
          quote: "\"No 'quick fix', no comparison. Health is the most important thing we have. It's about understanding your own body and strengthening it step by step.\"",
          cta: "Learn more",
          frontOnly: false,
          profileLabel: "Profile",
          instagramUrl: "https://www.instagram.com/abnehmspritze_mit_lipoedem/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "1.3K followers",
          front: "\"No 'quick fix', no comparison. Health is the most important thing we have. It's about understanding your own body and strengthening it step by step.\"",
          paragraphs: [
            "My path is deliberately slow, controlled and steady, because one thing matters most to me: my health. What I learned? Losing weight doesn't mean reaching your target weight as quickly as possible or comparing yourself to others. It's about getting to know your own body again and strengthening it sustainably.",
            "That's exactly why I fit with H2Humans. What convinces me is the holistic system: With just three coordinated products, the body is optimally supplied, without hours of research or complicated thinking. It simply and quickly fits into everyday life.",
            "On my Instagram account, I take my community along honestly and unfiltered. I share before-and-after insights, practical eating tips, my preparation for the next HYROX and all the ups and downs. My goal is to show that health is the most important asset we have and that the journey there can be fun.",
          ],
          tags: ["GLP-1", "lipedema", "Founding Member"],
        },
        {
          emoji: "✦",
          name: "Sandra",
          role: "Founding Member",
          subtitle: ["GLP-1 & perimenopause", "@sonnen.bunt"],
          facts: ["GLP-1 & perimenopause", "Strength training & long walks"],
          quote: "\"I'd had enough years of dieting, and with perimenopause nothing worked at all. With GLP-1 it finally clicked and I built sustainable routines. H2Humans sees the human behind the products.\"",
          cta: "Learn more",
          frontOnly: false,
          profileLabel: "Profile",
          instagramUrl: "https://www.instagram.com/sonnen.bunt/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "3.5K followers",
          front: "\"I had more than enough years of dieting. But once perimenopause began, I simply couldn’t lose weight anymore. With GLP-1 it finally worked again.\"",
          paragraphs: [
            "Since my GLP-1 journey began, a lot has changed for me.",
            "I don’t use GLP-1 because I thought someone would do the work for me. I use it because it helps me quiet something that used to be with me constantly: food noise. And honestly? I used to think everyone experienced it that way.",
            "Strength training, on the other hand, has been part of my life for many years and is an important part of my journey, especially during this hormonal transition and menopause. For me, change doesn’t just mean less weight, but above all: getting stronger, maintaining muscle and feeling at home in my body again.",
            "That’s exactly why I find the H2Humans concept so exciting. No wild hunt for supplements and the endless question: what do I actually need? Instead, a well-thought-out concept with products that are sensibly coordinated and support me exactly where I am right now.",
            "Because life is complicated enough: finding the right supplements doesn’t have to be.",
          ],
          tags: ["GLP-1", "perimenopause", "Founding Member"],
        },
      ],
    },
    // Blog
    about: {
      seoTitle: "About us | H2HUMANS",
      seoDescription: "The story behind H2HUMANS and what we stand for: the people, the attitude and the values behind the H2HUMANS System.",
      blogTitle: "More knowledge in the Guide.",
      blogBody: "Science-backed articles on GLP-1, nutrition and the path that follows.",
      blogCta: "Go to the Guide",
    },
    blog: {
      title: "H2Humans Guide",
      titleBefore: "The H2Humans ",
      titleEm: "Guide",
      titleAfter: ".",
      metaTitle: "H2Humans Guide: GLP-1, Stopping & Nutrition",
      metaDescription: "Science-based articles on GLP-1, stopping weight-loss injections, nutrition and the road ahead.",
      intro: "Scientifically grounded. Clearly explained. On GLP-1, nutrition and the road ahead.",
      pageTitleSuffix: " | H2Humans Guide",
      categoryKicker: "Guide · {category}",
      featured: "Latest article",
      aiImageLabel: "AI-generated image",
      aiImageMark: "AI",
      allCategories: "All topics",
      articleCount: "{count} articles",
      articleCountOne: "1 article",
      allPosts: "All articles",
      backToBlog: "Back to all articles",
      readTime: "approx. {min} min read",
      readTimeShort: "{min} min read",
      readMoreLink: "Read more",
      readArticle: "Read article",
      readTimeCompact: "{min} min",
      heroKicker: "Guide",
      heroTitle: "Answers on GLP-1. Evidence-based, with sources.",
      searchLabel: "Search the guide",
      searchPlaceholder: "What are you looking for? e.g. stopping, muscle mass, food noise",
      searchClear: "Clear search",
      searchResults: "{count} articles for “{query}”.",
      searchResultsOne: "1 article for “{query}”.",
      searchNone: "No articles found. Try another term.",
      trustSources: "Every article with scientific sources",
      trustWeekly: "New studies explained every week",
      trustOrientation: "No treatment advice, just orientation",
      newThisWeek: "New this week.",
      topicsHeading: "Topics.",
      topicCount: "{count} articles",
      topicCountOne: "1 article",
      allArticles: "All articles.",
      filterLabel: "Filter by topic",
      filterAll: "All",
      mostRead: "Most read.",
      bandTitle: "New studies, clearly explained. Every Thursday.",
      bandHint: "15 % off your first order.",
      loadMore: "Load more",
      sourcesCount: "With {count} scientific sources",
      sourcesCountOne: "With 1 scientific source",
      sourcesToggle: "Sources ({count})",
      noTherapy: "We do not replace medical treatment and give no treatment recommendations.",
      continueReading: "Keep reading.",
      readingProgress: "Reading progress",
      topics: {
        transition: { short: "Stopping", description: "What happens after stopping." },
        "food-noise-psychologie": { short: "Psychology", description: "Understanding hunger, appetite and mind." },
        wissenschaft: { short: "Studies", description: "New studies clearly explained." },
        ernaehrung: { short: "Nutrition", description: "Food and routines for every day." },
        community: { short: "Community", description: "Experiences from people like you." },
        klinik: { short: "Clinic", description: "Context for practice and clinic." },
      } as Record<string, { short: string; description: string }>,
      ratingNone: "No ratings yet",
      ratingSummary: "{avg} out of 5 · {count} ratings",
      ratingSummaryOne: "{avg} out of 5 · 1 rating",
      rateTitle: "How helpful was this article?",
      rateHint: "Rate from 1 to 5 stars.",
      rateStar: "{n} out of 5 stars",
      rateThanks: "Thank you for your rating.",
      rateError: "Your rating could not be saved. Please try again.",
      sortLabel: "Sort by",
      sortNewest: "Newest first",
      sortTopRated: "Top rated",
      publishedShort: "Published on {date}",
      publishedOn: "Published on {date}",
      updatedOn: "Updated on {date}",
      author: "H2Humans Editorial Team",
      toc: "Table of contents",
      sources: "Sources",
      faqHeading: "Frequently asked questions",
      related: "Related articles",
      disclaimer: "This article is based exclusively on publicly available scientific sources, all of which are listed transparently above.",
      empty: "No articles have been published here yet.",
      loading: "Loading articles...",
      ctaTitle: "Stay informed.",
      ctaBody: "15% off your first order: plus new articles and GLP-1 research straight to your inbox.",
      ctaCompact: "15% off your first order: straight to your inbox.",
      previewBanner: "Preview: this article has not been published yet.",
      onlyGermanNotice: "This article is currently only available in German.",
      breadcrumb: "Breadcrumb",
      breadcrumbHome: "Guide",
      lastUpdated: "Last updated on {date}",
      backToBlogButton: "Back",
      toShop: "Back to Shop",
      productsTitle: "Our products.",
      productsBody: "The H2HUMANS System: scientifically developed supplements for your everyday life.",
      productsCta: "View in shop",
      productsPrev: "Previous product",
      productsNext: "Next product",
      postsPrev: "Previous article",
      postsNext: "Next article",
      communityTitle: "Join the community.",
      communityBody: "Daily impulses, experiences and answers around GLP-1: follow us on Instagram.",
      communityCta: "Follow on Instagram",
      comingSoonTitle: "Coming soon.",
      comingSoonBody: "This category launches soon. The first articles are already in the making.",
      comingSoonClose: "Close",
    },
    // Admin
    admin: {
      metaTitle: "Editorial | H2Humans",
      brand: "H2Humans Editorial",
      logout: "Sign out",
      login: {
        heading: "Editorial",
        subtitle: "Please sign in with your editorial account.",
        email: "Email",
        password: "Password",
        submit: "Sign in",
        loading: "Signing in...",
        error: "Sign-in failed. Please check your credentials.",
      },
      list: {
        heading: "Blog articles",
        newPost: "New article",
        empty: "No articles yet.",
        loading: "Loading articles...",
        colTitle: "Title",
        colCategory: "Category",
        colStatus: "Status",
        colUpdated: "Last updated",
        sortBy: "Sort by",
        sortDate: "Date",
        sortStatus: "Status",
        noCategory: "—",
        analytics: "Analytics",
      },
      analytics: {
        heading: "Blog analytics",
        backToList: "Back to overview",
        period: "Period",
        periodDays: "Last {days} days",
        period6m: "Last 6 months",
        loading: "Loading analytics...",
        error: "Analytics could not be loaded.",
        empty: "No data in this period yet.",
        visitors: "Visitors",
        pageViews: "Page views",
        totalTime: "Total reading time",
        avgTime: "Avg. reading time",
        dailyHeading: "Daily trend",
        categoriesHeading: "Categories",
        postsHeading: "Articles",
        visitorsShort: "visitors",
        viewsShort: "views",
      },
      status: {
        draft: "Draft",
        published: "Published",
        archived: "Archived",
      },
      form: {
        newHeading: "New article",
        editHeading: "Edit article",
        back: "Back to overview",
        title: "Title",
        slug: "Slug",
        slugHint: "Generated from the title, can be overwritten.",
        category: "Category",
        categoryNone: "No category",
        language: "Language",
        translationOf: "Translation of …",
        translationOfNone: "Standalone article (new translation group)",
        translationOfHint: "Pick an existing article if this is its translation.",
        metaDescription: "Meta description",
        metaCounter: "{count}/160 characters",
        metaWarning: "Over 160 characters. Search engines will truncate it.",
        excerpt: "Excerpt",
        content: "Content (Markdown)",
        previewTab: "Live preview",
        sources: "Sources",
        sourceText: "Source",
        sourceUrl: "URL (optional)",
        addSource: "Add source",
        removeSource: "Remove source",
        faq: "Frequently asked questions (optional)",
        faqHint: "Only completed entries appear on the page and in the FAQ schema.",
        faqQuestion: "Question",
        faqAnswer: "Answer",
        addFaq: "Add question",
        removeFaq: "Remove question",
        ogImage: "Cover image URL (optional)",
        ogImageHint: "Photorealistic landscape image (at least 1200 × 675 px) for the overview and article. Leave empty: a matching cover image is generated automatically after publishing. The main subject must remain fully visible in the mobile crop.",
        ogImageRequired: "Please add a cover image before publishing this article.",
        status: "Status",
        save: "Save",
        saving: "Saving...",
        saved: "Saved.",
        saveError: "Saving failed.",
        previewLink: "Open preview",
        unsaved: "Unsaved changes",
        llmsNotice: "After publishing a new article, public/llms.txt has to be updated manually.",
        altWarning: "Note: {count} image(s) in the content have no alt text.",
        leaveConfirm: "You have unsaved changes. Leave this page?",
        requiredMissing: "Title, slug and meta description are required.",
      },
    },
  },

  pt: {
    trustVideos: {"title": "Pessoas reais. Rotinas reais.", "subtitle": "Founding Members e o nosso fundador contam como a H2Humans se integra no seu dia a dia.", "thanksTitle": "A rotina no dia a dia.", "strip": "Founding Members partilham a sua rotina*", "play": "Reproduzir vídeo de {name}", "close": "Fechar vídeo", "prev": "Vídeo anterior", "next": "Próximo vídeo", "setCta": "Ver o conjunto completo", "shopCta": "Ir para a loja", "bodyCta": "Ver Daily Body-Care", "advertising": "Publicidade · Founding Member, recebe uma comissão", "videoName": "H2Humans Trust Card – {name}", "people": {"sandra": {"name": "Sandra", "role": "Founding Member · Musculação e dia a dia", "quote": "Preparo um batido todos os dias. Não é doce, tem uma leve nota de cacau.", "sourceRole": "Founding Member"}, "nicole": {"name": "Nicole", "role": "Founding Member · Preparação HYROX", "quote": "A minha rotina começa todas as manhãs com a Daily Balance.", "sourceRole": "Founding Member"}, "patrick": {"name": "Patrick", "role": "Fundador e CEO, H2Humans", "quote": "De pessoa para pessoa: construímos o sistema para a fase seguinte.", "sourceRole": "Fundador e CEO"}, "angelika": {"name": "Angelika", "role": "Founding Member · Atleta HYROX", "quote": "Andam sempre no meu saco de ginásio. Perfeitos para levar.", "sourceRole": "Founding Member"}}, "quoteOpen": "„", "quoteClose": "“", "source": "— {name}, {role}", "footnote": "* Publicidade: os Founding Members são parceiros de colaboração da H2HUMANS e recebem uma comissão. Saiba mais em", "legalLink": "Aviso legal", "modalAdvertising": "* Publicidade · Founding Member com comissão", "cooperationTitle": "Colaborações com Founding Members.", "cooperationText": "No nosso website, nos nossos canais de redes sociais e em anúncios, apresentamos relatos de experiências de Founding Members. Os Founding Members são parceiros de colaboração da H2HUMANS. Podem receber produtos gratuitamente e uma comissão sobre encomendas efetuadas através do seu link ou código pessoal. Os conteúdos refletem a opinião e a experiência pessoal da respetiva pessoa. Patrick é fundador e CEO da H2HUMANS.", "carouselSubtitle": "Pessoas reais. Rotinas reais. Sem filtros.", "hydrationCta": "Ver Daily Hydration", "dot": "Ir para o vídeo {n} de {total}"},
    legalNotice: {"title": "Aviso legal.", "metaTitle": "Aviso legal | H2HUMANS", "description": "Informações legais da H2HUMANS, operada pela Cosmic Gap, Lda em Lisboa, Portugal.", "back": "Voltar à página inicial", "company": "Cosmic Gap, Lda.", "address": "Avenida da Liberdade 230, 2 Floor, Andar 1250-148", "city": "Lisboa, Portugal", "emailLabel": "E-mail", "email": "info@h2humans.com", "phoneLabel": "Telefone", "phone": "+351 910 734 628", "management": "Gerência.", "manager": "Patrick Eichiner", "registration": "Registo da empresa.", "registrationValue": "NIPC: 519218299", "tax": "Identificação fiscal.", "taxValue": "Número de identificação de IVA: PT519218299", "disputeTitle": "Resolução de litígios.", "disputeIntro": "A Comissão Europeia disponibiliza uma plataforma de resolução de litígios em linha:", "disputeText": "Não participamos em processos de resolução de litígios perante uma entidade de resolução alternativa de litígios de consumo e não estamos obrigados a fazê-lo."},
    productHeroAlts: {"bundle": "Conjunto completo Daily Routine: Daily Hydration, Daily Body-Care e Daily Balance, Daily Balance grátis", "body-care": "Daily Body-Care proteína em pó com sabor a cacau, 1000 g, 22,4 g de proteína por porção", "hydration": "Daily Hydration eletrólitos com sabor a citrinos, 30 sticks", "balance": "Daily Balance vitaminas e minerais, 30 cápsulas, 1 cápsula por dia"},
    productReviews: {"summary": "{avg} de 5 · {count} avaliações", "title": "Avaliações.", "verified": "Compra verificada", "incentivized": "Avaliação após incentivo com voucher", "note": "Todas as avaliações vêm de compradores verificados. Verificamos se as avaliações vêm de pessoas que compraram o produto.", "stars": "{n} de 5 estrelas", "perCapsule": "{price} / cápsula", "formTitle": "A tua avaliação.", "formIntro": "Obrigado pela tua compra. O que achas de {product}?", "formRating": "Estrelas", "formText": "A tua experiência", "formName": "Nome próprio", "formSubmit": "Enviar avaliação", "formSending": "A enviar …", "formThanks": "Obrigado! A tua avaliação será verificada e depois publicada.", "formUsed": "Já foi enviada uma avaliação para este link.", "formInvalid": "Este link de avaliação é inválido.", "formError": "Não funcionou. Tenta novamente.", "formRequired": "Indica estrelas, texto e nome próprio.", "metaTitle": "Avaliar | H2HUMANS", "metaDesc": "Avalia o teu produto H2HUMANS através do teu link pessoal.", "adminTitle": "Moderar avaliações.", "adminHint": "Rejeitar apenas por spam ou violação legal, nunca por uma avaliação negativa.", "adminApprove": "Aprovar", "adminReject": "Rejeitar", "adminEmpty": "Sem avaliações nesta vista.", "adminForbidden": "Sem acesso. A tua conta não tem função de admin.", "statusPending": "Pendente", "statusApproved": "Aprovada", "statusRejected": "Rejeitada", "adminReviewsLink": "Avaliações", "videosTitle": "Vozes em vídeo."},
    shippingUnits: {"daysNom": "{min}–{max} dias úteis", "daysDat": "{min}–{max} dias úteis", "countryNotice": "Atualmente entregamos apenas na Alemanha."},
    shop: {
      navLabel: "Loja",
      promoMessages: {
        label: "Ofertas atuais",
        freeShipping: "Envio grátis a partir de {amount}",
        app: "Novo: experimenta a app H2Humans grátis",
        freeShippingShort: "Envio grátis desde {amount}",
        appShort: "Novo: app H2Humans grátis",
        startOffer: "Oferta de lançamento: Kit Completo 24,80 € mais barato · Daily Balance grátis · envio grátis desde {amount}",
        startOfferShort: "Kit Completo 24,80 € mais barato · Balance grátis",
      },
      order: {"title": "A tua encomenda.", "continueToPayment": "Continuar para o pagamento", "continueShopping": "Continuar a comprar", "summaryTitle": "Resumo da encomenda", "stripeHint": "Ao clicar no botão de pagamento abaixo, fazes uma encomenda com obrigação de pagamento.", "empty": "O teu carrinho está vazio.", "toShop": "Ir para a loja", "back": "Voltar", "seoTitle": "Encomenda | H2HUMANS", "seoDesc": "Revê a tua encomenda H2HUMANS e paga com segurança.", "legalTerms": "À tua encomenda aplicam-se as nossas {terms}.", "legalTermsLink": "condições de venda", "legalWithdrawal": "As informações sobre o teu direito de livre resolução estão na {withdrawal}.", "legalWithdrawalLink": "política de livre resolução", "legalDelivery": "Entrega em {timeDat} na Alemanha.", "legalDeliveryShort": "Entrega em {timeDat}.", "newTab": "(abre num novo separador)"},
      upgrade: {"title": "Completa a tua rotina", "saved": "Daily Balance grátis · {amount} poupados", "extra": "Só mais {amount} por {products}", "cta": "Mudar para o conjunto", "decline": "Não, obrigado, só {product}", "yourChoice": "A tua escolha", "recommended": "Recomendado", "close": "Fechar", "andWord": " + "},
      miniCart: {
        shipping: "Envio",
        shippingFreeValue: "grátis",
        total: "Total",
        vatNote: "IVA incluído",
        deliveryLine: "Entrega em {time} · enviado da Alemanha",
        swapSet: "Trocar pelo kit",
        swapSetText: "Com o kit recebes o Daily Balance grátis e poupas {amount}.",
        reachesFree: "Assim o teu envio é gratuito",
        title: "O teu carrinho",
        itemCount: "{count} artigos",
        shippingRemaining: "Faltam {amount} para envio grátis",
        codeActive: "Código {code} ativo",
        tierActive: "Desconto de quantidade −{pct} %",
        codeLineActive: "Código {code} −{pct} %",
        tierLabel: "Desconto de quantidade",
        shippingRemainingOrSet: "Faltam {amount} para envio grátis ou leva o conjunto (envio sempre gratuito)",
        shippingFree: "O teu envio é gratuito ✓",
        crossSellTitle: "Combina com",
        add: "Adicionar",
        promoHint: "Introduz o código promocional no próximo passo",
        subtotal: "Subtotal",
        checkout: "Finalizar compra",
        trust: "Pagamento seguro · Envio a partir da Alemanha",
        empty: "O teu carrinho está vazio",
        toShop: "Ir para a loja",
        close: "Fechar carrinho",
        open: "Abrir carrinho",
        decrease: "Diminuir quantidade",
        increase: "Aumentar quantidade",
        remove: "Remover",
        quantity: "Quantidade",
      },
      title: "Todos os produtos.",
      subtitle: "O conceito de suplementos H2HUMANS em resumo.",
      metaTitle: "Loja | H2HUMANS",
      metaDescription: "Todos os produtos H2HUMANS em resumo.",
      viewProduct: "Ver produto",
      cart: "Carrinho",
      backToShop: "Voltar à loja",
      productMetaTitleSuffix: " | H2HUMANS",
      productMetaDescriptionFallback: "Descrição do produto em breve.",
      priceNote: "Preço c/ IVA, acresce envio.",
      shippingFaq: {"deliveryQ": "Quão rápida é a entrega?", "deliveryA": "Enviamos a partir da Alemanha. O prazo de entrega é de {time}.", "costQ": "Quanto custa o envio?", "costA": "O envio custa {cost}. A partir de {amount} em valor de mercadoria (após descontos) a entrega é gratuita. O Kit Completo tem sempre envio gratuito.", "title": "Envio"},
      trustBar: {"label": "Vantagens num relance", "stripLabel": "As nossas promessas", "setFree": "Kit Completo sempre com envio grátis", "qualityLabel": "Selos de qualidade", "seals": ["Fabricado em DE/AT", "Certificado GMP", "Non-GMO", "Testado em laboratório"], "guarantee": "Garantia de reembolso de 30 dias", "freeFrom": "Envio grátis a partir de {amount}", "delivery": "Entrega em {time}", "madeIn": "Fabricado em DE/AT", "set": ["Daily Balance grátis", "Envio gratuito", "2 minutos por dia", "Fabricado em DE/AT"], "body": ["22,4 g de proteína por dose", "3 g de creatina", "Com proteína de soro bio", "Sem açúcar adicionado"], "hyd": ["Sódio, potássio, magnésio", "Sem açúcar adicionado", "30 sticks para 30 dias", "Fabricado em DE/AT"], "bal": ["22 vitaminas e minerais", "1 cápsula por dia", "30 cápsulas para 30 dias", "Fabricado em DE/AT"], "card": {"bundle": "Daily Balance grátis", "body-care": "22,4 g de proteína", "hydration": "Sem açúcar adicionado", "balance": "1 cápsula por dia"}},
      trustLine: {"freeFrom": "Envio grátis a partir de {amount}", "setFree": "Kit sempre com envio gratuito", "delivery": "Entrega em {time}", "guarantee": "Garantia de rotina de 30 dias", "label": "Envio e garantia"},
      setMonthly3: "Ou a partir de {price} por mês no pacote de 3 meses",
      pdp: {"tbd": "[TEXTO A SEGUIR]", "unitPrice": "Preço por unidade: {price} / kg", "unitPriceMissing": "Preço por unidade: [TEXTO A SEGUIR]", "gallery": "Imagens do produto", "galleryAlts": {"set-1-routine": "Método de 3 passos: Daily Balance de manhã, Daily Hydration durante o dia, Daily Body-Care à tarde. 2 minutos por dia.", "set-2-preis": "Componentes individuais cerca de 173 € por 30 dias vs. conjunto completo a partir de 84,90 € por mês no pacote de 3 meses. Daily Balance grátis, envio gratuito.", "bodycare-1-inhalt": "Daily Body-Care por dose: 22,4 g de proteína, 3.000 mg de creatina, 3.000 mg de colagénio, vitamina B6 e B12, com proteína de soro biológica, 0 g de açúcar adicionado.", "bodycare-2-vergleich": "Comparação do Daily Body-Care com um batido de proteína normal.", "hydration-1-inhalt": "Daily Hydration por stick: 810 mg de sódio, 300 mg de potássio, 100 mg de magnésio, sem açúcar adicionado, 30 sticks.", "hydration-2-vergleich": "Comparação do Daily Hydration com uma bebida desportiva pronta.", "balance-1-inhalt": "Daily Balance: 22 vitaminas e minerais em 1 cápsula, incluindo vitamina D3, B12, ácido fólico, selénio, zinco, magnésio.", "balance-2-basis": "Daily Balance: nutrientes para energia, sistema imunitário, menos cansaço, cabelo, ossos e músculos e proteção celular.", "nutrition-body-care": "Valores nutricionais e ingredientes de Daily Body-Care", "nutrition-hydration": "Valores nutricionais e ingredientes de Daily Hydration", "nutrition-balance": "Valores nutricionais e ingredientes de Daily Balance"}, "slide": "Imagem {n} de {total}", "placeholderNutrition": "Imagem nutricional a seguir", "placeholderLifestyle": "Imagem lifestyle a seguir", "reviews": "{count} avaliações", "purchaseOptions": "Opção de compra", "oneTime": "Compra única", "subscribe": "Subscrever e poupar", "subscriptionPreview": "Subscrição / Subscription", "comingSoon": "Em breve", "tiers": "embalagens", "save": "Poupa {amount}", "quantity": "Quantidade", "addToCart": "Adicionar ao carrinho · {price}", "addShort": "Adicionar ao carrinho", "delivery": "Entrega em {time}", "trust": ["Testado em laboratório", "GMP certified", "Fabricado em DE/AT", "Non-GMO"], "accIngredients": "Ingredientes", "accUsage": "Modo de utilização", "accShipping": "Envio e devoluções", "shippingText": "Enviamos a partir da Alemanha. O prazo de entrega é de {time}. O envio custa {cost}. A partir de {amount} em valor de mercadoria (após descontos) a entrega é gratuita. O Kit Completo tem sempre envio gratuito. Os detalhes sobre o direito de livre resolução estão na política de devolução.", "shippingLink": "Informações de envio", "withdrawalLink": "Direito de livre resolução", "termsLink": "Termos", "upsellTitle": "Tudo no Daily Routine Komplett-Set", "upsellSave": "poupas {amount}", "upsellCta": "Ver o Komplett-Set", "phaseTitle": "Como se encaixa na tua", "phaseTitleEm": "fase.", "phases": ["Antes da injeção", "Com a injeção", "Depois da injeção"], "ingredientsTitle": "Ingredientes em", "ingredientsTitleEm": "detalhe.", "perServing": "por dose diária", "compareTitle": "H2Humans vs.", "compareTitleEm": "compra avulsa.", "compareCols": ["", "H2Humans", "Suplementos avulsos"], "compareRows": ["Número de produtos", "Preço por mês", "Adaptado às fases GLP-1", "Acompanhamento na app"], "compareProducts": "1 sistema (3 produtos)", "compareYes": "Sim", "compareApp": "Sim, experimenta grátis", "usageTitle": "Utilização em", "usageTitleEm": "3 passos.", "usageSteps": ["Medir a dose", "Tomar com líquido", "Integrar na rotina diária"], "faqTitle": "Perguntas", "faqTitleEm": "frequentes.", "appUpsellTitle": "O teu sistema. O teu ", "appUpsellTitleEm": "+1.", "crossTitle": "Completa o teu", "crossTitleEm": "sistema.", "bundleContents": "Incluído no sistema", "reviewsTitle": "Avaliações", "pkgLegend": "Escolhe um pacote", "pkgMonth1": "1 mês", "pkgMonths": "{n} meses", "pkgInstead": "em vez de {price}", "pkgPerDay": "apenas {price} por dia", "pkgPerSet": "{price} por set", "pkgSaved": "{amount} poupados", "pkgPopular": "Escolha mais popular", "pkgBest": "Melhor preço", "pkgGuideFree": "Oferta: o teu guia de rotina de 30 dias", "pkgFreeBalance": "Daily Balance GRÁTIS em cada set (valor {price})", "free": "GRÁTIS", "setContentsTitle": "Conteúdo de cada set", "promoExcluded": "Os códigos promocionais não se aplicam ao Komplett-Set já com desconto.", "setShippingFree": "Envio gratuito", "tplSetEyebrow": "Daily Routine Komplett-Set · Método de 3 passos™", "tplSetH1": ["Três produtos. 2\u00a0minutos por dia.", "Para o teu dia a dia com a injeção para emagrecer."], "tplSetSeoTitle": "Daily Routine Komplett-Set para o dia a dia com a injeção para emagrecer | H2Humans", "tplSetSeoDesc": "Três produtos, uma rotina, 2 minutos por dia: proteína, eletrólitos e micronutrientes para o teu dia a dia com a injeção para emagrecer. Daily Balance grátis, envio grátis, garantia de rotina de 30 dias.", "tplSetSubline": "Proteína, eletrólitos e micronutrientes num sistema coordenado. Sem confusão de embalagens nem horas de pesquisa. Pensado para os dias em que as refeições são menores.", "tplSetBullets": [["A proteína pode contribuir para a manutenção da massa muscular", "1", ". Também nos dias com refeições menores."], ["A creatina pode contribuir para um melhor desempenho físico em exercício de curta duração e alta intensidade", "2", ""], ["O magnésio e a vitamina B12 podem contribuir para a redução do cansaço e da fadiga", "3", ""], ["Um plano em vez de cinco embalagens: manhã, dia, tarde e a boa sensação de ter pensado em tudo", "", ""], ["Sabe bem: shake de cacau e bebida cítrica", "", ""]], "jumpNavLabel": "Nesta página", "jumpNav": ["Benefícios", "Como funciona", "Testemunhos", "FAQ"], "guaranteeBadge": "Garantia de rotina de 30 dias: experimenta sem risco", "deliveryLineSet": "Entrega em {time} · Envio a partir da Alemanha · envio gratuito", "balanceFreeShort": "Daily Balance grátis", "footnotesLabel": "Notas", "jumpGuarantee": "Garantia", "priceNoteSet": "Preço com IVA · envio gratuito", "priceNoteSinglePrefix": "IVA incluído, mais", "priceNoteShippingLink": "envio", "paymentMethodsLabel": "Métodos de pagamento disponíveis", "guaranteeTitle": "Experimenta durante 30 dias. Se não se encaixar no teu dia a dia, devolvemos-te o dinheiro.", "guaranteeSteps": ["Encomendar", "Testar 30 dias", "Email simples para info@h2humans.com com o número da encomenda"], "guaranteeNoReturn": "Embalagem aberta? Não precisas de a devolver.", "guaranteeTermsLink": "Todas as condições", "footnotes": ["¹ A proteína pode contribuir para a manutenção da massa muscular.", "² A creatina pode contribuir para um melhor desempenho físico em séries sucessivas de exercício de curta duração e alta intensidade. Uma ingestão diária de 3 g de creatina é um requisito para esta indicação; a alegação destina-se a adultos que praticam exercício de alta intensidade.", "³ O magnésio e a vitamina B12 podem contribuir para a redução do cansaço e da fadiga.", "Os suplementos alimentares não substituem um regime alimentar variado e equilibrado nem um estilo de vida saudável."], "gpNav": "Garantia", "gpSeoTitle": "Garantia de rotina de 30 dias | H2HUMANS", "gpSeoDesc": "Testa a tua primeira encomenda durante 30 dias. Se não se encaixar no teu dia a dia, reembolsamos o preço.", "gpBack": "Voltar à página inicial", "gpTitle": "Garantia de rotina de 30 dias.", "gpIntro": "Testa a tua primeira encomenda durante 30 dias a partir da entrega. Se não se encaixar no teu dia a dia, reembolsamos o preço de compra.", "gpHowTitle": "Como funciona.", "gpHow": "Escreve-nos para info@h2humans.com no prazo de 30 dias após a entrega, com o número da encomenda. Reembolsamos no meio de pagamento original no prazo de 14 dias.", "gpCondTitle": "Condições.", "gpConditions": ["Válida para a tua primeira encomenda, uma vez por cliente.", "Reembolsamos totalmente uma embalagem aberta por produto ou um conjunto aberto, sem devolução.", "Nos pacotes de reserva (2 ou 3 conjuntos), devolves os conjuntos adicionais por abrir; os custos de devolução ficam a teu cargo.", "A garantia é um serviço voluntário e não afeta os teus direitos legais (livre resolução, garantia legal)."], "tplSetFaq": [["Quase não como. Como é que isto cabe no meu dia?", "Facilmente: o batido prepara-se em 30 segundos, o stick vai para a tua garrafa e ainda uma cápsula. Não precisas de ter fome."], ["Quando tomo nos dias com pouco apetite?", "Quando te sentires bem. Podes beber o batido em pequenos goles ou prepará-lo com mais líquido."], ["Já me alimento bem. Preciso disto?", "O conjunto é um complemento para dias com porções pequenas. Não substitui um regime alimentar variado e equilibrado."], ["É um substituto de refeição?", "Não. O conjunto complementa as tuas refeições."], ["A que sabe?", "Daily Body-Care é um batido de cacau, Daily Hydration uma bebida cítrica, ambos sem açúcar adicionado."], ["Quanto tempo dura um conjunto?", "Um conjunto dura 30 dias."], ["Que pacote é ideal para mim?", "1 mês é ideal para conhecer. 2 ou 3 meses são para uma rotina fixa, com o melhor preço por conjunto."], ["Como funciona a garantia?", "Em 3 passos: encomendar, testar 30 dias, enviar um email simples para info@h2humans.com com o número da encomenda.", "/garantie"], ["Os códigos promocionais aplicam-se ao conjunto?", "Não, o conjunto já tem desconto."]], "pkgPiece1": "1 unidade", "pkgPieces": "{n} unidades", "pkgPctSaved": "{pct} % de poupança", "pkgPerPiece": "{price} por unidade", "pkgPopularShort": "Popular", "pkgListPrice": "Preço normal", "priceNotePdpPrefix": "Preço c/ IVA, mais", "priceNoteFreeFrom": "grátis a partir de {amount}", "setBoxText": "No Daily Routine Komplett-Set poupas a partir de {amount}: Daily Balance grátis incluído", "balanceInSet": "No Komplett-Set, o Daily Balance está incluído grátis.", "tilesLabel": "Num relance", "tplBodyEyebrow": "Multi-fórmula · Passo 3 da Daily Routine", "tplBodyH1": "O teu batido de proteína para dias com pouco apetite. Pronto em 30 segundos.", "tplBodySubline": "22,4 g de proteína, 3 g de creatina e 3 g de colagénio num só batido. Sabor a cacau, sem açúcar adicionado.", "tplBodyBullets": [["A proteína pode contribuir para a manutenção da massa muscular", "1", ""], ["A creatina pode contribuir para um melhor desempenho físico em exercício de curta duração e alta intensidade", "2", ""], ["As vitaminas B6 e B12 podem contribuir para o normal metabolismo produtor de energia", "3", ""], ["Sete ingredientes num batido em vez de sete embalagens e a boa sensação de ter pensado em tudo", "", ""], ["Sabe a cacau: 1 medida, líquido, agitar", "", ""]], "tplBodyTiles": ["22,4 g de proteína", "3.000 mg de creatina", "3.000 mg de colagénio", "30 doses"], "tplBodyFaq": [["Como preparo o batido?", "Junta 1 medida (35 g) a 300 ml de água ou leite, agita e pronto."], ["É um substituto de refeição?", "Não. O Daily Body-Care complementa as tuas refeições."], ["Qual é o sabor?", "Cacau, sem açúcar adicionado."], ["Que alergénios contém?", "Leite (proteína de soro, segundo a lista de ingredientes). A lista completa está acima em “Ingredientes”."], ["Quanto tempo dura uma embalagem?", "Uma embalagem tem 30 doses, com 1 dose por dia dura 30 dias."], ["Há desconto de quantidade ou códigos?", "Sim: a partir de 2 unidades poupas 5 %, a partir de 3 unidades 10 %. Desconto de quantidade e códigos não são acumuláveis. Aplica-se automaticamente o desconto maior por produto."], ["Como funciona a garantia?", "Em 3 passos: encomendar, testar durante 30 dias, enviar um e-mail informal para info@h2humans.com com o número da encomenda.", "/garantie"]], "tplBodyFootnotes": ["¹ A proteína pode contribuir para a manutenção da massa muscular.", "² A creatina pode contribuir para um melhor desempenho físico em séries sucessivas de exercício de curta duração e alta intensidade. Uma ingestão diária de 3 g de creatina é um requisito para esta indicação; a alegação destina-se a adultos que praticam exercício de alta intensidade.", "³ As vitaminas B6 e B12 podem contribuir para o normal metabolismo produtor de energia.", "Os suplementos alimentares não substituem um regime alimentar variado e equilibrado e um estilo de vida saudável."], "tplHydEyebrow": "Fórmula de eletrólitos · Passo 2 da Daily Routine", "tplHydH1": "Beber sem te esqueceres. Um stick, uma garrafa, pronto.", "tplHydSubline": "Sódio, potássio e magnésio num stick. Sabor a citrinos, sem açúcar adicionado, 30 sticks para 30 dias.", "tplHydBullets": [["O magnésio pode contribuir para o equilíbrio eletrolítico", "1", ""], ["O potássio e o magnésio podem contribuir para o normal funcionamento muscular", "2", ""], ["Stick na garrafa: em viagem, no escritório, no treino", "", ""], ["Citrinos em vez de doce, sem açúcar adicionado e a boa sensação de ter pensado em tudo", "", ""], ["30 sticks = 30 dias, sem medir", "", ""]], "tplHydTiles": ["810 mg de sódio", "300 mg de potássio", "100 mg de magnésio", "30 sticks"], "tplHydFaq": [["Quanta água por stick?", "Dissolve 1 stick em 500 ml de água."], ["Quando é melhor beber?", "Quando te der jeito: por exemplo de manhã, fora de casa ou no treino. 1 stick por dia."], ["Qual é o sabor?", "Citrinos: fresco em vez de doce."], ["Contém açúcar ou adoçante?", "Não tem açúcar adicionado. Segundo a lista de ingredientes é adoçado com glicosídeos de esteviol (stevia)."], ["Posso tomar mais de um stick?", "Respeita a dose diária recomendada de 1 stick. Não deve ser excedida."], ["Há desconto de quantidade ou códigos?", "Sim: a partir de 2 unidades poupas 5 %, a partir de 3 unidades 10 %. Desconto de quantidade e códigos não são acumuláveis. Aplica-se automaticamente o desconto maior por produto."], ["Como funciona a garantia?", "Em 3 passos: encomendar, testar durante 30 dias, enviar um e-mail informal para info@h2humans.com com o número da encomenda.", "/garantie"]], "tplHydFootnotes": ["¹ O magnésio pode contribuir para o equilíbrio eletrolítico.", "² O potássio e o magnésio podem contribuir para o normal funcionamento muscular.", "Os suplementos alimentares não substituem um regime alimentar variado e equilibrado e um estilo de vida saudável."], "tplBalEyebrow": "Complexo de micronutrientes · Passo 1 da Daily Routine", "tplBalH1": "Os teus micronutrientes numa cápsula. Tomar de manhã, riscar da lista.", "tplBalSubline": "Vitamina D3, B12, folato, magnésio, zinco e selénio numa cápsula. 30 cápsulas para 30 dias.", "tplBalBullets": [["A vitamina B12 e o magnésio podem contribuir para a redução do cansaço e da fadiga", "1", ""], ["A vitamina D, o zinco e o selénio podem contribuir para o normal funcionamento do sistema imunitário", "2", ""], ["1 cápsula de manhã, sem separar, sem caos de comprimidos", "", ""], ["Para os dias em que as porções são pequenas e a boa sensação de ter pensado em tudo", "", ""], ["30 cápsulas = 30 dias", "", ""]], "tplBalTiles": ["30 µg de vitamina B12", "72 mg de magnésio", "22 vitaminas e minerais", "30 cápsulas"], "tplBalFaq": [["Quando tomo a cápsula?", "De preferência de manhã: 1 cápsula por dia."], ["Com ou sem comida?", "Toma a cápsula com uma refeição e um copo de líquido."], ["Posso combinar com outros suplementos?", "Se já tomas outros suplementos alimentares, verifica as quantidades totais de vitaminas e minerais. Em caso de dúvida, pergunta na farmácia ou ao teu médico."], ["Quanto tempo dura uma embalagem?", "Uma embalagem tem 30 cápsulas, com 1 cápsula por dia dura 30 dias."], ["Há desconto de quantidade ou códigos?", "Sim: a partir de 2 unidades poupas 5 %, a partir de 3 unidades 10 %. Desconto de quantidade e códigos não são acumuláveis. Aplica-se automaticamente o desconto maior por produto."], ["Como funciona a garantia?", "Em 3 passos: encomendar, testar durante 30 dias, enviar um e-mail informal para info@h2humans.com com o número da encomenda.", "/garantie"]], "tplBalFootnotes": ["¹ A vitamina B12 e o magnésio podem contribuir para a redução do cansaço e da fadiga.", "² A vitamina D, o zinco e o selénio podem contribuir para o normal funcionamento do sistema imunitário.", "Os suplementos alimentares não substituem um regime alimentar variado e equilibrado e um estilo de vida saudável."], "deliveryLine": "Entrega em {time} · enviado da Alemanha", "tplSetOutcome": "Para teres o básico sob controlo e te sentires bem abastecido/a todos os dias.", "tplBodyOutcome": "Para que o batido se encaixe na rotina, mesmo nos dias com pouco apetite.", "tplHydOutcome": "Para que beber deixe de ser uma tarefa.", "tplBalOutcome": "Para que a cápsula diária faça parte da tua rotina.", "seoTitleBody": "Daily Body-Care Batido de Proteína, para dias com pouco apetite | H2HUMANS", "seoTitleHyd": "Daily Hydration Sticks de Eletrólitos: 30 dias | H2HUMANS", "seoTitleBal": "Daily Balance Cápsulas de Micronutrientes: 30 dias | H2HUMANS", "setBodyCareBenefit": "Proteína, creatina e colagénio num batido.", "appDescPdp": "O teu companheiro pessoal para rotina, conhecimento e motivação: em cada fase.", "appFeature1Pdp": "Plano pessoal para cada fase", "whyShakesTitle": "Porque é que os batidos normais não servem.", "whyShakes": ["Porções grandes para muita fome.", "Só proteína, sem creatina nem colagénio.", "Sete embalagens em vez de uma."], "whyShakesClose": "Por isso, o Daily Body-Care tem tudo numa só medida.", "guideBonusTitle": "Oferta: o teu guia de rotina de 30 dias.", "guideBonusBody": "Com plano de toma, preparação, ideias para dias com pouco apetite e checklist para assinalar.", "preparationVideoLabel": "Vídeo de preparação.", "claimNotesTitle": "Informações sobre nutrientes e fontes.", "claimSourceLabel": "Fonte: Regulamento UE 432/2012", "whyShakesDemand": "Como orientação: a Sociedade Alemã de Nutrição recomenda aos adultos cerca de 0,8 g de proteína por quilograma de peso corporal por dia e, a partir dos 65 anos, cerca de 1,0 g.", "whyShakesMetaphor": "Um batido para muita fome é como um prato demasiado cheio: muitas vezes fica por acabar.", "whyHydTitle": "Porque beber fica tantas vezes esquecido.", "whyHydPoints": ["Menos refeições significa muitas vezes menos bebidas a acompanhar.", "Sem um momento fixo, é fácil esquecer.", "Uma garrafa cheia na mochila ainda não é um hábito."], "whyHydClose": "Por isso: um stick, uma garrafa, um momento fixo por dia.", "whyBalTitle": "Porque a base fica tantas vezes esquecida.", "whyBalPoints": ["Porções menores significam muitas vezes menos variedade no prato.", "Poucas pessoas mantêm a organização de seis suplementos separados.", "Um armário cheio de vitaminas ainda não é uma rotina."], "whyBalClose": "Por isso: uma cápsula, de manhã, assinalada."},
      listing: {"bundleSubline": "3 produtos, 1 rotina, 2 minutos por dia: Daily Balance grátis incluído.", "bundleAlt": "Daily Routine Kit Completo com Daily Body-Care, Daily Hydration e Daily Balance", "title": "O teu GLP-1 Supplement System.", "subtitle": "Três produtos coordenados para cada fase da tua terapia: individualmente ou como sistema completo.", "bestseller": "RECOMENDADO", "allProducts": "Todos os produtos", "saveVsSingle": "Poupas {amount} face à compra avulsa", "singlesTitle": "Produtos individuais", "listLabel": "Produtos", "faqTitle": "Perguntas sobre a", "faqTitleEm": "encomenda.", "faq": [["Como posso pagar?", "Podes pagar com {payMethods}. O pagamento é processado com segurança através da Stripe."], ["Como uso um código promocional?", "Introduz o código na página da encomenda antes do pagamento. Os códigos para novos clientes aplicam-se à tua primeira encomenda, os códigos de fidelidade dos nossos Founding Members a cada nova encomenda. Um código por encomenda, não acumulável com o desconto por quantidade nem com o preço do kit: aplica-se automaticamente o desconto maior."]]},
      affiliate: {"welcome": "Que bom que chegaste através de {name}. O teu desconto de 20 % nos produtos individuais está ativo. O Kit Completo já tem desconto, com Daily Balance grátis incluído.", "close": "Fechar aviso", "admin": {"title": "Relatório de parceiras.", "loginTitle": "Iniciar sessão.", "loginHint": "Enviamos-te um link de acesso por e-mail.", "email": "Endereço de e-mail", "send": "Enviar link de acesso", "sent": "Link enviado. Verifica a tua caixa de correio.", "denied": "Sem acesso com esta conta.", "logout": "Terminar sessão", "period": "Período", "thisMonth": "Este mês", "lastMonth": "Mês passado", "custom": "Período personalizado", "dateFrom": "De", "dateTo": "Até", "partner": "Influenciadora", "all": "Todas", "none": "Sem influenciadora", "orders": "Encomendas", "net": "Receita líquida", "set": "Kit", "singles": "Produtos individuais", "first": "Primeiras compras", "reorders": "Novas encomendas", "viaLink": "Via link", "viaCode": "Via código", "refunds": "Reembolsos", "commission": "Comissão", "csv": "Exportar CSV", "backfill": "Importar encomendas anteriores", "backfillDone": "{n} encomendas importadas.", "colOrder": "Número da encomenda", "colDate": "Data", "colKind": "Tipo", "colType": "Primeira/Nova", "colProducts": "Produtos", "colDiscount": "Desconto", "colRefunded": "Reembolsada", "testOrder": "Encomenda de teste · sem comissão", "colCustomer": "Cliente", "link": "Link", "code": "Código", "firstOne": "Primeira compra", "reorder": "Nova encomenda", "yes": "sim", "no": "não", "empty": "Sem encomendas neste período.", "netHint": "Receita líquida: valor pago dos produtos após desconto, sem envio e sem IVA (taxa do país de entrega). Encomendas de teste não contam para a receita das parceiras e, tal como as reembolsadas, não geram comissão."}},
    },
    // Header
    nav: {
      howItWorks: "Como funciona",
      benefits: "Benefícios",
      trust: "Confiança",
      products: "Produtos",
      science: "Qualidade",
      experts: "Especialistas",
      app: "App",
      about: "Sobre nós",
      blog: "Guia",
      community: "Comunidade",
      shopCta: "Comprar agora",
      openMenu: "Abrir menu de navegação",
      closeMenu: "Fechar menu de navegação",
      primaryNavLabel: "Navegação principal",
      mobileNavLabel: "Navegação móvel",
      homeLabel: "Página inicial H2HUMANS",
    },
    langToggle: "DE",

    // Hero
    hero: {
      beActiveSection: {"filmLabel":"DA COMUNIDADE","videoAlt":"Filme da campanha BE ACTIVE com a Angelika no HYROX","eyebrow":"FOUNDING MEMBER · HYROX KARLSRUHE · 04.10.2026","title":"BE ACTIVE!","sub1":"Ficar forte.","sub2":"Manter-se forte.","body":"A Angelika não é profissional. Tem um emprego, um dia a dia e uma rotina que cabe nele. Como se prepara para o HYROX, o que come no dia da prova e porque a recuperação faz parte do plano: mostra tudo de forma honesta e sem filtros.","stats":[{"v":"8 km","l":"Corrida"},{"v":"8","l":"Estações"},{"v":"1","l":"Rotina por trás"}],"chapters":["01 Preparação","02 Race Day","03 Recuperação"],"ctaStory":"Ver a história da Angelika","ctaShop":"A rotina dela na loja","newTab":"(abre num novo separador)","nextStop":"Próxima paragem: HYROX Frankfurt · 13.12.2026"},
      beActiveLanding: {"metaTitle":"BE ACTIVE! HYROX para pessoas comuns: O caminho da Angelika até à meta | H2Humans","metaDescription":"Preparação, dia da prova e recuperação: como a founding member da H2Humans Angelika correu o HYROX Karlsruhe, com semana de treino, plano do dia da prova e a sua rotina.","eyebrow":"H2HUMANS × ANGELIKA · HYROX KARLSRUHE · 04.10.2026","sub1":"HYROX para pessoas comuns.","sub2":"O caminho da Angelika até à meta.","body":"Sem profissionais, sem soluções milagrosas. Um emprego, um dia a dia e uma rotina que cabe nele. A Angelika mostra-te tudo em três capítulos: como treinou, o que comeu no dia da prova e porque seis dias de pausa depois fazem parte do plano.","filmLink":"Filme completo no Instagram ▸","chooseChapter":"Escolhe o teu capítulo","chapters":[{"n":"01","title":"Preparação","sub":"Semana de treino e semana da prova","alt":"Angelika a treinar para o HYROX"},{"n":"02","title":"Race Day","sub":"Hora a hora","alt":"Angelika no dia da prova no HYROX Karlsruhe"},{"n":"03","title":"Recuperação","sub":"Os dias seguintes","alt":"Angelika a recuperar depois da prova"}],"routineTab":"A rotina da Angelika","navLabel":"Navegação por capítulos","communityBack":"← Comunidade","communityMore":"Conhece outros founding members →"},
      beActivePrep: {"eyebrow":"CAPÍTULO 01 · PREPARAÇÃO","h1":"Uma semana normal.","h2":"Sem plano de profissional.","imgAlt":"Angelika a fazer sandbag lunges na aula","imgLabel":"TREINO EM AULA · SEM PERSONAL TRAINER","intro":"A Angelika não mudou a vida por causa do HYROX. Construiu uma semana que funciona ao lado do trabalho e do dia a dia, e que conseguiu cumprir semana após semana.","week":[{"v":"1×","l":"Treino de força"},{"v":"1–2×","l":"Treino HYROX em aula"},{"v":"2×","l":"Corrida: zona 2 + intervalos"},{"v":"1–2","l":"dias de descanso a sério"}],"dailyTitle":"No dia a dia","dailyText":"Proteína sempre em foco, eletrólitos no treino, 6–7 horas de sono.","rwTitle1":"A semana da prova.","rwTitle2":"O que muda, o que fica.","rwSource":"Do plano da Angelika para a semana da prova","rw":[{"label":"5–3 DIAS ANTES","title":"Ainda sem carb-loading","text":"Não cortar hidratos, continuar a comer proteína, manter tudo normal e equilibrado, beber o suficiente.","alt":"Papas de aveia com fruta"},{"label":"2–1 DIAS ANTES","title":"Hidratos no centro","text":"Massa, arroz, batatas, pão, fruta. Conscientemente mais, mas sem rebentar.","alt":"Prato de massa"},{"label":"TODOS OS DIAS","title":"Beber regularmente","text":"Não três litros de uma vez na manhã da prova. Os eletrólitos podem fazer sentido conforme a situação. Objetivo: bem hidratada na linha de partida, sem barriga de água.","alt":""},{"label":"MOVIMENTO","title":"Manter a leveza","text":"Um passeio, bicicleta leve, mobilidade, talvez uma corrida muito leve. Nada que faça as pernas perguntar no dia seguinte: “O que foi isto?”","alt":""}],"productLabel":"NA PREPARAÇÃO DA ANGELIKA · PUBLICIDADE","howLead":"Como a Angelika o usa:","howText":"Proteína sempre presente, de manhã nas overnight oats ou como batido depois do treino.","unit":"Preço por unidade: {price} / kg · IVA incl.","next":"Continuar para o capítulo 02: Race Day"},
      beActiveRace: { eyebrow: 'CAPÍTULO 02 · RACE DAY · 04.10.2026', h1: 'O plano dela para o dia da prova.', h2: 'Hora a hora.', steps: [{ time: '3–4 H ANTES', title: 'A última refeição maior', text: 'Hidratos de fácil digestão, proteína moderada, pouca gordura e fibra. No caso da Angelika: papas de aveia ou overnight oats com Daily Body-Care e fruta. Alternativas: arroz, tosta, banana.' }, { time: 'ATÉ À PARTIDA', title: 'Beber regularmente, aquecer com calma', text: 'Água com eletrólitos em pequenos goles. Aquecimento na bicicleta e no remo.' }, { time: '15–30 MIN ANTES', title: 'Um pequeno impulso de energia', text: 'Hidratos de absorção rápida: banana, puré de fruta, bolacha de arroz com mel ou um gel. Mas só o que já foi testado no treino.' }, { time: 'NA PROVA', title: '8 × 1 km de corrida, 8 estações', text: 'SkiErg, Sled Push, Sled Pull, Burpee Broad Jumps, Remo, Farmers Carry, Sandbag Lunges, Wall Balls.' }, { time: 'NA META', title: 'Primeiro repor, depois celebrar', text: 'Líquidos e eletrólitos com Daily Hydration, depois um batido Daily Body-Care.' }], ruleLabel: 'A REGRA MAIS IMPORTANTE DA ANGELIKA', rule: 'Nada de novo no dia da prova.', alts: ['Angelika em frente à parede HYROX', 'Angelika nos wall balls', 'Angelika no remo', 'Angelika no farmers carry', 'Angelika a cortar a meta'], productLabel: 'PRESENTE NO DIA DA PROVA · PUBLICIDADE', howText: 'no treino, antes da partida e logo à chegada à meta.', next: 'Continuar para o capítulo 03: Recovery' },
      beActiveRecovery: { eyebrow: 'CAPÍTULO 03 · RECUPERAÇÃO', h1: '6 dias.', h2: 'Sem treino.', imgAlt: 'Angelika a descontrair depois da prova', quote1: '“O meu corpo acabou de fazer algo incrível.', quote2: 'Agora posso cuidar dele.”', intro: 'A recuperação não é um dia de treino perdido, é a razão pela qual se continua. Passeios, massagem e alongamentos fazem parte fixa do plano da Angelika.', tips: [{ title: 'Primeiro, beber', text: 'Depois de mais de 60 minutos de esforço, faltam líquidos. Não litros de uma vez, mas regularmente nas horas seguintes, com eletrólitos.' }, { title: 'Agora não poupar na comida', text: 'Hidratos para repor as reservas, proteína para a regeneração muscular, mais fruta e legumes. Nada de “dieta de recompensa”, mas também nada de “agora vou exagerar”.' }, { title: 'Movimento sim. Esforço não.', text: 'Um passeio, mobilidade suave, pés para cima e muito sono. Exausta na manhã seguinte? Totalmente normal.' }], dontLabel: 'O QUE A ANGELIKA NÃO FAZ DEPOIS DO HYROX', dont1: '', dontEm: 'Castigar', dont2: 'o corpo por ter dado tudo.', donts: ['“Queimar” calorias', 'Cortar na comida', 'Voltar logo a fundo', 'Treinar mais duro “para compensar”'], productLabel: 'NA RECUPERAÇÃO DA ANGELIKA · PUBLICIDADE', productAlt: 'Batido Daily Body-Care depois da prova', productQuote: '“Depois do HYROX não me apetece nada complicado.”', textBefore: 'Por isso, depois da prova, tem um', textBold: 'batido Daily Body-Care', textAfter: 'pronto: misturar, beber, já está.' },
      beActiveRoutine: {"eyebrow":"A ROTINA DA ANGELIKA · OS TRÊS CAPÍTULOS","h1":"Uma rotina.","h2":"Do treino à recuperação.","intro":"Três produtos que acompanharam a Angelika na preparação, no dia da prova e na recuperação.","bestseller":"RECOMENDADO","label":"A ROTINA COMPLETA DA ANGELIKA","text":"Daily Body-Care, Daily Balance e Daily Hydration num só conjunto: tudo o que aparece nos três capítulos.","lines":["Preparação: Daily Body-Care & Daily Balance","Dia da prova: Daily Hydration","Recuperação: batido Daily Body-Care"],"vat":"IVA incl. · Envio grátis a partir de {amount}","singleLabels":{"body-care":"MULTI-FÓRMULA · CAPÍTULO 01 + 03","balance":"COMPLEXO DE MICRONUTRIENTES · TODOS OS DIAS","hydration":"FÓRMULA DE ELETRÓLITOS · CAPÍTULO 02"},"addToCart":"Adicionar ao carrinho","disclaimer":"Publicidade: a Angelika é founding member da H2Humans. É mostrada a sua rotina pessoal, não uma recomendação geral ou médica. Os suplementos alimentares não substituem uma alimentação variada e equilibrada nem um estilo de vida saudável."},
      headline: "O primeiro protocolo de bem-estar para o GLP-1.",
      subheadline:
        "O Sistema H2HUMANS, concebido por especialistas para o dia a dia com o GLP-1, reúne app, acompanhamento digital através do Teu +1 e suplementos desenvolvidos cientificamente.",
      trustLine: "Cientificamente fundamentado e desenvolvido com especialistas.",
      supportingCopy:
        "Desenvolvido por especialistas para o teu dia a dia com o GLP-1. App, Teu +1 companhia de IA e suplementos complementares com base científica, tudo como um só sistema.",
      ctaPrimary: "Garantir Acesso Antecipado agora",
      ctaPrimaryHeader: "Acesso Antecipado",
      earlyAccessNote:
        "Estamos a lançar o Sistema H2HUMANS com um pequeno grupo fundador de utilizadores de GLP-1, para o construirmos corretamente em conjunto. A lista de espera garante o teu lugar no primeiro grupo.",
      headlineLine1: "O peso vai.",
      headlineLine2: "A tua sensação fica.",
      body: "A H2Humans acompanha-te no dia a dia com a injeção para emagrecer: ao reduzir, pausar e parar. Pela tua força, pelas tuas rotinas e por essa mesma sensação.",
      ctaPrimaryApp: "Testa a app grátis",
      ctaMicro: "Acesso antecipado · grátis · sem compromisso",
      ctaShop: "Ir para a loja",
      intro:
        "O primeiro sistema de apoio GLP-1 da Alemanha, desenvolvido cientificamente para apoiar o teu corpo durante a terapia e para além: preventivamente e a longo prazo.",
      badges: {
        labTested: "Testado em laboratório",
        gmpCertified: "GMP certified",
        nonGmo: "Non-GMO",
        madeInGermany: "Fabricado em DE/AT",
      },
      scienceLink: "A ciência →",
    },

    // Is This For Me Section
    isThisForMe: {
      title: "Isto soa-te familiar?",
      items: [
        "Começaste agora o GLP-1 e sentes-te inseguro",
        "Com a terapia, o teu dia a dia muda: porções mais pequenas, outro ritmo, novas perguntas",
        "Notas mudanças emocionais que não consegues explicar",
        "Procuras respostas compreensíveis, sem jargão médico",
        "Não queres percorrer este caminho sozinho",
      ],
      notFor: "",
    },

    // Problem Section
    problem: {
      title: "Estás no caminho da mudança,\nmas energia, digestão e humor ficam para trás.",
      subtitle: "",
      items: [
        {
          title: "POUCO APETITE",
          stat: "",
          description: "Menos fome significa muitas vezes menos proteína, menos água, menos micronutrientes.",
        },
        {
          title: "DESORIENTADOS",
          stat: "68 %",
          description: "sentem-se sozinhos no dia a dia da terapia, sem orientação clara.",
        },
        {
          title: "ABANDONO E DÚVIDAS",
          stat: "> 50 %",
          description:
            "interrompem a terapia antes do tempo ou duvidam do seu caminho, muitas vezes por falta de acompanhamento.",
        },
        {
          title: "MUDANÇA EMOCIONAL",
          stat: "> 50 %",
          description: 'relatam alterações de humor, irritabilidade ou a sensação de "estar ao lado de si mesmo".',
        },
      ],
      conclusion: "",
      bridge: "",
      cta: "",
    },

    // Solution Section
    solution: {
      title: "O Teu +1, o teu companheiro diário durante a terapia GLP-1.",
      titleOverride: "O Teu +1 para o dia a dia com o GLP-1.",
      subtitle:
        "O teu sistema de apoio pessoal para os momentos em que a terapia GLP-1 é difícil de gerir sozinho.",
      betaNote: "App em beta, disponível gratuitamente.",
      items: [
        "Apoio personalizado em cada fase da tua terapia GLP-1",
        "Recomendações baseadas em evidências, explicadas de forma clara",
        "Rotina de suplementos adequada à tua fase",
        "A tua companhia de IA dá apoio emocional e ajuda-te a compreender melhor as mudanças",
        "Sempre prático. Sempre humano. Sempre claro.",
      ],
    },

    // Benefits Section
    benefits: {
      title: "O que muda para ti.",
      subtitle: "Menos atrito, mais clareza, ao teu ritmo.",
      items: [
        {
          title: "Mais segurança",
          description: "Orientação clara e conhecimento compreensível para cada fase.",
        },
        {
          title: "Menos stress",
          description: "Acompanhamento calmo em vez de excesso de informação.",
        },
        {
          title: "Orientação mais clara",
          description: "Compreender o que está a acontecer, e porquê.",
        },
        {
          title: "Rotinas sustentáveis",
          description: "Passos pequenos e exequíveis para sucesso a longo prazo.",
        },
        {
          title: "Apoio emocional",
          description: "Não estás sozinho, estamos aqui.",
        },
      ],
    },

    // How It Works Section
    howItWorks: {
      title: "Como o Teu +1 te apoia no dia a dia.",
      subtitle: "O Teu +1 adapta-se ao teu dia.\nComo te sentes define aquilo de que precisas.",
      steps: [
        {
          number: "01",
          title: "Chegar",
          description: "O Teu +1 compreende a tua situação com uma breve introdução ao teu dia a dia.",
        },
        {
          number: "02",
          title: "Manter o ritmo",
          description: "Lembretes, pequenos impulsos e rotinas que se ajustam ao teu dia.",
        },
        {
          number: "03",
          title: "Avançar",
          description: "Apoio que evolui contigo, passo a passo.",
        },
      ],
      moodIntro: "Cada dia sente-se diferente. O Teu +1 responde a isso.",
      scenarios: [
        {
          title: "MANHÃ DIFÍCIL",
          mood: "Cansado, inseguro, desmotivado",
          responses: ["Início suave sem pressão", "Descobrir o que precisas hoje", "Passos simples para mais energia"],
        },
        {
          title: "DIA INTENSO",
          mood: "Ativo mas mentalmente sobrecarregado",
          responses: [
            "Não te esqueças das pausas",
            "Reconhecer cedo a sobrecarga",
            "Manter refeições e suplementos sob controlo",
          ],
        },
        {
          title: "NOITE INQUIETA",
          mood: "Irritado, exausto, agitado",
          responses: ["Tira tempo para ti", "Reflete sobre o que ajudou hoje", "Abranda e dorme bem"],
        },
      ],
    },

    // What Happens Next Section
    whatHappensNext: {
      title: "O que acontece depois da inscrição?",
      signupTitle: "O que acontece depois da tua inscrição sem compromisso?",
      signupSubtitle: "Três passos simples e estás dentro.",
      signupSteps: [
        {
          title: "Confirmação por email",
          description: "Recebes confirmação imediata. O teu lugar está reservado.",
        },
        {
          title: "Convite de Acesso Antecipado",
          description: "Assim que lançarmos, estás entre os primeiros a ter acesso.",
        },
        {
          title: "Conhecer o Teu +1",
          description: "Breve integração e o teu companheiro pessoal fica disponível para ti.",
        },
      ],
      dataPrivacyTooltip: {
        title: "Os teus dados pertencem-te",
        description: "Em conformidade com o RGPD. Sem partilha. Controlo total.",
      },
      steps: [
        {
          number: "1",
          title: "Confirmação por email",
          description: "Recebes confirmação imediata e sabes que o teu lugar está reservado.",
        },
        {
          number: "2",
          title: "Convite de Acesso Antecipado",
          description: "Assim que lançarmos, estás entre os primeiros a ter acesso.",
        },
        {
          number: "3",
          title: "Conhecer o Teu +1",
          description: "Breve integração e o teu companheiro pessoal fica imediatamente disponível.",
        },
      ],
    },

    // Founding Member Section
    foundingMember: {
      title: "Faz parte desde o início",
      subtitle: "Garante acesso antecipado, sem compromisso e antes do lançamento oficial.",
      benefits: [
        "30 dias gratuitos",
        "Sem pagamento antecipado",
        "Cancelável a qualquer momento",
        "Vagas limitadas",
      ],
      cta: "Começar gratuitamente",
    },

    // Trust Section
    trust: {
      title: "Construído na confiança. Apoiado pela ciência.",
      items: [
        {
          title: "Cientificamente fundamentado",
          description: "As nossas recomendações baseiam-se na investigação atual sobre GLP-1.",
        },
        {
          title: "Os teus dados pertencem-te",
          description: "Em conformidade com o RGPD. Sem partilha. Controlo total.",
        },
        {
          title: "Sem promessas de cura. Apenas apoio honesto.",
          description: "A H2HUMANS é uma companhia de bem-estar, não um dispositivo médico. Não fazemos promessas de cura.",
        },
      ],
      disclaimer:
        "O Teu +1 é uma companhia de bem-estar da H2HUMANS, não é um medicamento e não substitui aconselhamento médico.",
      expertsTitle: "O que os especialistas dizem sobre o Teu +1",
      experts: [
        {
          name: "Anna Pereira, PhD, MS",
          title: "Embodied Cognition · Ciência Comportamental · Investigação Mente-Corpo",
          quote:
            "O Teu +1 combina profundidade científica com utilidade real no dia a dia. Em especial, o foco no humor, na autoconsciência e nas rotinas mostra como é importante não otimizar as pessoas, mas sim acompanhá-las.",
          website: "actincycle.com",
        },
        {
          name: "Johannes Weiss",
          title: "Longevidade e Performance · Estratégias de Saúde · Prevenção Prática",
          quote:
            "O que me convence no Teu +1 é a abordagem estruturada e responsável. Em vez de soluções rápidas, trata-se de orientação, prevenção e rotinas sustentáveis, exatamente aquilo que falta a muitas pessoas no dia a dia.",
          website: "longevity-wien.at",
        },
      ],
    },

    // Privacy Block
    privacy: {
      title: "Os teus dados permanecem humanos.",
      items: [
        "Os teus dados nunca são vendidos",
        "Decides o que é guardado",
        "Sem diagnósticos médicos",
        "O acompanhamento complementa, não substitui médicos",
      ],
    },

    // Sticky Banner
    stickyBanner: {
      ticker: {
        label: "Novidades",
        newArticleKey: "Novo no Guia",
        newArticleRest: ": Preservar a massa muscular após interromper",
        articlesKey: "{count} artigos",
        articlesRest: " com base científica no Guia",
        qualityRest: "Testado em laboratório · Certificação GMP · Fabricado em DE/AT",
        appKey: "Experimenta a app grátis",
        appRest: ": Early Access",
        pause: "Pause",
        play: "Play",
      },
      guideTeaser: "Novo no guia: Manter a massa muscular depois de parar",
    },

    // Newsletter Section
    newsletter: {
      title: "Um amanhã mais saudável",
      titleEm: "começa hoje.",
      description: "15% na tua primeira encomenda: mais atualizações exclusivas e investigação GLP-1 na tua caixa de entrada.",
      discountHighlight: "15% na tua primeira encomenda",
      descriptionRest: "mais atualizações exclusivas e investigação GLP-1 na tua caixa de entrada.",
      placeholder: "your@email.com",
      submitting: "A enviar...",
      submit: "Obter 15%",
      success: "Obrigado, estás na lista de espera.",
      error: "Algo correu mal. Por favor tenta novamente.",
      note: "Sem spam. Cancela quando quiseres.",
      consentPrefix: "Ao subscreveres concordas com a nossa ",
      consentLink: "Política de Privacidade",
      consentSuffix: ".",
      finePrint: "Válido para a tua primeira encomenda. Não acumulável com outros códigos de desconto.",
      finePrintPartner: "Descontos exclusivos através dos nossos parceiros podem ser superiores.",
      pendingTitle: "Quase lá!",
      pendingBody: "Enviámos-te um email. Confirma a tua subscrição para receberes o teu código de 15%.",
      resend: "Não recebeste o email? Enviar novamente",
      resending: "A enviar novamente...",
      resent: "Email enviado novamente.",
      resendWait: "Aguarda um momento antes de tentares novamente.",
      alreadyConfirmed: "Este email já está subscrito connosco.",
      confirmedTitle: "Confirmado!",
      confirmedBody: "O teu código está a caminho. Verifica a tua caixa de entrada.",
      confirmedCta: "Ir para a loja",
      failedTitle: "Link inválido ou expirado.",
      failedBody: "Este link de confirmação já foi usado ou expirou. Basta subscreveres novamente.",
      failedCta: "Subscrever novamente",
      popupClose: "Fechar",
      popupTitle: "15% na tua",
      popupTitleEm: "primeira encomenda.",
      popupSentence: "Mais novidades exclusivas e investigação sobre GLP-1 diretamente na tua caixa de correio.",
      popupSuccess: "Quase lá. Confirma o teu e-mail.",
    },


    // Promise Section
    promise: {
      title: "Qualidade que consegues ",
      titleEm: "ver e verificar.",
      subtitle: "Cada ingrediente numa dose clinicamente estudada. Sem aditivos de enchimento, sem atalhos.",
      moleqlarTitle: "Desenvolvido com a MoleQlar",
      moleqlarBody1:
        "Os nossos suplementos foram desenvolvidos em conjunto com os cientistas da MoleQlar, uma empresa alemã líder em investigação de longevidade e saúde molecular.",
      moleqlarBody2:
        "As formulações baseiam-se em evidência científica atual e são desenvolvidas e produzidas segundo os mais elevados padrões de qualidade. É assim que garantimos que cada produto H2HUMANS é baseado na ciência, transparente e de qualidade intransigente.",
      tags: ["GMP", "IFS Food", "ISO 22000", "HACCP"],
    },

    // Journal Section
    journal: {
      titleEm: "A nossa história",
      titleSuffix: "por trás da H2Humans.",
      subtitle: "Análises detalhadas sobre investigação GLP-1, nutrição de performance, life hacks e as pessoas por trás da H2Humans.",
      heading: "Porque fundámos a H2Humans.",
      body1:
        "A H2Humans nasceu das nossas próprias experiências com a terapia GLP-1, assim como de inúmeras conversas com amigos, família, médicos e pessoas em terapia.",
      body2:
        "Milhões de pessoas voltam a ter controlo sobre o seu peso graças a medicamentos GLP-1. Mas o verdadeiro desafio começa muitas vezes depois. Muitas pessoas sentem-se sozinhas em temas como nutrição, suporte nutricional, saúde muscular e manutenção do peso a longo prazo.",
      body3:
        "Acreditamos que o sucesso sustentável exige mais do que uma prescrição. Por isso estamos a construir a H2Humans: um sistema cientificamente fundamentado de produtos, conhecimento e acompanhamento, que apoia as pessoas a viver a sua jornada GLP-1 com consciência, sucesso e saúde.",
      body4:
        "Com uma comunidade global de em breve mais de 200 milhões de utilizadores de GLP-1, vemos a oportunidade de resolver um dos maiores problemas de saúde do nosso tempo, para que a perda de peso de curto prazo se transforme em saúde de longo prazo.",
      learnMore: "Saber mais",
      aboutImageAlt: "H2Humans sobre nós",
    },

    // App Section
    app: {
      betaBadge: "Versão BETA Gratuita",
      earlyAccessBadge: "Versão Early Access 0€",
      title: "O Teu +1 para o dia a dia com o ",
      titleEm: "GLP-1.",
      description:
        "O teu sistema de apoio pessoal para os momentos em que a terapia GLP-1 sozinha é difícil de gerir.",
      screenHomeAlt: "App H2Humans: ecrã inicial",
      screenProgressAlt: "App H2Humans: progresso",
      features: [
        { title: "Apoio personalizado em cada fase da tua terapia GLP-1", body: "" },
        { title: "Recomendações baseadas em evidências, explicadas de forma clara", body: "" },
        { title: "Rotina de suplementos adequada à tua fase", body: "" },
        { title: "A tua companhia de IA dá apoio emocional e ajuda-te a compreender melhor as mudanças", body: "" },
        { title: "Sempre prático. Sempre humano. Sempre claro.", body: "" },
      ],
    },

    // Science Section
    science: {
      title: "Construído na ciência. Guiado pela ",
      titleEm: "experiência.",
      subtitle:
        "Dois parceiros de confiança. Uma missão partilhada:\ntornar a saúde baseada em evidências mais acessível, através de expertise científica, formulações premium e acompanhamento prático para o dia a dia.",
      learnMore: "Saber mais",
      back: "Voltar",
      next: "Seguinte",
      moleqlarTags: ["GMP", "ISO/IEC 17025", "HACCP", "Lab tested"],
      experts: [
        {
          badge: "Parceiro de Suplementos de Confiança",
          name: "MoleQlar",
          role: "Fundada por médicos · Berlim/Munique · ISO/IEC 17025",
          backRole: "Fundada por médicos · Alemanha e Áustria",
          backItems: [
            "Fundada por três médicos",
            "Cada lote testado de forma independente em laboratório",
            "Produzido em instalações certificadas na Alemanha e na Áustria",
            "Mais de 100.000 clientes em toda a Europa",
            "Qualidade e transparência baseadas na ciência",
          ],
          credentials: ["Garantia de Qualidade", "Ciência da Longevidade", "Formulação Baseada em Evidências"],
          alt: "Apresentação do parceiro de suplementos MoleQlar",
        },
        {
          badge: "Embaixador de Saúde",
          name: "Nuriel Molcho",
          role: "Saúde · Nutrição · Desporto",
          backRole: "Saúde · Nutrição · Desporto",
          backItems: [
            "Cofundador do grupo de restaurantes NENI",
            "Defensor da nutrição, do movimento e de uma vida saudável",
            "Apaixonado por longevidade e performance",
            "Apoia a missão da H2Humans de integrar o bem-estar no dia a dia",
          ],
          credentials: ["Estilo de Vida Saudável", "Nutrição", "Performance"],
          alt: "Retrato de Nuriel Molcho",
        },
      ],
    },

    // Principles Section
    principles: {
      title: "Aquilo em que ",
      titleEm: "acreditamos.",
      subtitle: "Tudo o que construímos está ancorado na ciência, na transparência e na utilidade real do dia a dia.",
      items: [
        {
          number: "01",
          title: "Construído com intenção e impacto",
          body: "Cada produto resolve um problema claramente definido e baseado em evidências. Nenhum suplemento existe sem uma razão clínica fundamentada.",
        },
        {
          number: "02",
          title: "Dosagens estudadas clinicamente",
          body: "Dosamos de acordo com a ciência. Formas bioativas em vez de alternativas mais baratas.",
        },
        {
          number: "03",
          title: "Fabricado segundo a norma GMP na Alemanha e na Áustria",
          body: "",
        },
        {
          number: "04",
          title: "Nós próprios usamos",
          body: "Nenhum produto que nós mesmos não tomaríamos todos os dias. O nosso filtro de qualidade mais rigoroso.",
        },
      ],
    },

    // FAQ Section
    faq: {
      title: "Perguntas frequentes.",
      items: [
        {
          icon: "help",
          tone: "neutral",
          question: "A H2HUMANS é um medicamento?",
          answer: [
            {
              type: "paragraph",
              text: "Não. A H2HUMANS é uma companhia de bem-estar, não um medicamento. Não substituímos aconselhamento médico. Consulta sempre o teu médico antes de tomares suplementos.",
            },
          ],
        },
        {
          icon: "clock",
          tone: "positive",
          question: "Quanto tempo demora a ver resultados?",
          answer: [
            {
              type: "paragraph",
              text: "O nosso protocolo de acompanhamento foi concebido para apoiar as mudanças de forma estruturada e mensurável. Os primeiros efeitos podem surgir nas primeiras semanas. Para uma avaliação consistente recomendamos um período de pelo menos 3 meses.",
            },
          ],
        },
        {
          icon: "shield",
          tone: "positive",
          question: "Os suplementos são seguros?",
          answer: [
            { type: "paragraph", text: "Todos os nossos suplementos são:" },
            {
              type: "list",
              items: ["Fabricado em DE/AT", "Lab Tested", "GMP Certified", "Non-GMO", "Desenvolvidos com especialistas"],
            },
            { type: "paragraph", text: "Trabalhamos apenas com os mais elevados padrões de qualidade." },
          ],
        },
        {
          icon: "bot",
          tone: "caution",
          question: "Como funciona o Teu +1?",
          answer: [
            { type: "paragraph", text: "O Teu +1 é uma companhia de IA que te dá recomendações personalizadas." },
            {
              type: "list",
              heading: "O Teu +1 NÃO é:",
              headingColor: "coral",
              items: [
                "Um terapeuta (não substituímos ajuda profissional)",
                "Um médico (não damos aconselhamento médico)",
              ],
            },
            {
              type: "list",
              heading: "O Teu +1 É:",
              headingColor: "green",
              items: [
                "Um companheiro (apoio emocional)",
                "Um coach (dicas práticas)",
                "Disponível 24/7 (sempre contigo)",
                "Construído numa base puramente científica e baseia-se exclusivamente em conhecimento de publicações e fontes fundamentadas",
              ],
            },
          ],
        },
        {
          icon: "trending",
          tone: "positive",
          question: "Isto funciona mesmo?",
          answer: [
            { type: "paragraph", text: "Depende de ti. A H2HUMANS funciona melhor quando:" },
            {
              type: "list",
              items: [
                "Tomas os suplementos com regularidade",
                "Usas a app diariamente",
                "Segues as recomendações do Teu +1",
                "Tens paciência",
              ],
            },
          ],
        },
        {
          icon: "mail",
          tone: "neutral",
          question: "Como posso contactar a H2HUMANS?",
          answer: [
            {
              type: "paragraph",
              text: "Envia-nos um email para info@h2humans.com e respondemos o mais rapidamente possível.",
            },
          ],
        },
      ],
    },

    // Supplement Value Comparison
    supplementComparison: {
      headline: "Orientação em vez de",
      headlineAccent: "sobrecarga",
      subline: "Um sistema coordenado, concebido para o teu corpo,\nos teus objetivos e a tua vida.",
      chaosLabel: "SEM SISTEMA",
      chaosPoints: [
        "Demasiados produtos,\nsem visão geral",
        "Dosagem pouco clara e\ntiming errado",
        "Sem adaptação ao\nGLP-1",
        "Informação\ncontraditória",
        "Muito esforço,\nsem consistência",
      ],
      chaosBottom: "Incerteza · Sobrecarga · sem progresso",
      systemLabel: "COM A H2HUMANS",
      systemWith: "Com",
      systemPoints: [
        "Um sistema coordenado\nem vez de produtos isolados",
        "Dosagem clara e\ntiming ideal",
        "Desenvolvido especificamente\npara a terapia GLP-1",
        "Cientificamente fundamentado",
        "App, suplementos e\nTeu +1 incluídos",
      ],
      systemBottomPrefix: "Clareza · Estrutura · ",
      systemBottomAccent: "resultados reais",
      trustBadges: [
        { label: "Fabricado em DE/AT", sub: "Máxima qualidade" },
        { label: "Non GMO", sub: "Sem engenharia genética" },
        { label: "Sem glúten", sub: "Bem tolerado" },
        { label: "GMP Certified", sub: "Produção certificada" },
        { label: "Lab Tested", sub: "Verificado em laboratório" },
      ],
    },

    // 404 Not Found
    notFound: {
      seoTitle: "404 | Página não encontrada | H2HUMANS",
      seoDescription: "A página que procuras não foi encontrada.",
      code: "404",
      heading: "Oops! Página não encontrada",
      homeLink: "Voltar à página inicial",
      body: "Esta página não existe (mais). Talvez isto ajude:",
      blogLink: "Para o Guia",
      shopLink: "Para a loja",
    },

    // Unsubscribe page
    unsubscribe: {
      seoTitle: "Cancelar subscrição | H2HUMANS",
      seoDescription: "Gere as tuas preferências de subscrição de email.",
      loading: "A processar…",
      successTitle: "Subscrição cancelada com sucesso",
      successBody: "Foste cancelado com sucesso de futuros emails de marketing.",
      errorTitle: "Falha no cancelamento",
      errorBody: "O link de cancelamento é inválido ou expirou.",
      back: "Voltar à página inicial",
    },

    // Email Unsubscribe page
    emailUnsubscribe: {
      title: "Cancelar email",
      intro: "Queres cancelar a subscrição dos emails da H2HUMANS?",
      confirm: "Confirmar cancelamento",
      success: "Foste cancelado com sucesso.",
      already: "Este email já está cancelado.",
      error: "O link é inválido ou expirou.",
      back: "Voltar à página inicial",
      loading: "A processar…",
    },

    // Checkout Return page
    checkoutReturn: {
      title: "Pagamento bem sucedido!",
      body: "Obrigado pela tua encomenda. Vais receber em breve uma confirmação por email.",
      back: "Voltar à página inicial",
      emailSending: "A enviar email de confirmação…",
      emailSent: "Email de confirmação enviado.",
      emailError: "Não foi possível enviar o email de confirmação. Em caso de dúvidas contacta info@h2humans.com.",
      orderLabel: "Número da encomenda:",
      orderReference: "Por favor indica este número da encomenda em qualquer contacto.",
      guideTitle: "O teu guia de rotina de 30 dias.",
      guideBody: "Com plano de toma, preparação, ideias para dias com pouco apetite e checklist para assinalar.",
      guideCta: "Abrir guia de rotina",
      nextOrderTip: "Dica para a próxima encomenda: no Daily Routine Kit Completo, o Daily Balance está incluído grátis.",
    },
    setValue: {"needTitle": "Porções menores. Complementar com atenção.", "need": ["Menos apetite pode acompanhar refeições menores e alterações na ingestão de líquidos. A suplementação adequada depende da alimentação e das necessidades individuais.", "Daily Body-Care combina proteína, creatina e colagénio num batido. A preparação e o tamanho da dose constam da recomendação de utilização.", "E cinco embalagens avulsas sem plano raramente duram no dia a dia."], "needClose": "Por isso transformámos três produtos numa rotina.", "needCta": "Escolher pacote", "costTitle": "Comprado avulso vs. Kit Completo.", "costSub": "Quanto custariam os componentes incluídos em separado durante 30 dias.", "costCols": ["Componente", "Quantidade por dose", "Avulso*"], "costExtra": [{"name": "Mistura de eletrólitos (Daily Hydration)", "benefit": "1 stick", "competitor": "~30 €"}, {"name": "Base de micronutrientes (Daily Balance)", "benefit": "1 cápsula", "competitor": "~15 €"}], "costTotal": "Soma dos componentes", "costTotalValue": "~173 €", "costSet": "Kit Completo desde 84,90 €", "costSetNote": "por mês no pacote de 3 meses", "vsTitle": "Kit Completo vs. alternativas.", "vsCols": ["Kit Completo", "Batido de proteína comum", "Suplementos avulsos"], "vsRows": [["Proteína + creatina + colagénio numa dose", 1, 0, 0], ["Eletrólitos para levar", 1, 0, 1], ["Base de micronutrientes", 1, 0, 1], ["Plano por fase na app", 1, 0, 0], ["GMP & Fabricado em DE/AT", 1, 2, 2], ["Uma encomenda em vez de cinco", 1, 1, 0]], "vsYes": "Sim", "vsNo": "Não", "vsVaries": "Depende do produto", "vsNote": "Comparação com categorias típicas de produtos, não com fornecedores individuais.", "needDemand": "Como orientação geral: a Sociedade Alemã de Nutrição (DGE) recomenda aos adultos cerca de 0,8 g de proteína por quilograma de peso corporal por dia e, a partir dos 65 anos, cerca de 1,0 g.", "needSourceLabel": "Fonte: valores de referência DGE para proteína", "needMetaphor": "Uma lista de compras com cinco produtos ainda não é um plano. A Daily Routine é o plano semanal que a acompanha."},
    threeStep: {"title": "Como funciona o método de 3 passos™.", "steps": [["Manhã", "Daily Balance", "1 cápsula: a tua base de micronutrientes."], ["Durante o dia", "Daily Hydration", "1 stick na garrafa: eletrólitos para levar."], ["Tarde", "Daily Body-Care", "1 batido em 30 segundos, com proteína, creatina e colagénio."]], "stepLabel": "Passo {n}", "app": "O plano certo para a tua fase está na app.", "tlTitle": "Os teus primeiros 30 dias.", "tl": [["Dia 1", "Desembala o kit, abre o guia de rotina."], ["Dia 3", "A rotina encontra o seu lugar."], ["Dia 14", "Já funciona sem pensar."], ["Dia 30", "Encomenda a reposição ou usa a garantia."]], "compactTitle": "Parte do método de 3 passos™.", "compactCurrent": "Este produto", "compactCta": "Os três no Kit Completo"},
    routineGuide: {"seoTitle": "Guia de rotina de 30 dias | H2HUMANS", "seoDesc": "Com plano de toma, preparação, ideias para dias com pouco apetite e checklist para assinalar.", "eyebrow": "Daily Routine", "title": "O teu guia de rotina de 30 dias.", "intro": "Um produto ou os três: este guia ajuda-te a criar a tua rotina nos primeiros 30 dias.", "pdf": "Guardar como PDF", "pdfHint": "Escolhe “Guardar como PDF” na janela de impressão.", "planTitle": "Plano de toma.", "plan": [["Manhã: Daily Balance", "1 cápsula com um copo de água, de preferência ao pequeno-almoço ou à primeira refeição."], ["Durante o dia: Daily Hydration", "1 stick na tua primeira garrafa de água do dia. Bebe ao longo da manhã ou em movimento."], ["Tarde: Daily Body-Care", "1 batido como momento fixo, p. ex. como snack entre o almoço e o jantar ou após o treino."]], "planNote": "É uma sugestão. Se outro momento encaixar melhor no teu dia, usa-o. O importante é que seja igual todos os dias.", "prepTitle": "Preparação.", "prep": [["Daily Body-Care", "Junta 1 medida a 300 ml de água fria, leite ou bebida vegetal e agita bem durante 15 segundos. Com gelo fica mais fresco."], ["Daily Hydration", "Junta 1 stick a uma garrafa de água fria e agita brevemente. Mais água torna o sabor mais suave."], ["Daily Balance", "Engole 1 cápsula inteira com líquido suficiente."]], "lowTitle": "Ideias para dias com pouco apetite.", "low": [["Começa devagar", "Bebe o batido em pequenos goles durante 20 a 30 minutos em vez de tudo de uma vez."], ["Divide", "Prepara o batido com um pouco mais de líquido e bebe metade à tarde e a outra ao início da noite."], ["Varia", "Mistura o batido com um expresso para um batido moca, ou com gelo e meia banana na liquidificadora."], ["O frio ajuda", "Frescos, o batido e a bebida sabem muitas vezes melhor quando comer custa."]], "lowNote": "Se o teu apetite se mantiver muito baixo durante muito tempo, fala com o teu médico.", "drinkTitle": "Lembrete para beber.", "drink": [["Torna visível", "Coloca a garrafa com o stick onde a vês o dia todo: secretária, cozinha, mala."], ["Associa", "Liga cada garrafa a um momento fixo, p. ex. início do trabalho, pausa de almoço, regresso a casa."], ["Recebe lembretes", "Define um alarme no telemóvel nas primeiras duas semanas ou usa os lembretes da app H2HUMANS."]], "checkTitle": "Checklist semanal.", "week": "Semana {n}", "weeks": [["Preparar", "Define os teus três momentos e coloca os produtos onde precisas deles."], ["Consolidar", "Mesmos momentos, todos os dias. Se um não der, muda-o, mas não o saltes."], ["Manter", "Repara na tua garrafa. Está vazia até à tarde?"], ["Balanço", "O que funcionou bem, o que queres mudar? O teu kit dura mais alguns dias. Planeia a reposição."]], "days": ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"], "checks": ["Balance", "Hydration", "Body-Care"], "checkLabel": "{item}, semana {n}, {day}", "reorder": "Encomenda a tempo: com o pacote de 2 ou 3 meses poupas mais por kit.", "reorderCta": "Ver o Kit Completo", "guarantee": "A rotina não encaixa no teu dia a dia? A nossa garantia de rotina de 30 dias aplica-se a partir da entrega.", "guaranteeLink": "Ver garantia", "legal": "Os suplementos alimentares não substituem uma alimentação variada e equilibrada nem um estilo de vida saudável. Não exceder a toma diária recomendada. Manter fora do alcance das crianças. Se tomas medicação, estás grávida ou a amamentar, fala com o teu médico antes de tomar."},
    shippingPage: {"and": "e", "metaTitle": "Condições de envio | H2HUMANS", "metaDesc": "Envio com a H2HUMANS: {cost} por encomenda, grátis a partir de {amount} em valor de mercadoria, o Kit Completo sempre com envio gratuito. Entrega apenas na Alemanha em {time}.", "back": "Voltar à página inicial", "title": "Condições de envio", "tableTitle": "Custos de envio e prazos de entrega", "colCountry": "País", "colCost": "Custos de envio", "colTime": "Prazo de entrega", "rowCost": "{cost} ({carrier}) · grátis a partir de {amount} em valor de mercadoria", "countries": {"DE": "Alemanha", "AT": "Áustria"}, "bundleNote": "Enviamos o Daily Routine Kit Completo sempre sem custos de envio.", "basisNote": "Conta o valor da mercadoria após descontos (desconto de quantidade, códigos de desconto), sem custos de envio.", "condTitle": "Condições de entrega", "cond1": "Atualmente entregamos na {countries}. Salvo indicação de outro prazo na respetiva oferta, a entrega da mercadoria é feita após a celebração do contrato (em caso de pagamento antecipado acordado, após a tua ordem de pagamento). O prazo de entrega é de {time}.", "cond2": "Tem em atenção que não são feitas entregas aos domingos e feriados. A tua encomenda é processada automaticamente. Por isso, normalmente não conseguimos fazer alterações pouco depois da encomenda.", "cond3": "Se encomendaste artigos com prazos de entrega diferentes, enviamos a mercadoria numa única remessa, salvo acordo diferente contigo. O prazo de entrega é determinado pelo artigo com o prazo de entrega mais longo.", "partnerTitle": "Parceiros de envio", "partner": "O envio é feito com os nossos parceiros de envio {carriers}.", "costTitle": "Custos de envio", "costVat": "Todas as indicações sobre custos de envio incluem o IVA legal.", "updated": "Atualizado: {date}"},
    paymentMethodList: {"withPaypal": "cartão, PayPal, Apple Pay, Google Pay e Klarna", "withoutPaypal": "cartão, Apple Pay, Google Pay e Klarna"},
    shopTerms: {"title": "Termos da loja", "pricesTitle": "Preços e custos de envio", "prices": "Todos os preços incluem o IVA legal. Acrescem custos de envio de {cost} por encomenda. A partir de um valor de mercadoria de {amount} após descontos, entregamos sem custos de envio na Alemanha. O Daily Routine Kit Completo é sempre entregue sem custos de envio. O prazo de entrega é de {time}. Detalhes em", "link": "Condições de envio", "paymentTitle": "Métodos de pagamento", "payment": "O pagamento é processado pelo nosso prestador de serviços de pagamento Stripe. Estão disponíveis {payMethods}. O Apple Pay e o Google Pay só aparecem em dispositivos e navegadores compatíveis.", "paymentPaypal": "Ao pagar com PayPal, és redirecionado para o PayPal; aplicam-se adicionalmente as condições do PayPal."},
    agbShop: {"pageTitle": "Termos e Condições", "title": "Condições de venda (loja)", "placeholder": "A completar.", "earlyTitle": "Condições do Early Access"},
    privacyPayments: {"title": "Serviços de pagamento PayPal e Google Pay", "paypal": "O prestador do serviço de pagamento PayPal é a PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburgo. Se escolheres o PayPal como método de pagamento no checkout, és redirecionado para o PayPal. Os teus dados de pagamento (por exemplo, nome, endereço de e-mail, montante e número da encomenda) são transmitidos ao PayPal e aí tratados para efeitos de processamento do pagamento. A base legal é o art. 6.º, n.º 1, alínea b) do RGPD (execução do contrato). Mais informações na declaração de privacidade do PayPal: ", "googlePay": "O prestador do serviço de pagamento Google Pay é a Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irlanda. Se utilizares o Google Pay no checkout, os teus dados de pagamento (por exemplo, o cartão guardado no Google Pay, nome, morada de faturação e montante) são tratados entre a Google e o nosso prestador de serviços de pagamento Stripe para efeitos de processamento do pagamento. A base legal é o art. 6.º, n.º 1, alínea b) do RGPD (execução do contrato). A Google pode tratar estes dados de acordo com os Termos de Utilização da API do Google Pay e a Política de Privacidade da Google: ", "googleApiTerms": "Termos de Utilização da API do Google Pay", "googlePrivacy": "Política de Privacidade da Google"},

    // Order Overview page
    orderOverview: {
      seoTitle: "Resumo da encomenda | H2HUMANS",
      seoDescription: "Escolhe o teu módulo de suplemento ou o bundle completo.",
      backToCart: "Voltar ao carrinho",
      orderNow: "Encomendar agora",
      successTitle: "Encomenda concluída!",
      successBody: "Vais receber em breve uma confirmação da encomenda por email.",
      successBack: "Voltar à loja",
      errorNotConfigured: "Os pagamentos ainda não estão configurados para este ambiente.",
      errorItemUnavailable: "Um artigo do carrinho já não está disponível.",
    },

    // Cart drawer
    cart: {
      title: "Carrinho",
      empty: "O teu carrinho está vazio",
      bundleDiscountActive: "Desconto de bundle ativo!",
      youSave: "Poupas",
      total: "Total",
      checkout: "Finalizar compra",
      pricesNote: "Todos os preços incluem IVA.",
      openCart: "Abrir carrinho",
    },

    // Index page SEO
    index: {
      seoTitle: "H2Humans: Apoio para reduzir e parar a injeção para emagrecer",
      seoDescription:
        "Reduzir, pausar ou parar: a H2Humans acompanha-te na fase de transição da terapia GLP-1, com app, suplementos e um guia científico.",
      appDescription:
        "O Protocol Companion inteligente para nutrição, rotinas, suplementos e tracking durante a tua jornada GLP-1.",
      faqSupplementsSafe:
        "Todos os nossos suplementos são fabricados na Alemanha e na Áustria, Lab Tested, GMP Certified, Non-GMO e desenvolvidos com especialistas. Trabalhamos apenas com os mais elevados padrões de qualidade.",
      faqHowPlus1Works:
        "O Teu +1 é uma companhia de IA com recomendações personalizadas. Não substitui terapeuta nem médico, é um coach 24/7 com base puramente científica.",
      faqDoesItWork:
        "Depende de ti. A H2HUMANS funciona melhor quando tomas os suplementos com regularidade, usas a app todos os dias, segues as recomendações do Teu +1 e tens paciência.",
    },

    // Payment Test Mode Banner
    paymentBanner: {
      notConfigured:
        "O checkout de produção não está configurado. Conclui a ativação de pagamentos para aceitar pagamentos reais.",
      testMode: "Todos os pagamentos em pré-visualização estão em modo de teste.",
      readMore: "Saber mais",
    },

    // Info Tooltip
    infoTooltip: {
      ariaLabel: "Mais informação",
      glp1Title: "O que é o GLP-1?",
      glp1Body:
        "Os medicamentos GLP-1 com substâncias ativas como a semaglutida ou a tirzepatida são prescritos por médicos para a redução de peso. Aumentam a sensação de saciedade e regulam o apetite.",
    },

    // Language Picker
    languagePicker: {
      ariaLabel: "Selecionar idioma",
      de: "Deutsch",
      en: "English",
      pt: "Português",
    },

    // Products Section
    products: {
      title: "Três produtos.",
      titleEm: "Um sistema completo.",
      description:
        "Três produtos com proteína, eletrólitos e micronutrientes para a rotina diária.",

      bodycare: {
        category: "Multi-fórmula",
        title: "Daily Body-Care",
        description:
          "Proteína em pó multifuncional com whey, creatina monohidratada, colagénio hidrolisado e L-carnitina. Sabor cacau.",
        shortDescription: "A proteína que contém pode contribuir para a manutenção da massa muscular.",
        pills: ["Músculo e tecidos", "Proteína + Creatina"],
        saleBadge: "Oferta Early Access",
        ingredientsHeading: "Por dose (35 g / 1 colher rasa) · 0 g de açúcar adicionado",
        ingredientsNote: "Misturar 1 colher rasa (35 g) em 300 ml de água ou leite. Sabor cacau.",
        fullIngredientsHeading: "Ingredientes",
        fullIngredients:
          "Proteína de soro de leite biológica, isolado de proteína de soro de leite (emulsionante: lecitinas (girassol)), cacau em pó magro, glicina, creatina monohidratada, hidrolisado de colagénio (bovino), aroma natural de cacau, L-carnitina-L-tartarato, espessante: goma xantana; inulina, extrato de feijão de cacau, Bacillus coagulans, mistura de enzimas (alfa-amilase, protease, lactase, celulase, lipase), cianocobalamina, cloridrato de piridoxina",
        whyTitle:
          "Daily Body-Care combina proteína de soro de leite com creatina, colagénio hidrolisado e outros ingredientes. Os nutrientes presentes podem contribuir para as seguintes funções normais do organismo; seguem-se também informações sobre a composição:",
        whyPoints: [
          "<strong>Colagénio</strong> está presente sob a forma de colagénio hidrolisado e fornece aminoácidos.",
          "<strong>L-carnitina</strong> está presente sob a forma de tartarato de L-carnitina.",
          "<strong>Enzimas e culturas bacterianas</strong> fazem parte da fórmula.",
        ],
        functionHeading: "Função",
        functionPoints: [
          "<strong>Proteína</strong> pode contribuir para a manutenção da massa muscular.",
          "<strong>Creatina</strong> pode contribuir para um melhor desempenho físico em séries sucessivas de exercícios de curta duração e alta intensidade. Uma ingestão diária de 3 g de creatina é um requisito para esta indicação. Esta informação destina-se a adultos que praticam exercício de alta intensidade.",
          "<strong>Vitaminas B6 e B12</strong> podem contribuir para um metabolismo energético normal.",
        ],
        applicationHeading: "Recomendação de utilização",
        applicationText:
          "Recomendamos a toma diária de 35 g de Daily Body-Care em pó. Basta dissolver uma colher medidora em 300 ml de líquido e beber.\n\nA dose diária recomendada indicada não deve ser excedida. Salvo erros e gralhas.",
      },

      balance: {
        category: "Complexo vitamínico",
        title: "Daily Balance",
        description: "Multivitamínico de alta potência com D3, B12, folato, magnésio, zinco e selénio. 30 cápsulas.",
        shortDescription: "Complexo de vitaminas e minerais para a rotina diária.",
        pills: ["Base de micronutrientes", "Vitaminas e minerais"],
        saleBadge: "Oferta Early Access",
        ingredientsHeading: "Por cápsula · dose diária",
        ingredientsNote: "Tomar 1 cápsula por dia com uma refeição.",
        fullIngredientsHeading: "Ingredientes",
        fullIngredients:
          "Bisglicinato de magnésio, vitamina C (ácido L-ascórbico), óxido de magnésio, pó de espirulina, bisglicinato de zinco, vitamina E (acetato de tocoferil D-alfa), nicotinamida, gluconato de manganês, vitamina D3 (colecalciferol, vegano de líquen), pantotenato de cálcio D, molibdato de sódio, vitamina K2 (MK7), borato de sódio (tetraborato de di-sódio), bisglicinato de cobre, vitamina B12 (metilcobalamina), vitamina B2 (riboflavina-5-fosfato), vitamina B1 (tiamina HCl), vitamina B6 (piridoxal-5-fosfato), D-biotina, vitamina A (palmitato de retinila), ácido fólico (Quatrefolic®), picolinato de crómio, iodeto de potássio, selenito de sódio; hidroxipropilmetilcelulose (cápsula)",
        whyTitle:
          "Daily Balance combina vitaminas, minerais e oligoelementos. Os micronutrientes presentes podem contribuir para as seguintes funções normais do organismo:",
        whyPoints: [
          "<strong>Vitaminas B1, B2, B6, B12 e vitamina C</strong> podem contribuir para um <strong>metabolismo energético</strong> normal.",
          "<strong>Vitaminas A, C, D, zinco e selénio</strong> podem contribuir para o funcionamento normal do <strong>sistema imunitário</strong>.",
          "<strong>Vitaminas B1, B2, B6, B12 e magnésio</strong> podem contribuir para o funcionamento normal do <strong>sistema nervoso</strong>.",
          "<strong>Vitaminas C, B2, B6, B12 e folato</strong> podem contribuir para a <strong>redução do cansaço e da fadiga</strong>.",
          "<strong>Vitamina C, vitamina E, zinco e selénio</strong> podem contribuir para a <strong>proteção das células contra o stress oxidativo</strong>.",
          "<strong>Vitaminas D e K</strong> podem contribuir para a manutenção de ossos normais. <strong>Vitamina D</strong> pode contribuir para a manutenção de uma função muscular normal. <strong>Vitamina A</strong> pode contribuir para a manutenção de uma visão normal.",
          "<strong>Folato</strong> pode contribuir para uma formação sanguínea normal. <strong>Vitamina B12</strong> pode contribuir para a formação normal de glóbulos vermelhos. <strong>Folato e vitamina B12</strong> podem contribuir para uma função normal no processo de divisão celular.",
        ],
        applicationHeading: "Recomendação de utilização",
        applicationText:
          "Recomendamos a toma diária de uma cápsula de Daily Balance. Para isso, basta tomar uma cápsula com um copo de líquido.\n\nA quantidade diária recomendada não deve ser ultrapassada. Os suplementos alimentares não substituem uma dieta equilibrada e variada, nem um estilo de vida saudável. Manter fora do alcance das crianças. O produto deve ser armazenado num local fresco e seco. Reservado o direito a erros de impressão e tipográficos.",
      },

      hydration: {
        category: "Fórmula de eletrólitos",
        title: "Daily Hydration",
        description:
          "Fórmula de eletrólitos para uso diário com sódio, cloreto, potássio e magnésio. Sabor citrinos. 30 sticks × 5 g.",
        shortDescription: "Eletrólitos para dias ativos em todas as fases.",
        pills: ["Equilíbrio de fluídos", "Minerais"],
        saleBadge: "Oferta Early Access",
        ingredientsHeading: "Por stick (5 g) · citrinos · sem açúcar adicionado",
        ingredientsNote: "Dissolver 1 stick em 500 ml de água. Beber diariamente ou conforme necessário.",
        fullIngredientsHeading: "Ingredientes",
        fullIngredients:
          "Sal-gema, acidificante (ácido cítrico), citrato tripotássico monohidratado, dicitrato trimagnésio 8,59%, bisglicinato de magnésio, aroma natural, alimento corante (cártamo), edulcorante (glicosídeos de esteviol provenientes de estévia)",
        whyTitle:
          "O sódio, o cloreto, o potássio e o magnésio estão entre os eletrólitos mais importantes do corpo humano. Encontram-se em diversos tecidos e fluídos corporais e são regularmente absorvidos através da alimentação.",
        whyPoints: [
          "<strong>Magnésio</strong> pode contribuir para o <strong>equilíbrio eletrolítico</strong> e para uma <strong>função muscular normal</strong>.",
          "<strong>Magnésio</strong> pode contribuir para o <strong>funcionamento normal do sistema nervoso</strong> e para a <strong>redução do cansaço e da fadiga</strong>.",
          "<strong>Potássio</strong> pode contribuir para uma função muscular normal.",
          "<strong>Potássio</strong> pode contribuir para o funcionamento normal do sistema nervoso.",
        ],
        applicationHeading: "Recomendação de utilização",
        applicationText:
          "Recomendamos a toma diária de um Electrolyte Stick. Este fornece 810 mg de sódio, 1240 mg de cloreto, 300 mg de potássio e 100 mg de magnésio. Dissolver o conteúdo de uma saqueta em água e beber.\n\nA dose diária recomendada indicada não deve ser excedida. Os suplementos alimentares não substituem uma alimentação equilibrada e variada nem um estilo de vida saudável. Manter fora do alcance das crianças. O produto deve ser conservado em local fresco e seco. Salvo erros e gralhas.",
      },

      bundle: {
        badgeValue: "BEST VALUE",

        title: "Daily Routine Komplett-Set",
        description:
          "Três produtos numa caixa: Daily Body-Care, Daily Hydration e Daily Balance.",
        shortDescription: "Três suplementos para a tua rotina diária.",
        pills: [],
        cta: "Adicionar bundle ao carrinho",
        ctaShort: "Adicionar ao carrinho",
        details: {
          intro:
            "Três produtos complementam a tua rotina alimentar diária.",
          contentsHeading: "O que está incluído",
          benefitsHeading: "Os teus benefícios",
          benefits: [
            "Três produtos podem complementar a tua rotina alimentar consciente num só sistema.",
            "O sistema pode complementar a tua ingestão de eletrólitos, vitaminas, minerais e aminoácidos essenciais.",
            "Três momentos fixos para a tua rotina diária.",
          ],
          products: {
            bodycare:
              "Proteína em pó com proteína de soro de leite, creatina, colagénio hidrolisado e outros ingredientes.",
            balance: "Multivitamínico com vitamina D3, B12, folato, magnésio, zinco e selénio.",
            hydration: "Fórmula de eletrólitos com sódio, cloreto, potássio e magnésio.",
          },
        },
      },

      common: {
        details: "Detalhes",
        addToCart: "Adicionar ao carrinho",
        back: "Voltar",
        whyItWorks: "Porque funciona",
        whatsInside: "O que está incluído",
        overview: "Visão geral",
        close: "Fechar",
        bundleUpsellTitle: "O sistema completo",
        bundleUpsellText: "Os três produtos como um sistema: perfeitamente alinhados.",
        bundleUpsellCta: "Adicionar bundle ao carrinho",
        relatedTitle: "Combina com",
        perMonth: "/ mês",
        savePill: "Poupa {amount}",
        routinePill: "Rotina de 30 dias",
        showAllIngredients: "Mostrar todos os ingredientes",
        hideAllIngredients: "Mostrar menos",
        msrpLabel: "PVP",
        zoomIn: "Ampliar",
        zoomOut: "Reduzir",
        zoomReset: "Repor zoom",
        zoomHint: "Tocar para ampliar",
        detailBadges: ["Foco GLP-1", "Rotina de 30 dias", "Desenvolvido com médicos"],
      },
    },

    // Footer
    footer: {
      tagline: "Tornamos o bem-estar pessoal, o teu +1.",
      description: "We make wellbeing personal",
      privacy: "Privacidade",
      imprint: "Impressão legal",
      terms: "Termos",
      privacySettings: "Definições de privacidade",
      productsTitle: "Produtos",
      companyTitle: "Empresa",
      supportTitle: "Apoio",
      aboutUs: "Sobre nós",
      blog: "Guia",
      careers: "Carreiras",
      faq: "FAQ",
      shipping: "Envios",
      returns: "Devoluções",
      privacyPolicy: "Privacidade",
      imprintLink: "Impressão legal",
      termsOfService: "Termos",
      copyright: "© H2HUMANS 2026 · h2humans.com",
      disclaimer:
        "Os suplementos alimentares não substituem uma alimentação variada e equilibrada nem um estilo de vida saudável. A dose diária recomendada indicada não deve ser excedida. Manter fora do alcance das crianças pequenas.",
    },

    // Questionnaire
    questionnaire: {
      progress: "Passo",
      of: "de",
      back: "Voltar",
      next: "Continuar",
      finish: "Concluir e entrar na app",

      phase00: {
        title: "Faz parte desde o início",
        subtitle: "Garante acesso antecipado, sem compromisso e antes do lançamento oficial.",
        email: {
          label: "O teu endereço de email",
          placeholder: "nome@exemplo.pt",
        },
        username: {
          label: "Como te devemos chamar?",
          placeholder: "O teu nome",
        },
      },

      phase01: {
        title: "Verificação rápida de segurança",
        subtitle: "Por favor responde a estas perguntas com honestidade.",
        q1: "Estás atualmente grávida ou a amamentar?",
        q2: "Alguma vez te foi diagnosticada pancreatite ou cancro da tiroide?",
        q3: "Tens uma doença gastrointestinal grave ou diabetes não controlada?",
        yes: "Sim",
        no: "Não",
        exitTitle: "Fala primeiro com o teu médico",
        exitMessage:
          "Recomendamos que procures aconselhamento médico antes de utilizar a H2HUMANS. Estaremos cá quando estiveres pronto.",
        exitButton: "Compreendi",
      },

      phase02: {
        title: "Qual é o teu objetivo?",
        subtitle: "Ajuda-nos a compreender-te melhor.",
        q1: {
          label: "O que queres alcançar com o GLP-1?",
          options: [
            "Reduzir peso",
            "Gerir melhor os efeitos secundários",
            "Manter-me a longo prazo",
            "Mais energia no dia a dia",
            "Estabilidade emocional",
            "Outro",
          ],
        },
        q2: {
          label: "Como te sentes atualmente acompanhado durante a terapia?",
          low: "De modo algum",
          high: "Muito bem",
        },
        q3: {
          label: "O que seria sucesso para ti dentro de 12 semanas?",
          placeholder: "por exemplo, efeitos secundários controlados, mais energia, as minhas rotinas a funcionar",
        },
        reward: {
          title: "Pequenos passos, grande impacto",
          message: "Os estudos mostram que quem recebe acompanhamento mantém-se por mais tempo e obtém resultados claramente melhores.",
        },
      },

      phase03: {
        title: "Conta-nos mais sobre ti",
        subtitle: "",
        section1: {
          title: "Alguns dados básicos",
          age: {
            label: "Idade",
            placeholder: "anos",
          },
          gender: {
            label: "Género",
            options: ["Feminino", "Masculino", "Não binário", "Prefiro não dizer"],
          },
          weight: {
            label: "Peso atual",
            placeholder: "kg",
          },
        },
        section2: {
          title: "A tua experiência com o GLP-1",
          glp1Status: {
            label: "Estás atualmente a usar um GLP-1?",
            options: ["Sim", "Não"],
          },
          brand: {
            label: "Qual produto estás a usar?",
            options: ["Ozempic", "Wegovy", "Mounjaro", "Outro", "Não tenho a certeza"],
          },
          therapyWeek: {
            label: "Em que semana da terapia estás?",
            start: "0",
            end: "12+",
          },
          endReason: {
            label: "Porque paraste?",
            options: ["Concluído com sucesso", "Interrompido"],
          },
          abortReasons: {
            label: "Quais foram as razões?",
            hint: "Seleção múltipla possível",
            options: [
              "Efeitos secundários",
              "Custo",
              "Falta de resultados",
              "Não se adequava ao meu dia a dia",
              "Outro",
            ],
          },
          pastBrand: {
            label: "Qual produto usaste?",
            options: ["Ozempic", "Wegovy", "Mounjaro", "Outro", "Não tenho a certeza"],
          },
          startPlan: {
            label: "Planeias usar um GLP-1?",
            options: ["Não", "Em 1 a 4 semanas", "Em 4 a 8 semanas", "Em mais de 8 semanas"],
          },
        },
      },

      phase04: {
        title: "Quase lá.",
        subtitle: "Avisamos-te assim que o Teu +1 estiver pronto para ti.",
        privacyConsent:
          "Li e aceito as condições de Acesso Antecipado. Tomei conhecimento da política de privacidade.",
        privacyLink: "Política de Privacidade",
        marketing:
          "Sim, quero receber informações, atualizações e ofertas da H2HUMANS por email. Posso retirar o meu consentimento a qualquer momento com efeito para o futuro (por exemplo, através do link de cancelamento em cada email ou contactando info@h2humans.com). Encontras mais informação sobre o tratamento dos teus dados na nossa política de privacidade.",
        required: "Campo obrigatório",
        trustMicrocopy: "Sem partilha com terceiros. Sem spam.",
        cta: "Reservar o meu lugar, gratuitamente",
      },

      complete: {
        title: "Estás dentro!",
        message:
          "Estás na lista de espera do Teu +1. O que acontece agora: vamos partilhar atualizações exclusivas, conteúdos de bastidores e o teu convite pessoal para o primeiro grupo de utilizadores.",
        button: "Voltar à página inicial",
      },
    },

    // Checkout
    checkout: {
      title: "Encomenda",
      backToShop: "Voltar à loja",
      step: "Passo",
      of: "de",

      identification: {
        title: "Identificação",
        subtitle: "Indica os teus dados de contacto",
        email: { label: "Endereço de email", placeholder: "nome@exemplo.pt", error: "Indica um email válido" },
        firstName: { label: "Nome", placeholder: "João", error: "O nome é obrigatório" },
        lastName: { label: "Apelido", placeholder: "Silva", error: "O apelido é obrigatório" },
        phone: { label: "Telefone (opcional)", placeholder: "+351 912 345 678" },
      },

      delivery: {
        title: "Entrega",
        subtitle: "Escolhe o método de envio e a morada",
        address: {
          label: "Morada de entrega",
          street: "Rua e número",
          streetPlaceholder: "Rua Principal 42",
          streetError: "A rua é obrigatória",
          zip: "Código postal",
          zipPlaceholder: "1000",
          zipError: "Código postal válido obrigatório",
          city: "Cidade",
          cityPlaceholder: "Lisboa",
          cityError: "A cidade é obrigatória",
          country: "País",
          countryOptions: ["Alemanha", "Áustria", "Suíça"],
        },
      },

      payment: {
        title: "Pagamento",
        subtitle: "Método de pagamento e código promocional",
        method: {
          label: "Método de pagamento",
          notConfigured: "Provedor de pagamento em preparação",
          comingSoon: "Disponível em breve",
        },
        promoCode: {
          label: "Código promocional",
          placeholder: "Inserir código",
          apply: "Aplicar",
          remove: "Remover",
          applied: "Desconto ativado",
          freeShipping: "Envio grátis",
          invalid: "Código promocional inválido",
        },
        summary: {
          subtotal: "Subtotal",
          bundleDiscount: "Desconto de bundle",
          promoDiscount: "Código promocional",
          shipping: "Envio",
          shippingFree: "Grátis",
          total: "Total",
        },
        cta: "Encomendar agora com obrigação de pagamento",
      },
    },

    knowledge: {
      prevArticle: "Artigo anterior",
      nextArticle: "Próximo artigo",
      goToArticle: "Artigo {n} de {total}",
      title: "Conhecimento que te",
      titleEm: "acompanha",
      titleAfter: ".",
      subtitle: "Com base científica: sobre GLP-1, nutrição e o caminho depois.",
      sourcesNote: "Trabalhamos com mais de 100 fontes científicas.",
      homeKicker: "Guia",
      homeTitle: "O que a investigação sobre GLP-1 realmente diz.",
      homeAllArticles: "Todos os artigos",
      homeTopicsLabel: "Temas do guia",
      homeTrustHundred: "Mais de 100 fontes científicas",
      homeTrustSources: "Cada artigo com fontes científicas",
      homeTrustWeekly: "Novos estudos todas as semanas",
      viewAll: "Ver o guia",
      related: "Leitura relacionada",
      phaseLink: "{count} artigos sobre esta fase",
      phaseLinkOne: "1 artigo sobre esta fase",
      categoryCount: "{count} artigos",
      categoryCountOne: "1 artigo",
      germanOnly: "Artigo em alemão",
      listLabel: "Artigos de conhecimento",
    },
    journey: {
      v2: {
        eyebrow: 'Para que serve a H2Humans',
        title1: 'Outros acompanham o início.',
        title2: 'Nós acompanhamos a transição.',
        intro: 'Com a injeção para emagrecer, o teu corpo está em mudança, antes, durante e depois da terapia. A transição decide o que manténs. É exatamente para isso que a H2Humans foi criada.',
        transitionLabel: 'A transição',
        steps: [
          { num: '01 · Antes da injeção', title: 'Começar bem preparado', text: 'Expectativas realistas e primeiras rotinas, antes de tudo mudar.' },
          { num: '02 · Com a injeção', title: 'Manter a força em vista', text: 'Proteína, movimento e rotinas fixas enquanto o apetite está calmo.' },
          { num: '03 · Depois da injeção', title: 'Manter o que alcançaste', text: 'Acompanhamento ao parar e depois. Sem pressão, sem vergonha.' },
        ],
        cardTitle: 'Cada mudança é uma transição.',
        cardText: 'A H2Humans acompanha-te em todas as direções, todos os dias, com a app, conhecimento e produtos ajustados. Sempre em consulta com a tua médica ou o teu médico.',
        cta: 'Experimentar a app grátis',
      },
      eyebrow: "O CAMINHO COMPLETO",
      title: "Não apenas a terapia.",
      titleEm: "O caminho completo.",
      subtitle: "**Muitas pessoas vivem uma fase de transição difícil depois de parar.**\nFoi exatamente para este momento que a H2Humans foi criada.",
      transitionLabel: "Fase de transição",
      pathTitle: "Três fases. Uma",
      pathTitleEm: "transição",
      changes: ["Ajustar a dose", "Alargar intervalos", "Pausar", "Recomeçar", "Parar"],
      guideHint: "É aqui que te acompanhamos.",
      explTitle: "A",
      explText: "Cada mudança na tua terapia traz perguntas sobre o corpo, a fome e as rotinas. Acompanhamos-te em qualquer direção, em articulação com o teu médico ou a tua médica.",
      articlesLink: "{count} artigos sobre a fase de transição no guia",
      articlesLinkOne: "1 artigo sobre a fase de transição no guia",
      pathAlt: "Um caminho em três fases: Pre GLP-1, On GLP-1 e Post GLP-1: que oscila numa fase de transição desde o meio da fase ativa até à manutenção: ajustar a dose, alargar intervalos, pausar, recomeçar ou parar.",
      phaseSubs: ["Preparação", "Fase ativa", "Manutenção"],
      transitionText: "Cada mudança na tua terapia: ajustar a dose, alargar intervalos, pausar, recomeçar ou parar. Acompanhamos-te em qualquer direção, em articulação com o teu médico ou a tua médica.",
      bothWays: "Movimento possível em ambas as direções.",
      source: "Fonte: Budini, Luo et al., eClinicalMedicine 2026.",
      disclaimer: "Representação esquemática, sem promessa de resultados.",
      more: "Saber mais",
      less: "Mostrar menos",
      labels: {
        happens: "O que acontece",
        challenge: "Maior desafio",
        h2h: "O que a H2Humans oferece",
      },
      phases: [
        {
          tag: "Fase 1",
          name: "Pré GLP-1",
          timing: "Antes de iniciar a terapia",
          happens: "A decisão é tomada: financeira, mental e praticamente. Raramente ao mesmo ritmo.",
          challenge: "“Readiness mismatch”: orçamento, mudança de comportamento e compromisso não estão sincronizados.",
          h2h: "Expectativas honestas em vez de promessas milagrosas: preparação para todo o caminho, não só o início.",
        },
        {
          tag: "Fase 2",
          name: "Em GLP-1",
          timing: "Tratamento ativo: meses a anos",
          happens: "Mudança substancial. A janela mais fácil para novos hábitos fecha cedo (dia 10–21).",
          challenge: "A perda muscular é real. Cerca de dois terços param no primeiro ano. O ciclo é a norma.",
          h2h: "Orientação de proteína e treino segundo consenso Delphi e acompanhamento além da janela do fármaco.",
        },
        {
          tag: "Fase 3",
          name: "Fase de transição",
          timing: "Redução de dose, paragem ou pausa",
          happens: "Os sistemas do corpo não reiniciam em sincronia: metabolismo, relação massa gorda/muscular e bem-estar mudam a ritmos diferentes.",
          challenge: "O ponto cego do setor: redução de dose e acompanhamento a longo prazo quase não são estudados.",
          h2h: "É exatamente aqui que a H2Humans entra: acompanhamento diário, não só durante a injeção.",
        },
        {
          tag: "Fase 4",
          name: "Pós GLP-1",
          timing: "Novo equilíbrio: meses a anos depois",
          happens: "75 % voltam a ganhar peso num ano: tendências reais, não manchetes de ensaios clínicos.",
          challenge: "“Identity lag” no plateau de manutenção: ainda não nos sentimos a nova versão de nós próprios.",
          h2h: "Apoio de controlo de rebound e um verdadeiro fluxo de “welcome back” em vez de narrativa de vergonha.",
        },
      ],
    },

    comparison: {
      eyebrow: "",
      title: "Multiformulação em vez de multi-compra.",
      titleEm: "",
      subtitle: "30 doses, 7 componentes, 1 produto.",
      productLabel: "Daily Body-Care · 1000 g",
      columns: {
        component: "Componente",
        benefit: "Quantidade por dose",
        competitor: "Marcas líderes*",
        competitorSub: "(30 dias, proporcional)",
        h2: "H2Humans",
        h2Sub: "Daily Body-Care",
      },
      rows: [
        { name: "Whey Protein Isolate", benefit: "22,4 g de proteína", competitor: "~50 €" },
        { name: "Peptídeos de Colagénio", benefit: "3.000 mg", competitor: "~40 €" },
        { name: "Creatina Monohidratada", benefit: "3.000 mg", competitor: "~6 €" },
        { name: "L-Carnitina Tartarato", benefit: "500 mg", competitor: "~5 €" },
        { name: "Extrato de Polifenóis de Cacau", benefit: "250 mg", competitor: "~12 €" },
        { name: "Bacillus Coagulans", benefit: "2 mil milhões UFC", competitor: "~10 €" },
        { name: "Vitamina B6 + B12", benefit: "1,4 mg · 2,89 µg", competitor: "~5 €" },
      ],
      includedLabel: "Incluído",
      totalLabel: "Total concorrência",
      totalValue: "~128 €",
      h2Price: "69,90 €",
      savingsLabel: "A tua poupança mensal com Daily Body-Care",
      savingsValue: "~58 €",
      savingsNote: "Sete componentes num só produto, sem sete doses separadas.",
      imageAlt: "Daily Body-Care em pó numa colher doseadora",
      singleLabel: "Avulso",
      cta: "Ver Daily Body-Care na loja",
      footnote: "* Comparação baseada em preços de mercado online de 2026 de marcas premium da UE. Preços proporcionalmente convertidos para 30 doses diárias (preço ÷ doses × 30).",
    },

    foundingMembers: {
      title: "Os nossos Founding Members.",
      body: "Trabalhamos com pessoas que partilham a sua jornada GLP-1 de forma honesta com a sua comunidade, com sucessos reais, recuos reais e sem filtros.",
      productBody: "Trabalhamos com pessoas que partilham honestamente o seu dia a dia e as suas rotinas com a comunidade.",
      productRoles: ["HYROX & rotinas diárias", "Preparação para HYROX", "Treino de força & longas caminhadas"],
      badge: "Founding Member",
      showCard: "Mostrar cartão",
      prevCard: "Cartão anterior",
      nextCard: "Próximo cartão",
      backCta: "Voltar",
      campaignBadge: "CAMPANHA BE ACTIVE!",
      hyroxStoryCta: "Ver a história HYROX",
      cards: [
        {
          emoji: "✦",
          name: "Angelika",
          role: "Founding Member",
          subtitle: ["GLP-1 & HYROX", "@piks_zu_mir"],
          facts: ["GLP-1 & HYROX", "2× HYROX Finisher"],
          quote: "\"Não acredito em milagres. Acredito em sistemas, rotinas e acompanhamento honesto. Por isso sou Founding Member da H2Humans.\"",
          cta: "Saber mais",
          frontOnly: false,
          profileLabel: "Perfil",
          instagramUrl: "https://www.instagram.com/piks_zu_mir/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "1,4K seguidores",
          front: "\"Não acredito em milagres. Acredito em sistemas, rotinas e acompanhamento honesto. Por isso sou Founding Member da H2Humans.\"",
          paragraphs: [
            "O que aprendi na minha jornada GLP-1: A injeção não faz o trabalho por ti. Cria a oportunidade de construir novos hábitos.",
            "É exactamente por isso que me identifico com a H2Humans. O que me convence não é a promessa de uma cura milagrosa, mas a abordagem de acompanhar as pessoas a longo prazo com conhecimento, rotinas e produtos coordenados de forma sensata.",
            "Na minha conta Instagram, partilho honestamente a minha jornada, com sucessos, contratempos e tudo o que está pelo meio. O meu objetivo é encorajar as pessoas e mostrar que a mudança não tem de ser perfeita, mas sim sustentável.",
          ],
          tags: ["GLP-1", "HYROX", "Founding Member"],
        },
        {
          emoji: "✦",
          name: "Nicole",
          role: "Founding Member",
          subtitle: ["GLP-1 & lipedema", "@abnehmspritze_mit_lipoodem"],
          facts: ["GLP-1 & lipedema", "Preparação HYROX"],
          quote: "\"Nada de 'rápido-rápido', nada de comparações. A saúde é o mais importante que temos. Trata-se de compreender o próprio corpo e fortalecê-lo passo a passo.\"",
          cta: "Saber mais",
          frontOnly: false,
          profileLabel: "Perfil",
          instagramUrl: "https://www.instagram.com/abnehmspritze_mit_lipoedem/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "1,3K seguidores",
          front: "\"Nada de 'rápido-rápido', nada de comparações. A saúde é o mais importante que temos. Trata-se de compreender o próprio corpo e fortalecê-lo passo a passo.\"",
          paragraphs: [
            "O meu caminho é deliberadamente lento, controlado e constante, porque uma coisa é mais importante para mim: a minha saúde. O que aprendi? Perder peso não significa atingir o peso-alvo o mais rapidamente possível ou comparar-me com os outros. Trata-se de voltar a conhecer o próprio corpo e fortalecê-lo de forma sustentável.",
            "É exactamente por isso que me identifico com a H2Humans. O que me convence é o sistema holístico: Com apenas três produtos coordenados, o corpo é optimamente suprido, sem horas de pesquisa ou pensamento complicado. Adapta-se simples e rapidamente ao dia a dia.",
            "Na minha conta Instagram, levo a minha comunidade comigo de forma honesta e sem filtros. Partilho insights de antes e depois, dicas práticas de alimentação, a minha preparação para o próximo HYROX e todos os altos e baixos. O meu objetivo é mostrar que a saúde é o bem mais importante que temos e que o caminho até lá pode ser divertido.",
          ],
          tags: ["GLP-1", "lipedema", "Founding Member"],
        },
        {
          emoji: "✦",
          name: "Sandra",
          role: "Founding Member",
          subtitle: ["GLP-1 & perimenopausa", "@sonnen.bunt"],
          facts: ["GLP-1 & perimenopausa", "Musculação & longas caminhadas"],
          quote: "\"Já tinha anos de dietas, e com a menopausa deixou de resultar. Com o GLP-1 voltou a funcionar e criei rotinas sustentáveis. A H2Humans vê a pessoa por trás dos produtos.\"",
          cta: "Saber mais",
          frontOnly: false,
          profileLabel: "Perfil",
          instagramUrl: "https://www.instagram.com/sonnen.bunt/",
          brandLabel: "H2Humans",
          brandInstagramUrl: "https://www.instagram.com/_h2humans_/",
          followers: "3,5K seguidores",
          front: "\"Já tinha anos suficientes de dietas. Mas com o início da menopausa deixei de conseguir perder peso. Com o GLP-1 voltou finalmente a resultar.\"",
          paragraphs: [
            "Desde o início da minha jornada GLP-1, muita coisa mudou para mim.",
            "Não uso GLP-1 porque pensasse que alguém faria o trabalho por mim. Uso porque me ajuda a silenciar algo que antes me acompanhava constantemente: o food noise. E, sinceramente? Antes pensava que era assim para toda a gente.",
            "O treino de força, por outro lado, acompanha-me há muitos anos e é uma parte importante da minha jornada, sobretudo nesta fase de mudança hormonal e na menopausa. Para mim, mudança não significa apenas menos peso, mas sobretudo: ficar mais forte, manter músculo e sentir-me bem no meu corpo.",
            "É exactamente por isso que acho o conceito da H2Humans tão interessante. Sem procurar suplementos ao acaso e sem a eterna pergunta: do que preciso realmente? Em vez disso, um conceito bem pensado com produtos coordenados que me apoiam exactamente onde estou.",
            "Porque a vida já é suficientemente complicada: a procura dos suplementos certos não precisa de ser também.",
          ],
          tags: ["GLP-1", "perimenopausa", "Founding Member"],
        },
      ],
    },
    // Blog
    about: {
      seoTitle: "Sobre nós | H2HUMANS",
      seoDescription: "A história por trás da H2HUMANS e aquilo que defendemos: as pessoas, a atitude e os valores por trás do H2HUMANS System.",
      blogTitle: "Mais conhecimento no Guia.",
      blogBody: "Artigos fundamentados cientificamente sobre GLP-1, alimentação e o caminho depois.",
      blogCta: "Ir para o Guia",
    },
    blog: {
      title: "H2Humans Guia",
      titleBefore: "O ",
      titleEm: "Guia",
      titleAfter: " H2Humans.",
      metaTitle: "Guia H2Humans: GLP-1, interrupção e nutrição",
      metaDescription: "Artigos com base científica sobre GLP-1, a interrupção da injeção para emagrecer, nutrição e o caminho depois.",
      intro: "Com base científica. Explicado com clareza. Sobre GLP-1, nutrição e o caminho depois.",
      pageTitleSuffix: " | H2Humans Guia",
      categoryKicker: "Guia · {category}",
      featured: "Artigo mais recente",
      aiImageLabel: "Imagem gerada por IA",
      aiImageMark: "IA",
      allCategories: "Todos os temas",
      articleCount: "{count} artigos",
      articleCountOne: "1 artigo",
      allPosts: "Todos os artigos",
      backToBlog: "Voltar a todos os artigos",
      readTime: "aprox. {min} min de leitura",
      readTimeShort: "{min} min de leitura",
      readMoreLink: "Ler mais",
      readArticle: "Ler artigo",
      readTimeCompact: "{min} min",
      heroKicker: "Guia",
      heroTitle: "Respostas sobre GLP-1. Baseadas em evidência, com fontes.",
      searchLabel: "Pesquisar no guia",
      searchPlaceholder: "O que procuras? ex. parar, massa muscular, food noise",
      searchClear: "Limpar pesquisa",
      searchResults: "{count} artigos sobre “{query}”.",
      searchResultsOne: "1 artigo sobre “{query}”.",
      searchNone: "Nenhum artigo encontrado. Tenta outro termo.",
      trustSources: "Cada artigo com fontes científicas",
      trustWeekly: "Novos estudos explicados todas as semanas",
      trustOrientation: "Sem recomendação terapêutica, apenas orientação",
      newThisWeek: "Novo esta semana.",
      topicsHeading: "Temas.",
      topicCount: "{count} artigos",
      topicCountOne: "1 artigo",
      allArticles: "Todos os artigos.",
      filterLabel: "Filtrar por tema",
      filterAll: "Todos",
      mostRead: "Mais lidos.",
      bandTitle: "Novos estudos, explicados com clareza. Todas as quintas-feiras.",
      bandHint: "15 % na tua primeira encomenda.",
      loadMore: "Carregar mais",
      sourcesCount: "Com {count} fontes científicas",
      sourcesCountOne: "Com 1 fonte científica",
      sourcesToggle: "Fontes ({count})",
      noTherapy: "Não substituímos tratamento médico e não damos recomendações terapêuticas.",
      continueReading: "Continuar a ler.",
      readingProgress: "Progresso de leitura",
      topics: {
        transition: { short: "Parar", description: "O que acontece depois de parar." },
        "food-noise-psychologie": { short: "Psicologia", description: "Compreender fome, apetite e mente." },
        wissenschaft: { short: "Estudos", description: "Novos estudos explicados com clareza." },
        ernaehrung: { short: "Nutrição", description: "Alimentação e rotinas para todos os dias." },
        community: { short: "Comunidade", description: "Experiências de pessoas como tu." },
        klinik: { short: "Clínica", description: "Enquadramento para prática e clínica." },
      } as Record<string, { short: string; description: string }>,
      ratingNone: "Ainda sem avaliações",
      ratingSummary: "{avg} de 5 · {count} avaliações",
      ratingSummaryOne: "{avg} de 5 · 1 avaliação",
      rateTitle: "Quão útil foi este artigo?",
      rateHint: "Avalie de 1 a 5 estrelas.",
      rateStar: "{n} de 5 estrelas",
      rateThanks: "Obrigado pela sua avaliação.",
      rateError: "Não foi possível guardar a avaliação. Tente novamente.",
      sortLabel: "Ordenar por",
      sortNewest: "Mais recentes",
      sortTopRated: "Melhor avaliados",
      publishedShort: "Publicado em {date}",
      publishedOn: "Publicado a {date}",
      updatedOn: "Atualizado a {date}",
      author: "Redação H2Humans",
      toc: "Índice",
      sources: "Fontes",
      faqHeading: "Perguntas frequentes",
      related: "Artigos relacionados",
      disclaimer: "Este artigo baseia-se exclusivamente em fontes científicas de acesso público, listadas de forma completa e transparente acima.",
      empty: "Ainda não existem artigos publicados aqui.",
      loading: "A carregar artigos...",
      ctaTitle: "Fica a par.",
      ctaBody: "15% na tua primeira encomenda: além de novos artigos e investigação sobre GLP-1 no teu email.",
      ctaCompact: "15% na tua primeira encomenda: diretamente no teu email.",
      previewBanner: "Pré-visualização: este artigo ainda não foi publicado.",
      onlyGermanNotice: "Este artigo está disponível apenas em alemão por enquanto.",
      breadcrumb: "Breadcrumb",
      breadcrumbHome: "Guia",
      lastUpdated: "Última atualização a {date}",
      backToBlogButton: "Voltar",
      toShop: "Ir para a loja",
      productsTitle: "Os nossos produtos.",
      productsBody: "O H2HUMANS System: suplementos desenvolvidos cientificamente para o teu dia a dia.",
      productsCta: "Ver na loja",
      productsPrev: "Produto anterior",
      productsNext: "Próximo produto",
      postsPrev: "Artigo anterior",
      postsNext: "Próximo artigo",
      communityTitle: "Faz parte da comunidade.",
      communityBody: "Impulsos diários, experiências e respostas sobre GLP-1: segue-nos no Instagram.",
      communityCta: "Seguir no Instagram",
      comingSoonTitle: "Coming soon.",
      comingSoonBody: "Esta categoria arranca em breve. Os primeiros artigos já estão a ser preparados.",
      comingSoonClose: "Fechar",
    },
    // Admin
    admin: {
      metaTitle: "Redação | H2Humans",
      brand: "Redação H2Humans",
      logout: "Terminar sessão",
      login: {
        heading: "Redação",
        subtitle: "Inicia sessão com a tua conta de redação.",
        email: "Email",
        password: "Palavra-passe",
        submit: "Entrar",
        loading: "A iniciar sessão...",
        error: "Falha ao iniciar sessão. Verifica os teus dados.",
      },
      list: {
        heading: "Artigos do blog",
        newPost: "Novo artigo",
        empty: "Ainda não existem artigos.",
        loading: "A carregar artigos...",
        colTitle: "Título",
        colCategory: "Categoria",
        colStatus: "Estado",
        colUpdated: "Última alteração",
        sortBy: "Ordenar por",
        sortDate: "Data",
        sortStatus: "Estado",
        noCategory: "—",
        analytics: "Estatísticas",
      },
      analytics: {
        heading: "Estatísticas do blog",
        backToList: "Voltar à lista",
        period: "Período",
        periodDays: "Últimos {days} dias",
        period6m: "Últimos 6 meses",
        loading: "A carregar estatísticas...",
        error: "Não foi possível carregar as estatísticas.",
        empty: "Ainda sem dados neste período.",
        visitors: "Visitantes",
        pageViews: "Visualizações",
        totalTime: "Tempo total de leitura",
        avgTime: "Tempo médio de leitura",
        dailyHeading: "Evolução diária",
        categoriesHeading: "Categorias",
        postsHeading: "Artigos",
        visitorsShort: "visitantes",
        viewsShort: "visualizações",
      },
      status: {
        draft: "Rascunho",
        published: "Publicado",
        archived: "Arquivado",
      },
      form: {
        newHeading: "Novo artigo",
        editHeading: "Editar artigo",
        back: "Voltar à lista",
        title: "Título",
        slug: "Slug",
        slugHint: "Gerado a partir do título, pode ser alterado.",
        category: "Categoria",
        categoryNone: "Sem categoria",
        language: "Idioma",
        translationOf: "Tradução de …",
        translationOfNone: "Artigo autónomo (novo grupo de tradução)",
        translationOfHint: "Escolhe um artigo existente se este for a sua tradução.",
        metaDescription: "Meta description",
        metaCounter: "{count}/160 caracteres",
        metaWarning: "Mais de 160 caracteres. Os motores de busca vão cortar o texto.",
        excerpt: "Excerto",
        content: "Conteúdo (Markdown)",
        previewTab: "Pré-visualização",
        sources: "Fontes",
        sourceText: "Fonte",
        sourceUrl: "URL (opcional)",
        addSource: "Adicionar fonte",
        removeSource: "Remover fonte",
        faq: "Perguntas frequentes (opcional)",
        faqHint: "Apenas entradas preenchidas aparecem na página e no schema FAQ.",
        faqQuestion: "Pergunta",
        faqAnswer: "Resposta",
        addFaq: "Adicionar pergunta",
        removeFaq: "Remover pergunta",
        ogImage: "URL da imagem de capa (opcional)",
        ogImageHint: "Imagem temática fotorrealista em formato horizontal (mínimo 1200 × 675 px). Deixe vazio: após a publicação é criada automaticamente uma imagem de capa. O motivo principal deve permanecer totalmente visível no recorte móvel.",
        ogImageRequired: "Adicione uma imagem de capa antes de publicar o artigo.",
        status: "Estado",
        save: "Guardar",
        saving: "A guardar...",
        saved: "Guardado.",
        saveError: "Falha ao guardar.",
        previewLink: "Abrir pré-visualização",
        unsaved: "Alterações não guardadas",
        llmsNotice: "Depois de publicar um novo artigo, o ficheiro public/llms.txt tem de ser atualizado manualmente.",
        altWarning: "Nota: {count} imagem(ns) no conteúdo não têm texto alternativo.",
        leaveConfirm: "Existem alterações não guardadas. Sair mesmo assim?",
        requiredMissing: "Título, slug e meta description são obrigatórios.",
      },
    },
  },
} as const;

export type Translations = typeof translations.de;
